// // src/components/AddUpcomingProjectPopup.jsx
// import React, { useState, useRef, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import { Calendar as CalendarIcon, ChevronLeft, ChevronRight } from "lucide-react";
// import { useProperty } from "./PropertyContext";
// import { sellerPropertiesAPI, authAPI, sellerDashboardAPI, sellerProfileAPI } from "../../services/api.service";
// import { API_BASE_URL, API_ENDPOINTS } from "../../config/api.config";
// import { validateImageFile } from "../../utils/validation";
// import {
//   collectAmenityLabels,
//   generateUpcomingProjectDescription,
// } from "../../utils/generatePropertyDescription";
// import {
//   buildBrochureFromUrl,
//   createExistingImageValidationStatus,
//   isBlobUrl,
//   resolvePropertyImageUrls,
// } from "../../utils/propertyMedia";
// import LocationPicker from "../../components/Map/LocationPicker";
// import LocationAutoSuggest from "../../components/LocationAutoSuggest/LocationAutoSuggest";
// import "../styles/AddPropertyPopup.css";

// const FREE_LISTING_SLOTS = 1;

// const hasActiveFreeTrial = (subscription, user) => {
//   const source = String(subscription?.source || '').toLowerCase();
//   const expiryRaw = subscription?.end_date || subscription?.nearest_expiry;
//   const expiryDate = expiryRaw ? new Date(expiryRaw) : null;
//   const isSubscriptionTrialActive =
//     expiryDate &&
//     !Number.isNaN(expiryDate.getTime()) &&
//     expiryDate.getTime() > Date.now() &&
//     source !== 'paid_plan';

//   if (isSubscriptionTrialActive) {
//     return true;
//   }

//   const createdAtRaw = user?.created_at || user?.createdAt;
//   if (!createdAtRaw) {
//     return false;
//   }

//   const createdAt = new Date(createdAtRaw);
//   if (Number.isNaN(createdAt.getTime())) {
//     return false;
//   }

//   const trialEndsAt = createdAt.getTime() + (30 * 24 * 60 * 60 * 1000);
//   return Date.now() < trialEndsAt;
// };

// const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// function ModernDatePicker({ value, onChange, placeholder = "Select date", id, onOpenChange }) {
//   const [open, setOpen] = useState(false);
//   const [viewDate, setViewDate] = useState(() => {
//     if (value) {
//       const [y, m] = value.split("-").map(Number);
//       return new Date(y, m - 1, 1);
//     }
//     return new Date();
//   });
//   const containerRef = useRef(null);

//   useEffect(() => {
//     if (value) {
//       const [y, m] = value.split("-").map(Number);
//       setViewDate(new Date(y, m - 1, 1));
//     }
//   }, [value]);

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (containerRef.current && !containerRef.current.contains(e.target)) setOpen(false);
//     };
//     if (open) {
//       document.addEventListener("mousedown", handleClickOutside);
//       return () => document.removeEventListener("mousedown", handleClickOutside);
//     }
//   }, [open]);

//   useEffect(() => {
//     if (onOpenChange) {
//       onOpenChange(open);
//     }
//   }, [open, onOpenChange]);

//   const formatDisplay = (val) => {
//     if (!val) return "";
//     const [y, m, d] = val.split("-").map(Number);
//     return `${d} ${MONTHS[m - 1]} ${y}`;
//   };

//   const toYYYYMMDD = (d) => {
//     const y = d.getFullYear();
//     const m = String(d.getMonth() + 1).padStart(2, "0");
//     const day = String(d.getDate()).padStart(2, "0");
//     return `${y}-${m}-${day}`;
//   };

//   const year = viewDate.getFullYear();
//   const month = viewDate.getMonth();
//   const firstDay = new Date(year, month, 1);
//   const lastDay = new Date(year, month + 1, 0);
//   const startPad = firstDay.getDay();
//   const daysInMonth = lastDay.getDate();
//   const days = [];
//   for (let i = 0; i < startPad; i++) days.push(null);
//   for (let d = 1; d <= daysInMonth; d++) days.push(d);

//   const handleSelect = (d) => {
//     if (!d) return;
//     const date = new Date(year, month, d);
//     onChange(toYYYYMMDD(date));
//     setOpen(false);
//   };

//   const prevMonth = () => setViewDate(new Date(year, month - 1, 1));
//   const nextMonth = () => setViewDate(new Date(year, month + 1, 1));
//   const handleYearChange = (e) => setViewDate(new Date(parseInt(e.target.value), month, 1));
//   const handleMonthChange = (e) => setViewDate(new Date(year, parseInt(e.target.value), 1));
//   const selectToday = () => {
//     onChange(toYYYYMMDD(new Date()));
//     setOpen(false);
//   };

//   const selectedYMD = value ? value.split("-").map(Number) : null;

//   return (
//     <div className="modern-date-picker" ref={containerRef}>
//       <button
//         type="button"
//         className="modern-date-picker-input"
//         onClick={() => setOpen((o) => !o)}
//         aria-haspopup="dialog"
//         aria-expanded={open}
//         aria-label={placeholder}
//         id={id}
//       >
//         <CalendarIcon size={18} className="modern-date-picker-icon" />
//         <span className={value ? "" : "modern-date-picker-placeholder"}>
//           {value ? formatDisplay(value) : placeholder}
//         </span>
//       </button>
//       {open && (
//         <div className="modern-date-picker-dropdown" role="dialog" aria-modal="true">
//           <div className="modern-date-picker-header">
//             <button type="button" className="modern-date-picker-nav" onClick={prevMonth} aria-label="Previous month">
//               <ChevronLeft size={18} />
//             </button>
//             <div className="modern-date-picker-selectors">
//               <select
//                 className="modern-date-picker-select"
//                 value={month}
//                 onChange={handleMonthChange}
//               >
//                 {MONTHS.map((m, i) => (
//                   <option key={m} value={i}>{m}</option>
//                 ))}
//               </select>
//               <select
//                 className="modern-date-picker-select"
//                 value={year}
//                 onChange={handleYearChange}
//               >
//                 {Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - 3 + i).map(y => (
//                   <option key={y} value={y}>{y}</option>
//                 ))}
//               </select>
//             </div>
//             <button type="button" className="modern-date-picker-nav" onClick={nextMonth} aria-label="Next month">
//               <ChevronRight size={18} />
//             </button>
//           </div>
//           <div className="modern-date-picker-weekdays">
//             {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((w) => (
//               <span key={w} className="modern-date-picker-weekday">{w}</span>
//             ))}
//           </div>
//           <div className="modern-date-picker-grid">
//             {days.map((d, i) => {
//               const isSelected = selectedYMD && selectedYMD[0] === year && selectedYMD[1] === month + 1 && selectedYMD[2] === d;
//               const isToday = (() => {
//                 const t = new Date();
//                 return d && t.getFullYear() === year && t.getMonth() === month && t.getDate() === d;
//               })();
//               return (
//                 <button
//                   key={i}
//                   type="button"
//                   className={`modern-date-picker-day ${!d ? "empty" : ""} ${isSelected ? "selected" : ""} ${isToday ? "today" : ""}`}
//                   onClick={() => handleSelect(d)}
//                   disabled={!d}
//                 >
//                   {d || ""}
//                 </button>
//               );
//             })}
//           </div>
//           <div className="modern-date-picker-footer">
//             <button type="button" className="modern-date-picker-today" onClick={selectToday}>
//               Today
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// const STEPS = [
//   { id: 1, title: "Basic Details", icon: "📝" },
//   { id: 2, title: "Location", icon: "📍" },
//   { id: 3, title: "Configuration", icon: "🏗️" },
//   { id: 4, title: "Pricing & Amenities", icon: "💰" },
//   { id: 5, title: "Media & Contact", icon: "📷" }
// ];

// // Same property types as in property form (Seller AddPropertyPopup) for consistency
// const PROJECT_TYPES = [
//   { value: "Apartment", icon: "🏢" },
//   { value: "Villa / Banglow", icon: "🏡" },
//   { value: "Independent House", icon: "🏘️" },
//   { value: "Row House/ Farm House", icon: "🏘️" },
//   { value: "Penthouse", icon: "🌆" },
//   { value: "Studio Apartment", icon: "🛏️" },
//   { value: "Plot / Land / Indusrtial Property", icon: "📐" },
//   { value: "Commercial Office", icon: "🏢" },
//   { value: "Commercial Shop", icon: "🏪" },
//   { value: "PG / Hostel", icon: "🛏️" },
//   { value: "Warehouse / Godown", icon: "🏪" }
// ];

// const PROJECT_STATUS_OPTIONS = [
//   { value: "UNDER CONSTRUCTION", label: "UNDER CONSTRUCTION" },
//   { value: "PRE-LAUNCH", label: "PRE-LAUNCH" },
//   { value: "COMPLETED", label: "COMPLETED" }
// ];

// // Configuration options per project type — fields in Step 3 change based on this (2BHK style)
// const CONFIGURATION_BY_PROJECT_TYPE = {
//   "Apartment": ["Studio Apartment", "1BHK", "2BHK", "3BHK", "4BHK", "5+BHK", "Duplex Apartment", "Penthouse"],
//   "Villa / Banglow": ["2BHK Villa", "3BHK Villa", "4BHK Villa", "5+BHK Villa", "Luxury Villa"],
//   "Independent House": ["1BHK Independent House", "2BHK Independent House", "3BHK Independent House", "4+BHK Independent House"],
//   "Row House/ Farm House": ["2BHK Row House", "3BHK Row House", "4BHK Row House", "Farm House Plot", "Luxury Farm House"],
//   "Penthouse": ["3BHK Penthouse", "4BHK Penthouse", "5+BHK Penthouse"],
//   "Studio Apartment": ["Studio Unit", "Studio + Balcony", "Studio Deluxe"],
//   "Plot / Land / Indusrtial Property": ["Residential Plot", "Commercial Plot", "Industrial Plot", "NA Plot", "Agricultural Land"],
//   "Commercial Office":[  "Bare Shell Office",
//     "Warm Shell Office",
//     "Furnished Office",
//     "Semi-Furnished Office",
//     "Ready-to-Move Office",
//     "Plug & Play Office",
//     "Managed Office",
//     "Serviced Office",
//     "Co-working Space",
//     "Private Cabin",
//     "Shared Office",
//     "Virtual Office",
//     "Business Center Office",
//     "IT / Tech Park Office",
//     "Corporate Office",
//     "Commercial Floor",
//     "Independent Office Building",
//     "Office in Business Park",
//     "Office in Commercial Tower"] ,
//   // ["Office Space (Bare Shell)", "Furnished Office", "IT / Tech Park Office", "Business Center Office", "Call Center / BPO Office", "Head Office",
//   //                       "Branch Office", "Ready-to-Move Office",  "Shared Office",  "Co-working Space"],
//   "Commercial Shop": ["Retail Shop", "Showroom", "Food Court Shop", "Kiosk", "Mall Shop"],
//   "PG / Hostel": ["Single Sharing", "Double Sharing", "Triple Sharing", "Dormitory", "Girls Hostel / Boys Hostel"],
//   "Warehouse / Godown": ["Small Warehouse", "Medium Warehouse", "Large Warehouse", "Cold Storage", "Logistics Warehouse"]
// };

// // Same amenities as in property form (Seller AddPropertyPopup) for consistency
// const AMENITIES = [
//  { id: "parking", label: "Parking", icon: "🚗" },
//   //{ id: "lift", label: "Lift", icon: "🛗" },
//  // { id: "security", label: "24x7 Security", icon: "👮" },
//  // { id: "power_backup", label: "Power Backup", icon: "⚡" },
//   //{ id: "gym", label: "Gym", icon: "🏋️" },
//   { id: "cctv", label: "CCTV", icon: "📹" },
//   { id: "fire_safety", label: "Fire Safety", icon: "🔥" },
//   { id: "water_supply", label: "24x7 Water", icon: "💧" },
//   { id: "swimming_pool", label: "Swimming Pool", icon: "🏊" },
//   { id: "garden", label: "Garden", icon: "🌳" },
//   { id: "clubhouse", label: "Club House", icon: "🏛️" },
//   { id: "playground", label: "Children's Play Area", icon: "🎢" },
//   // { id: "cctv", label: "CCTV", icon: "📹" },
//   { id: "intercom", label: "Intercom", icon: "📞" },
//   // { id: "fire_safety", label: "Fire Safety", icon: "🔥" },
//   // { id: "water_supply", label: "24x7 Water", icon: "💧" },
//   { id: "gas_pipeline", label: "Gas Pipeline", icon: "🔥" },
//  // { id: "wifi", label: "WiFi", icon: "📶" },
//   { id: "ac", label: "Air Conditioning", icon: "❄️" },
//  // { id: "electricity", label: "Electricity", icon: "⚡" },

//   // Plot/Land specific
//   { id: "internal_roads", label: "Internal Roads", icon: "🛣️" },
//   { id: "led_lighting", label: "LED Street Lighting", icon: "💡" },
//   { id: "rainwater_harvesting", label: "Rainwater Harvesting", icon: "🌧️" },
//   { id: "underground_drainage", label: "Underground Drainage", icon: "🚰" },
//   { id: "stormwater_drainage", label: "Stormwater Drainage", icon: "🌊" },
//   { id: "water_line", label: "Water Supply Line/Borewell", icon: "💧" },
//   { id: "electricity_provision", label: "Electricity Provision", icon: "⚡" },
//   { id: "gated_entrance", label: "Gated Entrance", icon: "🚧" },
//   { id: "compound_wall", label: "Compound Wall", icon: "🧱" },
//   { id: "security_cabin", label: "Security Cabin", icon: "🏠" },
//   { id: "landscaped_garden", label: "Landscaped Garden", icon: "🌳" },
//   { id: "jogging_track", label: "Jogging/Walking Track", icon: "🏃" },
//   { id: "open_gym", label: "Open Gym/Fitness Zone", icon: "💪" },
//  // { id: "visitor_parking", label: "Visitor Parking", icon: "🅿️" },

//   // Commercial/Office/Coworking
//   { id: "power_backup_ups", label: "24/7 Power Backup (UPS/DG)", icon: "⚡" },
//   { id: "high_speed_internet", label: "High-Speed Internet/Fiber Ready", icon: "🌐" },
//   { id: "centralized_ac", label: "Centralized AC (HVAC)", icon: "❄️" },
//   { id: "lifts_high_speed", label: "Elevators/High-Speed Lifts", icon: "🛗" },
//   { id: "access_control", label: "Access Control (RFID/Biometric)", icon: "🔐" },
//   { id: "security_staff", label: "Security Staff (24×7)", icon: "👮" },
//   { id: "reception_desk", label: "Reception Desk", icon: "💁" },
//   { id: "lobby_area", label: "Lobby Area", icon: "🛋️" },
//   { id: "conference_room", label: "Conference Room", icon: "🤝" },
//   { id: "washrooms", label: "Washrooms (Private/Common)", icon: "🚻" },
//   { id: "pantry", label: "Pantry/Kitchenette", icon: "☕" },

//   // Commercial Shop
//   { id: "power_supply_247", label: "24/7 Power Supply", icon: "⚡" },
//  // { id: "customer_parking", label: "Customer Parking", icon: "🚗" },
// //  { id: "two_wheeler_parking", label: "Two-Wheeler Parking", icon: "🛵" },
//   { id: "wheelchair_accessible", label: "Wheelchair Accessible/Ramp", icon: "♿" },
//  // { id: "escalator_access", label: "Lift/Escalator Access", icon: "🛗" },
//   { id: "display_window", label: "Glass Front/Display Window", icon: "🪟" },
//   { id: "shutter_door", label: "Shutter Door", icon: "🚪" },
//   { id: "mezzanine_floor", label: "Mezzanine Floor/Storage Room", icon: "📦" },

//   // Coworking specific
//   { id: "dedicated_desk", label: "Dedicated Desk/Hot Desk", icon: "💻" },
//   { id: "private_cabins", label: "Private Cabins", icon: "🏢" },
//   { id: "meeting_rooms", label: "Meeting Rooms", icon: "👥" },
//  // { id: "coffee_tea", label: "Coffee/Tea/Water", icon: "☕" },
//   { id: "office_supplies", label: "Printer/Scanner/Office Supplies", icon: "🖨️" },
//   { id: "housekeeping", label: "Housekeeping & Daily Cleaning", icon: "🧹" },
//   { id: "quiet_zones", label: "Quiet Zones", icon: "🤫" },
//   { id: "mobile_app_access", label: "Mobile App Access", icon: "📱" },
//   { id: "event_space", label: "Event Space/Community Area", icon: "🎉" },
//   { id: "lounge", label: "Lounge/Breakout Zones", icon: "🛋️" }
// ];

// const RERA_STATUS_OPTIONS = [
//   { value: "Applied", label: "Applied" },
//   { value: "Approved", label: "Approved" }
// ];

// const LAND_OWNERSHIP_OPTIONS = [
//   "Freehold", "Leasehold", "Power of Attorney", "Co-operative Society"
// ];

// const BANK_OPTIONS = [
//   "SBI",
//   "HDFC Bank",
//   "Kotak Mahindra Bank",
//   "ICICI Bank",
//   "Axis Bank",
//   "Bank of Baroda (BoB)",
//   "Other"
// ];

// // Indian states for state suggestion dropdown
// const INDIAN_STATES = [
//   'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
//   'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand',
//   'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
//   'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab',
//   'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura',
//   'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
//   'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu',
//   'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Lakshadweep', 'Puducherry'
// ];

// export default function AddUpcomingProjectPopup({ onClose, editData = null }) {
//   const navigate = useNavigate();
//   const { addProperty, updateProperty, refreshData, properties } = useProperty();
//   const isEditMode = !!editData;

//   const [currentStep, setCurrentStep] = useState(1);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [uploadingImages, setUploadingImages] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [isPublished, setIsPublished] = useState(false); // Track if publishing is completed
//   const [showCloseWarning, setShowCloseWarning] = useState(false); // Show warning modal when trying to close on final step
//   const [isDiscarded, setIsDiscarded] = useState(false); // Track if user discarded the form
//   const [showLocationPicker, setShowLocationPicker] = useState(false);
//   const [mapCenterFromAddress, setMapCenterFromAddress] = useState(null);
//   const [imageFiles, setImageFiles] = useState([]);
//   const [imageValidationStatus, setImageValidationStatus] = useState([]); // Track validation status for each image
//   const [isCheckingImages, setIsCheckingImages] = useState(false);
//   const [builderName, setBuilderName] = useState('');
//   const [stateAutoFilled, setStateAutoFilled] = useState(false); // Track if state was auto-filled from map
//   const [stateDropdownOpen, setStateDropdownOpen] = useState(false); // State suggestion dropdown visibility
//   const [launchDatePickerOpen, setLaunchDatePickerOpen] = useState(false); // Launch date picker dropdown visibility
//   const [possessionDatePickerOpen, setPossessionDatePickerOpen] = useState(false); // Possession date picker dropdown visibility
//   const stateDropdownRef = useRef(null);
//   const imagesRef = useRef();
//   const brochureRef = useRef(null);
//   const popupBodyRef = useRef(null);

//   // Get builder name from logged-in user
//   useEffect(() => {
//     const user = authAPI.getUser();
//     if (user && user.full_name) {
//       setBuilderName(user.full_name);
//     }
//   }, []);

//   // Pre-fill form data when in edit mode
// //   useEffect(() => {
// //     if (editData && isEditMode) {
// //       // Parse upcoming_project_data if it's a string
// //       let upcomingData = {};
// //       try {
// //         if (typeof editData.upcomingProjectData === 'string') {
// //           upcomingData = JSON.parse(editData.upcomingProjectData);
// //         } else if (typeof editData.upcomingProjectData === 'object' && editData.upcomingProjectData) {
// //           upcomingData = editData.upcomingProjectData;
// //         }
// //       } catch (e) {
// //         console.warn('Failed to parse upcoming_project_data:', e);
// //       }

// //       // Map legacy project types to current property form values
// //       const legacyProjectTypeMap = {
// //         "Villa": "Villa / Banglow",
// //         "Plot": "Plot / Land / Indusrtial Property",
// //         "Commercial": "Commercial Office"
// //       };
// //       const projectType = legacyProjectTypeMap[editData.propertyType] || editData.propertyType || "";

// //       // Map legacy amenity ids to current (e.g. play_area -> playground)
// //       const rawAmenities = Array.isArray(editData.amenities) ? editData.amenities : [];
// //       const amenities = rawAmenities.map((a) => (a === "play_area" ? "playground" : a));

// //       // Pre-fill form with existing data
// //       setFormData({
// //         // Step 1: Basic Project Information
// //         projectName: editData.title || "",
// //         builderName: upcomingData.builderName || builderName || "",
// //         projectType,
// //         projectStatus: upcomingData.projectStatus || "UNDER CONSTRUCTION",
// //         reraNumber: upcomingData.reraNumber || "",
// //         description: editData.description || "",

// //         // Step 2: Location Details
// //         city: "",
// //         area: editData.location || "",
// //         location: editData.location || "", // Also set location field for form compatibility
// //         fullAddress: editData.additionalAddress || "",
// //         latitude: editData.latitude || "",
// //         longitude: editData.longitude || "",
// //         state: editData.state || "",
// //         pincode: upcomingData.pincode || "",
// //         mapLink: upcomingData.mapLink || "",

// //         // Step 3: Configuration & Inventory
// //         configurations: Array.isArray(upcomingData.configurations) ? upcomingData.configurations : [],
// //         carpetAreaRange: upcomingData.carpetAreaRange || "",
// //         numberOfTowers: upcomingData.numberOfTowers || "",
// //         totalUnits: upcomingData.totalUnits || "",
// //         floorsCount: upcomingData.floorsCount || "",
// //         unitsPerFloor: upcomingData.unitsPerFloor || "",
// //         numberOfVillas: upcomingData.numberOfVillas || "",
// //         numberOfPlots: upcomingData.numberOfPlots || "",
// //         bedCapacity: upcomingData.bedCapacity || "",
// //         loadingDocks: upcomingData.loadingDocks || "",

// //         // Step 4: Pricing & Timeline
// //         startingPrice: editData.price ? (parseFloat(editData.price) / 10000000).toFixed(2) + " Cr" : "",
// //         pricePerSqft: upcomingData.pricePerSqft || "",
// //         bookingAmount: upcomingData.bookingAmount || "",
// //         expectedLaunchDate: upcomingData.expectedLaunchDate || "",
// //         expectedPossessionDate: upcomingData.expectedPossessionDate || "",

// //         // Step 5: Amenities (normalized for legacy ids)
// //         amenities,

// //         // Step 6: Legal & Approval
// //         reraStatus: upcomingData.reraStatus || "",
// //         landOwnershipType: upcomingData.landOwnershipType || "",
// //         bankApproved: upcomingData.bankApproved || "",
// //         approvedBanks: Array.isArray(upcomingData.approvedBanks) ? upcomingData.approvedBanks : [],
// //         otherBankName: "",

// //         // Step 7: Media
// //         coverImage: (() => {
// //           const resolved = resolvePropertyImageUrls(editData.images);
// //           return resolved.length > 0 ? { url: resolved[0], isExisting: true } : null;
// //         })(),
// //         projectImages: resolvePropertyImageUrls(editData.images),
// //       //  brochure: buildBrochureFromUrl(editData.brochureUrl || editData.brochure_url),
// //       // brochures: editData.brochureUrl || editData.brochure_url 
// //       // ? [{ 
// //       //     name: 'Brochure.pdf', 
// //       //     url: editData.brochureUrl || editData.brochure_url, 
// //       //     isExisting: true 
// //       //   }] 
// //       // : [],


// // // NEW CODE (multiple brochures):
// // brochures: (() => {
// //   // Check if there are multiple brochure URLs
// //   const brochureUrls = editData.brochureUrl || editData.brochure_url || [];
  
// //   // If it's a string (single brochure), convert to array
// //   let urls = [];
// //   if (typeof brochureUrls === 'string') {
// //     // Check if it's a JSON string containing an array
// //     try {
// //       const parsed = JSON.parse(brochureUrls);
// //       if (Array.isArray(parsed)) {
// //         urls = parsed;
// //       } else {
// //         urls = [brochureUrls];
// //       }
// //     } catch {
// //       // Not JSON, treat as single URL
// //       urls = [brochureUrls];
// //     }
// //   } else if (Array.isArray(brochureUrls)) {
// //     urls = brochureUrls;
// //   }
  
// //   // Filter out empty/null values and create brochure objects
// //   return urls
// //     .filter(url => url && url.trim() !== '')
// //     .map((url, index) => ({
// //       name: `Brochure ${index + 1}.pdf`,
// //       url: url,
// //       isExisting: true,
// //       id: `existing-${Date.now()}-${index}`
// //     }));
// // })(),



// //         // Step 8: Contact & Sales (support both legacy single contact and salesPersons array)
// //         salesPersons: Array.isArray(upcomingData.salesPersons) && upcomingData.salesPersons.length > 0
// //           ? upcomingData.salesPersons.map(sp => ({
// //             name: sp.name || '',
// //             number: sp.number || '',
// //             email: sp.email || '',
// //             landlineNumber: sp.landlineNumber || '',
// //             whatsappNumber: sp.whatsappNumber || '',
// //             alternativeNumber: sp.alternativeNumber || ''
// //           }))
// //           : [{
// //             name: upcomingData.salesName || "",
// //             number: upcomingData.salesNumber || "",
// //             email: upcomingData.emailId || "",
// //             landlineNumber: upcomingData.landlineNumber || upcomingData.mobileNumber || "",
// //             whatsappNumber: upcomingData.whatsappNumber || "",
// //             alternativeNumber: upcomingData.alternativeNumber || ""
// //           }].filter(sp => sp.name || sp.number || sp.email).length > 0
// //             ? [{ name: upcomingData.salesName || "", number: upcomingData.salesNumber || "", email: upcomingData.emailId || "", landlineNumber: upcomingData.landlineNumber || upcomingData.mobileNumber || "", whatsappNumber: upcomingData.whatsappNumber || "", alternativeNumber: upcomingData.alternativeNumber || "" }]
// //             : [{ name: "", number: "", email: "", landlineNumber: "", whatsappNumber: "", alternativeNumber: "" }],
// //         landlineNumber: upcomingData.landlineNumber || upcomingData.mobileNumber || "",
// //         whatsappNumber: upcomingData.whatsappNumber || "",
// //         alternativeNumber: upcomingData.alternativeNumber || "",

// //         // Step 9: Marketing
// //         projectHighlights: upcomingData.projectHighlights || "",
// //         usp: upcomingData.usp || ""
// //       });

// //       const resolvedImages = resolvePropertyImageUrls(editData.images);
// //       if (resolvedImages.length > 0) {
// //         setImageValidationStatus(createExistingImageValidationStatus(resolvedImages));
// //       }
// //     }
// //   }, [editData, isEditMode, builderName]);


// // Pre-fill form data when in edit mode
// useEffect(() => {
//   if (editData && isEditMode) {
//     // Parse upcoming_project_data if it's a string
//     let upcomingData = {};
//     try {
//       if (typeof editData.upcomingProjectData === 'string') {
//         upcomingData = JSON.parse(editData.upcomingProjectData);
//       } else if (typeof editData.upcomingProjectData === 'object' && editData.upcomingProjectData) {
//         upcomingData = editData.upcomingProjectData;
//       }
//     } catch (e) {
//       console.warn('Failed to parse upcoming_project_data:', e);
//     }

//     // Map legacy project types to current property form values
//     const legacyProjectTypeMap = {
//       "Villa": "Villa / Banglow",
//       "Plot": "Plot / Land / Indusrtial Property",
//       "Commercial": "Commercial Office"
//     };
//     const projectType = legacyProjectTypeMap[editData.propertyType] || editData.propertyType || "";

//     // Map legacy amenity ids to current (e.g. play_area -> playground)
//     const rawAmenities = Array.isArray(editData.amenities) ? editData.amenities : [];
//     const amenities = rawAmenities.map((a) => (a === "play_area" ? "playground" : a));

//     // Handle multiple brochures
//     const handleBrochures = () => {
//       const brochureUrls = editData.brochureUrl || editData.brochure_url || [];
      
//       let urls = [];
//       if (typeof brochureUrls === 'string') {
//         try {
//           const parsed = JSON.parse(brochureUrls);
//           if (Array.isArray(parsed)) {
//             urls = parsed;
//           } else {
//             urls = [brochureUrls];
//           }
//         } catch {
//           urls = [brochureUrls];
//         }
//       } else if (Array.isArray(brochureUrls)) {
//         urls = brochureUrls;
//       }
      
//       return urls
//         .filter(url => url && url.trim() !== '')
//         .map((url, index) => ({
//           name: `Brochure ${index + 1}.pdf`,
//           url: url,
//           isExisting: true,
//           id: `existing-${Date.now()}-${index}`
//         }));
//     };

//     // Pre-fill form with existing data
//     setFormData({
//       // Step 1: Basic Project Information
//       projectName: editData.title || "",
//       builderName: upcomingData.builderName || builderName || "",
//       projectType,
//       projectStatus: upcomingData.projectStatus || "UNDER CONSTRUCTION",
//       reraNumber: upcomingData.reraNumber || "",
//       description: editData.description || "",

//       // Step 2: Location Details
//       city: "",
//       area: editData.location || "",
//       location: editData.location || "",
//       fullAddress: editData.additionalAddress || "",
//       latitude: editData.latitude || "",
//       longitude: editData.longitude || "",
//       state: editData.state || "",
//       pincode: upcomingData.pincode || "",
//       mapLink: upcomingData.mapLink || "",

//       // Step 3: Configuration & Inventory
//       configurations: Array.isArray(upcomingData.configurations) ? upcomingData.configurations : [],
//       carpetAreaRange: upcomingData.carpetAreaRange || "",
//       numberOfTowers: upcomingData.numberOfTowers || "",
//       totalUnits: upcomingData.totalUnits || "",
//       floorsCount: upcomingData.floorsCount || "",
//       unitsPerFloor: upcomingData.unitsPerFloor || "",
//       numberOfVillas: upcomingData.numberOfVillas || "",
//       numberOfPlots: upcomingData.numberOfPlots || "",
//       bedCapacity: upcomingData.bedCapacity || "",
//       loadingDocks: upcomingData.loadingDocks || "",

//       // Step 4: Pricing & Timeline
//       startingPrice: editData.price ? (parseFloat(editData.price) / 10000000).toFixed(2) + " Cr" : "",
//       pricePerSqft: upcomingData.pricePerSqft || "",
//       bookingAmount: upcomingData.bookingAmount || "",
//       expectedLaunchDate: upcomingData.expectedLaunchDate || "",
//       expectedPossessionDate: upcomingData.expectedPossessionDate || "",

//       // Step 5: Amenities (normalized for legacy ids)
//       amenities,

//       // Step 6: Legal & Approval
//       reraStatus: upcomingData.reraStatus || "",
//       landOwnershipType: upcomingData.landOwnershipType || "",
//       bankApproved: upcomingData.bankApproved || "",
//       approvedBanks: Array.isArray(upcomingData.approvedBanks) ? upcomingData.approvedBanks : [],
//       otherBankName: "",

//       // Step 7: Media
//       coverImage: (() => {
//         const resolved = resolvePropertyImageUrls(editData.images);
//         return resolved.length > 0 ? { url: resolved[0], isExisting: true } : null;
//       })(),
//       projectImages: resolvePropertyImageUrls(editData.images),
//       brochures: handleBrochures(), // Updated to handle multiple brochures

//       // Step 8: Contact & Sales
//       salesPersons: Array.isArray(upcomingData.salesPersons) && upcomingData.salesPersons.length > 0
//         ? upcomingData.salesPersons.map(sp => ({
//             name: sp.name || '',
//             number: sp.number || '',
//             email: sp.email || '',
//             landlineNumber: sp.landlineNumber || '',
//             whatsappNumber: sp.whatsappNumber || '',
//             alternativeNumber: sp.alternativeNumber || ''
//           }))
//         : [{
//             name: upcomingData.salesName || "",
//             number: upcomingData.salesNumber || "",
//             email: upcomingData.emailId || "",
//             landlineNumber: upcomingData.landlineNumber || upcomingData.mobileNumber || "",
//             whatsappNumber: upcomingData.whatsappNumber || "",
//             alternativeNumber: upcomingData.alternativeNumber || ""
//           }].filter(sp => sp.name || sp.number || sp.email).length > 0
//             ? [{ name: upcomingData.salesName || "", number: upcomingData.salesNumber || "", email: upcomingData.emailId || "", landlineNumber: upcomingData.landlineNumber || upcomingData.mobileNumber || "", whatsappNumber: upcomingData.whatsappNumber || "", alternativeNumber: upcomingData.alternativeNumber || "" }]
//             : [{ name: "", number: "", email: "", landlineNumber: "", whatsappNumber: "", alternativeNumber: "" }],
//       landlineNumber: upcomingData.landlineNumber || upcomingData.mobileNumber || "",
//       whatsappNumber: upcomingData.whatsappNumber || "",
//       alternativeNumber: upcomingData.alternativeNumber || "",

//       // Step 9: Marketing
//       projectHighlights: upcomingData.projectHighlights || "",
//       usp: upcomingData.usp || ""
//     });

//     const resolvedImages = resolvePropertyImageUrls(editData.images);
//     if (resolvedImages.length > 0) {
//       setImageValidationStatus(createExistingImageValidationStatus(resolvedImages));
//     }
//   }
// }, [editData, isEditMode, builderName]);



//   const [formData, setFormData] = useState({
//     // Step 1: Basic Project Information
//     projectName: "",
//     builderName: "",
//     projectType: "",
//     projectStatus: "UNDER CONSTRUCTION",
//     reraNumber: "",
//     description: "",

//     // Step 2: Location Details
//     city: "",
//     area: "",
//     fullAddress: "",
//     latitude: "",
//     longitude: "",
//     state: "",
//     pincode: "",
//     mapLink: "",

//     // Step 3: Configuration & Inventory
//     configurations: [],
//     carpetAreaRange: "",
//     numberOfTowers: "",
//     totalUnits: "",
//     floorsCount: "",
//     unitsPerFloor: "",
//     numberOfVillas: "",
//     numberOfPlots: "",
//     bedCapacity: "",
//     loadingDocks: "",

//     // Step 4: Pricing & Timeline
//     startingPrice: "",
//     pricePerSqft: "",
//     bookingAmount: "",
//     expectedLaunchDate: "",
//     expectedPossessionDate: "",

//     // Step 5: Amenities
//     amenities: [],

//     // Step 6: Legal & Approval
//     reraStatus: "",
//     landOwnershipType: "",
//     bankApproved: "",
//     approvedBanks: [],
//     otherBankName: "",

//     // Step 7: Media
//     coverImage: null,
//     projectImages: [],
//     brochures: [],

//     // Step 8: Contact & Sales (multiple sales persons)
//     salesPersons: [{ name: "", number: "", email: "", landlineNumber: "", whatsappNumber: "", alternativeNumber: "" }],
//     landlineNumber: "",
//     whatsappNumber: "",
//     alternativeNumber: "",

//     // Step 9: Marketing
//     projectHighlights: "",
//     usp: ""
//   });

//   // Reset all form state (for hard discard)
//   const resetFormState = useCallback(() => {
//     setFormData({
//       projectName: "",
//       builderName: "",
//       projectType: "",
//       projectStatus: "UNDER CONSTRUCTION",
//       reraNumber: "",
//       description: "",
//       city: "",
//       area: "",
//       fullAddress: "",
//       latitude: "",
//       longitude: "",
//       state: "",
//       pincode: "",
//       mapLink: "",
//       configurations: [],
//       carpetAreaRange: "",
//       numberOfTowers: "",
//       totalUnits: "",
//       floorsCount: "",
//       unitsPerFloor: "",
//       numberOfVillas: "",
//       numberOfPlots: "",
//       bedCapacity: "",
//       loadingDocks: "",
//       startingPrice: "",
//       pricePerSqft: "",
//       bookingAmount: "",
//       expectedLaunchDate: "",
//       expectedPossessionDate: "",
//       amenities: [],
//       reraStatus: "",
//       landOwnershipType: "",
//       bankApproved: "",
//       approvedBanks: [],
//       otherBankName: "",
//       coverImage: null,
//       projectImages: [],
//       brochures: [],
//       salesPersons: [{ name: "", number: "", email: "", landlineNumber: "", whatsappNumber: "", alternativeNumber: "" }],
//       landlineNumber: "",
//       whatsappNumber: "",
//       alternativeNumber: "",
//       projectHighlights: "",
//       usp: ""
//     });
//     setCurrentStep(1);
//     setErrors({});
//     setImageFiles([]);
//     setImageValidationStatus([]);
//     setIsCheckingImages(false);
//     setStateAutoFilled(false);
//     setMapCenterFromAddress(null);
//     setIsSubmitting(false);
//     setUploadingImages(false);
//     setIsPublished(false);
//   }, []);

//   // Handle discard and close - HARD DISCARD
//   const handleDiscardAndClose = useCallback(() => {
//     setIsDiscarded(true);
//     resetFormState();
//     setShowCloseWarning(false);
//     onClose();
//   }, [resetFormState, onClose]);

//   // Handle close attempt - check if on final step and not published
//   const handleCloseAttempt = useCallback(() => {
//     const isFinalStep = currentStep === STEPS.length;
//     if (isFinalStep && !isPublished) {
//       // Show warning modal instead of closing
//       setShowCloseWarning(true);
//       return;
//     }
//     // Allow closing if not on final step or already published
//     onClose();
//   }, [currentStep, isPublished, onClose]);

//   // Close on escape
//   useEffect(() => {
//     if (showCloseWarning) return; // Don't close main popup when warning modal is open
//     const onKey = (e) => {
//       if (e.key === "Escape") {
//         handleCloseAttempt();
//       }
//     };
//     window.addEventListener("keydown", onKey);
//     return () => window.removeEventListener("keydown", onKey);
//   }, [handleCloseAttempt, showCloseWarning]);

//   // Close state dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (stateDropdownRef.current && !stateDropdownRef.current.contains(e.target)) {
//         setStateDropdownOpen(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   // Cleanup blob URLs on unmount
//   useEffect(() => {
//     return () => {
//       if (formData.projectImages) {
//         formData.projectImages.forEach(img => {
//           if (typeof img === 'string' && img.startsWith('blob:')) {
//             URL.revokeObjectURL(img);
//           }
//         });
//       }
//     };
//   }, []);

//   const handleChange = (field, value) => {
//     setFormData(prev => {
//       const next = { ...prev, [field]: value };
//       // When project type changes, keep only configurations valid for the new type
//       if (field === "projectType") {
//         const options = CONFIGURATION_BY_PROJECT_TYPE[value] || [];
//         next.configurations = (prev.configurations || []).filter((c) => options.includes(c));
//       }
//       return next;
//     });
//     if (errors[field]) {
//       setErrors(prev => ({ ...prev, [field]: null }));
//     }
//   };

//   // Handle price input - only allow numbers, dashes, and decimal points
//   const handlePriceChange = (field, value) => {
//     // Allow numbers, dots, dashes, spaces, and commas for flexible price ranges
//     const sanitized = value.replace(/[^\d.\-\s,]/g, '');
//     handleChange(field, sanitized);
//   };

//   // Handle carpet area range input - strip sq.ft if user types it, store numeric only
//   const handleCarpetAreaChange = (value) => {
//     // Remove "sq.ft" if user typed it
//     const cleanValue = value.replace(/\s*sq\.ft\s*/gi, '').trim();
//     handleChange('carpetAreaRange', cleanValue);
//   };

//   const toggleConfiguration = (config) => {
//     setFormData(prev => ({
//       ...prev,
//       configurations: prev.configurations.includes(config)
//         ? prev.configurations.filter(c => c !== config)
//         : [...prev.configurations, config]
//     }));
//     if (errors.configurations) {
//       setErrors(prev => ({ ...prev, configurations: null }));
//     }
//   };

//   const toggleAmenity = (amenityId) => {
//     setFormData(prev => ({
//       ...prev,
//       amenities: prev.amenities.includes(amenityId)
//         ? prev.amenities.filter(a => a !== amenityId)
//         : [...prev.amenities, amenityId]
//     }));
//     // Clear amenities error when user selects/deselects an amenity
//     if (errors.amenities) {
//       setErrors(prev => ({ ...prev, amenities: null }));
//     }
//   };

//   const handleGenerateDescription = () => {
//     const amenityLabels = collectAmenityLabels(formData.amenities, AMENITIES);
//     const generated = generateUpcomingProjectDescription(formData.amenityLabels, formData.builderName
//     //   {
//     //   amenityLabels,
//     //   builderName,
//     // }
//   );
//     handleChange('description', generated);
//     if (errors.description) {
//       setErrors(prev => ({ ...prev, description: null }));
//     }
//   };

//   const toggleBank = (bank) => {
//     setFormData(prev => ({
//       ...prev,
//       approvedBanks: (prev.approvedBanks || []).includes(bank)
//         ? (prev.approvedBanks || []).filter(b => b !== bank)
//         : [...(prev.approvedBanks || []), bank]
//     }));
//   };

//   const defaultSalesPerson = () => ({ name: '', number: '', email: '', landlineNumber: '', whatsappNumber: '', alternativeNumber: '' });

//   const updateSalesPerson = (index, field, value) => {
//     setFormData(prev => {
//       const next = [...(prev.salesPersons || [defaultSalesPerson()])];
//       if (!next[index]) next[index] = defaultSalesPerson();
//       next[index] = { ...next[index], [field]: value };
//       return { ...prev, salesPersons: next };
//     });
//     setErrors(prev => {
//       const next = { ...prev };
//       ['name', 'number', 'email'].forEach(f => {
//         if (next[`salesPerson_${f}_${index}`]) delete next[`salesPerson_${f}_${index}`];
//       });
//       return next;
//     });
//   };

//   const addSalesPerson = () => {
//     setFormData(prev => {
//       const currentSalesPersons = prev.salesPersons || [];
//       if (currentSalesPersons.length >= 5) return prev;
//       return {
//         ...prev,
//         salesPersons: [...currentSalesPersons, defaultSalesPerson()]
//       };
//     });
//   };

//   const removeSalesPerson = (index) => {
//     setFormData(prev => {
//       const next = (prev.salesPersons || []).filter((_, i) => i !== index);
//       if (next.length === 0) next.push(defaultSalesPerson());
//       return { ...prev, salesPersons: next };
//     });
//     setErrors(prev => {
//       const next = { ...prev };
//       Object.keys(next).forEach(k => {
//         if (k.startsWith('salesPerson_')) delete next[k];
//       });
//       return next;
//     });
//   };

//   // Handle location selection from LocationPicker (map)
//   const handleLocationSelect = (locationData) => {
//     // Auto-populate state from map selection if available
//     const stateFromMap = locationData.state || '';
//     const wasStateAutoFilled = !!stateFromMap;

//     setFormData(prev => ({
//       ...prev,
//       latitude: locationData.latitude.toString(),
//       longitude: locationData.longitude.toString(),
//       location: locationData.fullAddress || prev.location || prev.area,
//       // DO NOT auto-fill fullAddress - it should remain NULL unless manually entered
//       // fullAddress: locationData.fullAddress || prev.fullAddress, // REMOVED
//       // Always update state from map (even if empty) to reflect the new location
//       state: stateFromMap
//     }));

//     // Track if state was auto-filled from map
//     setStateAutoFilled(wasStateAutoFilled);
//     setShowLocationPicker(false);
//     if (errors.location || errors.area || errors.state) {
//       setErrors(prev => ({ ...prev, location: null, area: null, state: null }));
//     }
//   };

//   // Handle location selection from LocationAutoSuggest dropdown
//   const handleLocationDropdownSelect = (locationData) => {
//     if (!locationData) {
//       // Clear location and state when location is cleared
//       setFormData(prev => ({
//         ...prev,
//         location: '',
//         area: '',
//         state: '',
//         latitude: '',
//         longitude: ''
//       }));
//       setStateAutoFilled(false);
//       setMapCenterFromAddress(null);
//       if (errors.location || errors.area || errors.state) {
//         setErrors(prev => ({ ...prev, location: null, area: null, state: null }));
//       }
//       return;
//     }

//     // Auto-populate state from location dropdown selection
//     const stateFromLocation = locationData.state || '';
//     const wasStateAutoFilled = !!stateFromLocation;

//     setFormData(prev => ({
//       ...prev,
//       location: locationData.placeName || locationData.fullAddress || prev.location || prev.area,
//       area: locationData.placeName || locationData.fullAddress || prev.area,
//       // Do not auto-pin from typed address: user must confirm location on map
//       latitude: '',
//       longitude: '',
//       // Always update state from location dropdown (even if empty) to reflect the new location
//       state: stateFromLocation
//       // DO NOT auto-fill fullAddress - it should remain NULL unless manually entered
//       // fullAddress is NOT updated here - user must manually enter it
//     }));

//     // Center map on selected list location when user opens LocationPicker
//     if (locationData.coordinates?.lat != null && locationData.coordinates?.lng != null) {
//       setMapCenterFromAddress({
//         lng: locationData.coordinates.lng,
//         lat: locationData.coordinates.lat,
//       });
//     } else {
//       setMapCenterFromAddress(null);
//     }

//     // Track if state was auto-filled from location dropdown
//     setStateAutoFilled(wasStateAutoFilled);
//     if (errors.location || errors.area || errors.state) {
//       setErrors(prev => ({ ...prev, location: null, area: null, state: null }));
//     }
//   };

//   const handleImageUpload = async (e) => {
//     const files = Array.from(e.target.files || []);
//     const currentCount = formData.projectImages?.length || 0;
//     if (currentCount + files.length > 20) {
//       setErrors(prev => ({
//         ...prev,
//         projectImages: `You can upload a maximum of 20 images. You have ${currentCount} and trying to add ${files.length}`
//       }));
//       return;
//     }

//     // Basic file validation first
//     const validFiles = [];
//     for (const file of files) {
//       const fileValidation = validateImageFile(file);
//       if (!fileValidation.valid) {
//         setErrors(prev => ({
//           ...prev,
//           projectImages: fileValidation.message
//         }));
//         continue;
//       }
//       validFiles.push(file);
//     }

//     if (validFiles.length === 0) {
//       return;
//     }

//     // Create image objects with pending status
//     const newImageObjects = validFiles.map(file => ({
//       file: file,
//       preview: URL.createObjectURL(file),
//       status: 'pending', // pending, checking, approved, rejected
//       errorMessage: '',
//       imageId: null,
//       imageUrl: null
//     }));

//     // Add to state immediately
//     setImageFiles(prev => [...prev, ...validFiles].slice(0, 20));
//     setImageValidationStatus(prev => [...prev, ...newImageObjects].slice(0, 20));

//     // Create blob URLs for preview
//     const newImages = validFiles.map(f => URL.createObjectURL(f));
//     setFormData(prev => ({
//       ...prev,
//       projectImages: [...(prev.projectImages || []), ...newImages].slice(0, 20)
//     }));

//     // Clear any previous errors
//     if (errors.projectImages) {
//       setErrors(prev => ({ ...prev, projectImages: null }));
//     }

//     // Immediately validate each image through moderation API (in parallel for speed)
//     setIsCheckingImages(true);
//     const startIndex = imageValidationStatus.length;

//     // Validate all images in parallel for faster processing
//     const validationPromises = newImageObjects.map((imgObj, i) =>
//       validateImageThroughModeration(imgObj, startIndex + i)
//     );

//     // Wait for all validations to complete
//     await Promise.all(validationPromises);

//     setIsCheckingImages(false);
//   };

//   // Validate single image through moderation API
//   const validateImageThroughModeration = async (imageObj, index) => {
//     // Update status to checking
//     setImageValidationStatus(prev => {
//       const updated = [...prev];
//       if (updated[index]) {
//         updated[index] = {
//           ...updated[index],
//           status: 'checking'
//         };
//       }
//       return updated;
//     });

//     try {
//       // Use 0 for property ID (validation-only mode for new projects)
//       const propertyId = 0;

//       const formData = new FormData();
//       formData.append('image', imageObj.file);
//       formData.append('property_id', propertyId);
//       formData.append('validate_only', 'true');

//       const token = localStorage.getItem('authToken');
//       console.log(`[Image ${index + 1}] Starting validation...`);

//       const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.MODERATE_AND_UPLOAD}`, {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//         },
//         body: formData,
//       });

//       console.log(`[Image ${index + 1}] Response status:`, response.status);

//       // Check if response is OK
//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error(`[Image ${index + 1}] HTTP Error ${response.status}:`, errorText);
//         let errorData;
//         try {
//           errorData = JSON.parse(errorText);
//         } catch (e) {
//           errorData = { message: errorText || `HTTP ${response.status} Error` };
//         }

//         setImageValidationStatus(prev => {
//           const updated = [...prev];
//           if (updated[index]) {
//             updated[index] = {
//               ...updated[index],
//               status: 'rejected',
//               errorMessage: errorData.message || 'Validation failed',
//               fullErrorMessage: errorData.message || `HTTP ${response.status} Error`
//             };
//           }
//           return updated;
//         });
//         return;
//       }

//       const result = await response.json();
//       console.log(`[Image ${index + 1}] API Response:`, result);

//       // CRITICAL: Check moderation_status explicitly, not just response status
//       // Backend returns: { status: "success", data: { moderation_status: "PENDING" | "NEEDS_REVIEW" | "SAFE" } }
//       const moderationStatus = result.data?.moderation_status;

//       const formatModerationError = (message) => {
//         let errorReason = message || 'Image was rejected';
//         if (errorReason.includes('animal appearance')) {
//           const match = errorReason.match(/\(([^)]+)\)/);
//           errorReason = match ? `${match[1]} detected` : 'Animal detected';
//         } else if (errorReason.includes('human appearance') || errorReason.includes('Human')) {
//           errorReason = 'Human appearance detected';
//         } else if (errorReason.includes('blurry') || errorReason.includes('blur')) {
//           errorReason = 'Image is too blurry';
//         } else if (errorReason.includes('low quality') || errorReason.includes('pixels')) {
//           errorReason = 'Image quality too low';
//         } else if (
//           errorReason.includes('text') ||
//           errorReason.includes('document') ||
//           errorReason.includes('OCR') ||
//           errorReason.includes('visiting') ||
//           errorReason.includes('phone number') ||
//           errorReason.includes('email')
//         ) {
//           errorReason = 'Text or document detected';
//         }
//         return errorReason;
//       };

//       setImageValidationStatus(prev => {
//         const updated = [...prev];
//         if (!updated[index]) {
//           return updated;
//         }

//         if (
//           result.status === 'error' ||
//           moderationStatus === 'REJECTED' ||
//           moderationStatus === 'UNSAFE'
//         ) {
//           const errorReason = formatModerationError(result.message);
//           updated[index] = {
//             ...updated[index],
//             status: 'rejected',
//             errorMessage: errorReason,
//             fullErrorMessage: result.message || 'Image was rejected',
//           };
//         } else {
//           updated[index] = {
//             ...updated[index],
//             status: 'approved',
//             imageId: result.data?.image_id ?? null,
//             imageUrl: result.data?.image_url || null,
//             moderationStatus: moderationStatus || 'SAFE',
//           };
//         }

//         return updated;
//       });

//     } catch (error) {
//       console.error(`[Image ${index + 1}] ❌ Validation error:`, error);
//       console.error(`[Image ${index + 1}] Error details:`, {
//         name: error.name,
//         message: error.message,
//         stack: error.stack
//       });

//       setImageValidationStatus(prev => {
//         const updated = [...prev];
//         if (updated[index]) {
//           updated[index] = {
//             ...updated[index],
//             status: 'rejected',
//             errorMessage: error.message || 'Validation failed. Please check console for details.',
//             fullErrorMessage: error.message || 'Failed to validate image. Please try again.'
//           };
//         }
//         return updated;
//       });
//     }
//   };

//   const removeImage = (idx) => {
//     // Revoke blob URL to free memory
//     if (formData.projectImages && formData.projectImages[idx] && formData.projectImages[idx].startsWith('blob:')) {
//       URL.revokeObjectURL(formData.projectImages[idx]);
//     }

//     // Also revoke preview URL from validation status
//     if (imageValidationStatus[idx]?.preview && imageValidationStatus[idx].preview.startsWith('blob:')) {
//       URL.revokeObjectURL(imageValidationStatus[idx].preview);
//     }

//     setFormData(prev => ({
//       ...prev,
//       projectImages: prev.projectImages.filter((_, i) => i !== idx)
//     }));

//     // Also remove from imageFiles array
//     setImageFiles(prev => prev.filter((_, i) => i !== idx));

//     // Remove from validation status
//     setImageValidationStatus(prev => prev.filter((_, i) => i !== idx));
//   };

//   const validateStep = (step) => {
//     const newErrors = {};

//     switch (step) {
//       case 1:
//         if (!formData.projectName?.trim()) newErrors.projectName = "Project name is required";
//         if (!formData.projectType) newErrors.projectType = "Project type is required";
//         if (!formData.projectStatus) newErrors.projectStatus = "Project status is required";
//         break;
//       case 2:
//         if (!formData.location?.trim() && !formData.area?.trim()) {
//           newErrors.location = "Location is required";
//         }
//         if (!formData.state?.trim()) {
//           newErrors.state = "State is required";
//         }
//         if (!formData.fullAddress?.trim()) {
//           newErrors.fullAddress = "Additional address is required";
//         }
//         if (!formData.pincode?.trim()) {
//           newErrors.pincode = "Pincode is required";
//         } else if (!/^\d{6}$/.test(formData.pincode.trim())) {
//           newErrors.pincode = "Pincode must be 6 digits";
//         }
//         break;
//       case 3: {
//         const configOptions = formData.projectType ? (CONFIGURATION_BY_PROJECT_TYPE[formData.projectType] || []) : [];
//         if (configOptions.length === 0) {
//           newErrors.configurations = "Select a project type in Step 1 first.";
//         } else if (formData.configurations.length === 0) {
//           newErrors.configurations = "At least one configuration is required";
//         }
//         if (!formData.carpetAreaRange?.trim()) newErrors.carpetAreaRange = "Area range is required";
//         break;
//       }
//       case 4:
//         if (!formData.startingPrice?.trim()) newErrors.startingPrice = "Starting price is required";
//         if (!formData.amenities || formData.amenities.length < 3) {
//           newErrors.amenities = "Select at least 3 amenities compulsory";
//         }
//         if (!formData.description?.trim()) {
//           newErrors.description = "Project description is required";
//         } else if (formData.description.trim().length < 100) {
//           newErrors.description = "Project description must be at least 100 characters";
//         }
//         break;
//     //   case 5:
//     //     if (!formData.coverImage?.file && !formData.coverImage?.isExisting) {
//     //       newErrors.coverImage = "Please add cover image first";
//     //     }
//     //     // Validate images
//     //     const imageCount = Math.max(
//     //       imageValidationStatus.length,
//     //       formData.projectImages.length || 0
//     //     );
//     //     if (imageCount < 2) {
//     //       newErrors.projectImages = `Please upload at least 2 images. Currently uploaded: ${imageCount}`;
//     //     } else if (imageCount > 20) {
//     //       newErrors.projectImages = `You can upload a maximum of 20 images. Currently uploaded: ${imageCount}`;
//     //     } else {
//     //       // Check if any images are still being validated
//     //       if (isCheckingImages) {
//     //         newErrors.projectImages = "Please wait for all images to be validated";
//     //       }
//     //       // Check if any images were rejected
//     //       const rejectedCount = imageValidationStatus.filter(img => img.status === 'rejected').length;
//     //       if (rejectedCount > 0) {
//     //         newErrors.projectImages = `Please remove ${rejectedCount} rejected image(s) before proceeding`;
//     //       }
//     //       // Check if at least one image is approved
//     //       const approvedCount = imageValidationStatus.filter(img => img.status === 'approved').length;
//     //       if (approvedCount === 0 && imageValidationStatus.length > 0 && !isCheckingImages) {
//     //         newErrors.projectImages = "At least one image must be approved";
//     //       }
//     //     }
//     //     // Validate contact fields (at least one sales person with all required fields)
//     //     const salesPersons = formData.salesPersons || [];
//     //     if (salesPersons.length === 0) {
//     //       newErrors.salesPersons = "At least one sales person is required";
//     //     } else {
//     //       salesPersons.forEach((sp, idx) => {
//     //         if (!sp.name?.trim()) newErrors[`salesPerson_name_${idx}`] = "Sales person name is required";
//     //         else if (/[^a-zA-Z\s]/.test(sp.name)) newErrors[`salesPerson_name_${idx}`] = "Name should contain only letters";
//     //         if (!sp.number?.trim()) newErrors[`salesPerson_number_${idx}`] = "Sales number is required";
//     //         else if (sp.number.replace(/\D/g, '').length !== 10) newErrors[`salesPerson_number_${idx}`] = "Sales number must be 10 digits";
//     //         if (!sp.email?.trim()) newErrors[`salesPerson_email_${idx}`] = "Email ID is required";
//     //       });
//     //     }
//     //     break;
//     //   default:
//     //     break;
//     // }


// // Find this section in the validateStep function (around line 500-520)
// case 5:
//   if (!formData.coverImage?.file && !formData.coverImage?.isExisting) {
//     newErrors.coverImage = "Please add cover image first";
//   }
//   // Validate images
//   const imageCount = Math.max(
//     imageValidationStatus.length,
//     formData.projectImages.length || 0
//   );
//   // CHANGE THIS: Update from 2 to 3
//   if (imageCount < 3) {  // Changed from 2 to 3
//     newErrors.projectImages = `Please upload at least 3 images. Currently uploaded: ${imageCount}`;
//   } else if (imageCount > 20) {
//     newErrors.projectImages = `You can upload a maximum of 20 images. Currently uploaded: ${imageCount}`;
//   } else {
//     // Check if any images are still being validated
//     if (isCheckingImages) {
//       newErrors.projectImages = "Please wait for all images to be validated";
//     }
//     // Check if any images were rejected
//     const rejectedCount = imageValidationStatus.filter(img => img.status === 'rejected').length;
//     if (rejectedCount > 0) {
//       newErrors.projectImages = `Please remove ${rejectedCount} rejected image(s) before proceeding`;
//     }
//     // Check if at least one image is approved
//     const approvedCount = imageValidationStatus.filter(img => img.status === 'approved').length;
//     if (approvedCount === 0 && imageValidationStatus.length > 0 && !isCheckingImages) {
//       newErrors.projectImages = "At least one image must be approved";
//     }
//   }
//   // ... rest of the validation
//   break;
// }


//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleNext = () => {
//     if (validateStep(currentStep)) {
//       setCurrentStep(prev => Math.min(prev + 1, 5));
//     } else {
//       setTimeout(() => {
//         if (popupBodyRef.current) {
//           const firstErrorField = popupBodyRef.current.querySelector('.error, .error-text');
//           if (firstErrorField) {
//             firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
//           } else {
//             popupBodyRef.current.scrollTop = 0;
//           }
//         }
//       }, 100);
//     }
//   };

//   const handleBack = () => {
//     setCurrentStep(prev => Math.max(prev - 1, 1));
//   };

//   const isStepCompleted = (stepId) => {
//     return currentStep > stepId;
//   };

//   const handleStepClick = (stepId) => {
//     if (stepId === currentStep) return;
//     if (stepId < currentStep) {
//       setCurrentStep(stepId);
//     }
//   };

//   useEffect(() => {
//     if (popupBodyRef.current) {
//       popupBodyRef.current.scrollTop = 0;
//     }
//   }, [currentStep]);

//   // Format price in words (same as List Property) - handles ranges
//   const formatPriceInWords = (price) => {
//     if (!price) return '';

//     // Check if it's a range (contains "-" or "to" or " - ")
//     const isRange = /[-–—]|to/i.test(price);

//     if (isRange) {
//       // Split by common range separators
//       const rangeParts = price.split(/[-–—]|to/i).map(p => p.trim()).filter(p => p);
//       if (rangeParts.length === 2) {
//         const startPrice = formatSinglePrice(rangeParts[0]);
//         const endPrice = formatSinglePrice(rangeParts[1]);
//         if (startPrice && endPrice) {
//           return `${startPrice} - ${endPrice}`;
//         }
//       }
//     }

//     // Single price
//     return formatSinglePrice(price);
//   };

//   // Helper function to format a single price value
//   const formatSinglePrice = (priceStr) => {
//     if (!priceStr) return '';
//     // Extract numeric value from string (e.g., "₹45 Lakhs" -> 4500000)
//     let num = 0;
//     const cleanStr = priceStr.toString().replace(/[^\d.]/g, '');
//     num = parseFloat(cleanStr) || 0;

//     // If the string contains "lakh" or "lac", multiply by 100000
//     if (priceStr.toString().toLowerCase().includes('lakh') || priceStr.toString().toLowerCase().includes('lac')) {
//       num = num * 100000;
//     } else if (priceStr.toString().toLowerCase().includes('crore') || priceStr.toString().toLowerCase().includes('cr')) {
//       num = num * 10000000;
//     }

//     if (isNaN(num) || num === 0) return '';

//     if (num >= 10000000) {
//       return `₹${(num / 10000000).toFixed(2)} Crore`;
//     } else if (num >= 100000) {
//       return `₹${(num / 100000).toFixed(2)} Lakh`;
//     } else if (num >= 1000) {
//       return `₹${(num / 1000).toFixed(2)} Thousand`;
//     }
//     return `₹${num}`;
//   };

//   const handleSubmit = async () => {
//     // CRITICAL: Block all publishing if form was discarded
//     if (isDiscarded) {
//       console.log('Publishing blocked: Form was discarded');
//       return;
//     }

//     // Final slot check before publishing a new project.
//     if (!isEditMode) {
//       try {
//         const currentUser = authAPI.getUser();
//         const [statsResponse, subscriptionsResponse, profileResult] = await Promise.all([
//           sellerDashboardAPI.getStats(),
//           sellerDashboardAPI.getSubscriptions(),
//           sellerProfileAPI.get().catch(() => null),
//         ]);
//         const activeSubscriptions = subscriptionsResponse?.success
//           ? (subscriptionsResponse.data?.subscriptions || []).filter((subscription) => subscription.status === 'active')
//           : [];
//         const paidSlots = activeSubscriptions.reduce(
//           (total, subscription) => total + Number(subscription.properties_limit || 0),
//           0
//         );
//         const statsSubscription = statsResponse?.data?.subscription || null;
//         const trialUser = profileResult?.success
//           ? profileResult.data?.profile
//           : currentUser;
//         const totalSlots = paidSlots + (hasActiveFreeTrial(statsSubscription, trialUser) ? FREE_LISTING_SLOTS : 0);
//         const currentPropertyCount = properties?.length || 0;
//         const remainingSlots = Math.max(0, totalSlots - currentPropertyCount);

//         if (remainingSlots <= 0) {
//           const errorMsg = 'You have reached your current plan limit. Purchase another plan to add more properties.';
//           setErrors(prev => ({ ...prev, submit: errorMsg }));
//           alert(errorMsg);
//           navigate('/agent-dashboard/subscription');
//           return;
//         }
//       } catch (err) {
//         console.error('Failed to verify plan slots before project publish:', err);
//         // Proceed and rely on backend enforcement when stats check fails transiently
//       }
//     }

//     // Always validate step 5 (images and contact) before submission
//     if (!validateStep(5)) {
//       // Switch to step 5 if validation fails
//       setCurrentStep(5);
//       return;
//     }

//     setIsSubmitting(true);
//     setUploadingImages(true);

//     try {
//       // Convert form data to property format
//       // Extract numeric price value from string (e.g., "₹45 Lakhs onwards" -> 4500000)
//       let priceValue = 0;
//       if (formData.startingPrice) {
//         const priceStr = formData.startingPrice.replace(/[^\d.]/g, '');
//         priceValue = parseFloat(priceStr) || 0;
//         // If the string contains "lakh" or "lac", multiply by 100000
//         if (formData.startingPrice.toLowerCase().includes('lakh') || formData.startingPrice.toLowerCase().includes('lac')) {
//           priceValue = priceValue * 100000;
//         } else if (formData.startingPrice.toLowerCase().includes('crore') || formData.startingPrice.toLowerCase().includes('cr')) {
//           priceValue = priceValue * 10000000;
//         }
//       }

//       // Validate required fields before submission
//       if (!priceValue || priceValue <= 0) {
//         throw new Error('Starting price is required and must be greater than 0');
//       }

//       const propertyData = {
//         title: formData.projectName,
//         property_type: formData.projectType,
//         status: "sale", // Upcoming projects are always for sale
//         location: formData.location || formData.area || '',
//         latitude: formData.latitude || null,
//         longitude: formData.longitude || null,
//         state: formData.state || null,
//         additional_address: formData.fullAddress || null,
//         description: formData.description,
//         price: priceValue,
//         area: 1, // Required field, set minimum value for upcoming projects (1 sq ft as placeholder)
//         project_type: "upcoming", // CRITICAL FLAG
//         // Additional upcoming project fields stored as JSON
//         upcoming_project_data: {
//           builderName: formData.builderName || builderName,
//           projectStatus: formData.projectStatus,
//           startingPrice: formData.startingPrice || null,
//           reraNumber: formData.reraNumber || null,
//           configurations: formData.configurations,
//           carpetAreaRange: formData.carpetAreaRange || null,
//           numberOfTowers: formData.numberOfTowers || null,
//           totalUnits: formData.totalUnits || null,
//           floorsCount: formData.floorsCount || null,
//           unitsPerFloor: formData.unitsPerFloor || null,
//           numberOfVillas: formData.numberOfVillas || null,
//           numberOfPlots: formData.numberOfPlots || null,
//           bedCapacity: formData.bedCapacity || null,
//           loadingDocks: formData.loadingDocks || null,
//           pricePerSqft: formData.pricePerSqft || null,
//           bookingAmount: formData.bookingAmount || null,
//           expectedLaunchDate: formData.expectedLaunchDate || null,
//           expectedPossessionDate: formData.expectedPossessionDate || null,
//           reraStatus: formData.reraStatus || null,
//           landOwnershipType: formData.landOwnershipType || null,
//           bankApproved: formData.bankApproved || null,
//           approvedBanks: (() => {
//             // Combine selected banks and custom bank names
//             const banks = [...(formData.approvedBanks || [])];
//             // Remove "Other" from the array as it's just a trigger
//             const banksWithoutOther = banks.filter(b => b !== 'Other');
//             if (formData.otherBankName && formData.otherBankName.trim()) {
//               // Parse comma-separated custom bank names and add them
//               const customBanks = formData.otherBankName.split(',').map(b => b.trim()).filter(b => b);
//               banksWithoutOther.push(...customBanks);
//             }
//             return banksWithoutOther;
//           })(),
//           salesPersons: (formData.salesPersons || []).filter(sp => sp.name?.trim() || sp.number?.trim() || sp.email?.trim()).map(sp => ({
//             name: sp.name || null,
//             number: sp.number || null,
//             email: sp.email || null,
//             landlineNumber: sp.landlineNumber?.trim() || null,
//             whatsappNumber: sp.whatsappNumber?.trim() || null,
//             alternativeNumber: sp.alternativeNumber?.trim() || null
//           })),
//           salesName: formData.salesPersons?.[0]?.name || null,
//           salesNumber: formData.salesPersons?.[0]?.number || null,
//           emailId: formData.salesPersons?.[0]?.email || null,
//           landlineNumber: formData.salesPersons?.[0]?.landlineNumber?.trim() || formData.landlineNumber || null,
//           whatsappNumber: formData.salesPersons?.[0]?.whatsappNumber?.trim() || formData.whatsappNumber || null,
//           alternativeNumber: formData.salesPersons?.[0]?.alternativeNumber?.trim() || formData.alternativeNumber || null,
//           projectHighlights: formData.projectHighlights || null,
//           usp: formData.usp || null,
//           pincode: formData.pincode || null,
//           mapLink: formData.mapLink || null
//         },
//         images: (formData.projectImages || []).filter(
//           (img) => typeof img === 'string' && !isBlobUrl(img)
//         ),
//         amenities: formData.amenities || [],
//         // brochure_url: (() => {
//         //   if (!formData.brochure) return null;
//         //   if (formData.brochure.file) return undefined;
//         //   const url = formData.brochure.url || '';
//         //   if (url && !isBlobUrl(url)) return url;
//         //   return editData?.brochureUrl || editData?.brochure_url || null;
//         // })(),

//         brochure_url: (() => {
//           // Handle multiple brochures
//           if (formData.brochures && formData.brochures.length > 0) {
//             // For edit mode, return existing URLs if they exist
//             const existingUrls = formData.brochures
//               .filter(b => b.isExisting && b.url && !isBlobUrl(b.url))
//               .map(b => b.url);
//             if (existingUrls.length > 0) {
//               return existingUrls;
//             }
//             return undefined; // Will be uploaded separately
//           }
//           // Fallback for single brochure (backward compatibility)
//           if (!formData.brochure) return null;
//           if (formData.brochure.file) return undefined;
//           const url = formData.brochure.url || '';
//           if (url && !isBlobUrl(url)) return url;
//           return editData?.brochureUrl || editData?.brochure_url || null;
//         })(),


//       };

//       let propertyId;

//       if (isEditMode && editData && editData.id) {
//         // UPDATE MODE: Update existing upcoming project
//         try {
//           console.log('Updating upcoming project:', editData.id, propertyData);

//           // Call API directly with the same structure as create
//           const response = await sellerPropertiesAPI.update(editData.id, propertyData);

//           if (!response.success) {
//             throw new Error(response.message || 'Failed to update upcoming project');
//           }

//           propertyId = editData.id;
//           console.log('Upcoming project updated successfully:', propertyId);

//           // Refresh data after successful update
//           if (refreshData) {
//             await refreshData();
//           }
//         } catch (error) {
//           console.error('Upcoming project update failed - Full error:', error);
//           console.error('Error details:', {
//             message: error.message,
//             status: error.status,
//             errors: error.errors,
//             data: error.data,
//             response: error.response
//           });

//           // Extract validation errors if available
//           let errorMessage = 'Failed to update project. Please try again.';

//           // Check various error formats
//           if (error.message) {
//             errorMessage = error.message;
//           } else if (error.errors && typeof error.errors === 'object') {
//             const errorList = Object.values(error.errors).join(', ');
//             errorMessage = `Validation failed: ${errorList}`;
//           } else if (error.data?.errors && typeof error.data.errors === 'object') {
//             const errorList = Object.values(error.data.errors).join(', ');
//             errorMessage = `Validation failed: ${errorList}`;
//           } else if (error.data?.message) {
//             errorMessage = error.data.message;
//           } else if (error.response?.data?.errors) {
//             const errorList = Object.values(error.response.data.errors).join(', ');
//             errorMessage = `Validation failed: ${errorList}`;
//           } else if (error.response?.data?.message) {
//             errorMessage = error.response.data.message;
//           }

//           console.error('Final error message:', errorMessage);
//           throw new Error(errorMessage);
//         }
//       } else {
//         // CREATE MODE: Create new upcoming project
//         let createdProperty;
//         try {
//           console.log('Submitting property data:', propertyData);
//           createdProperty = await addProperty(propertyData);
//           console.log('Property created successfully:', createdProperty);
//         } catch (error) {
//           console.error('Property creation failed - Full error:', error);
//           console.error('Error details:', {
//             message: error.message,
//             status: error.status,
//             errors: error.errors,
//             data: error.data,
//             response: error.response
//           });

//           // Extract validation errors if available
//           let errorMessage = 'Failed to create project. Please try again.';

//           // Check various error formats
//           if (error.message) {
//             errorMessage = error.message;
//           } else if (error.errors && typeof error.errors === 'object') {
//             const errorList = Object.values(error.errors).join(', ');
//             errorMessage = `Validation failed: ${errorList}`;
//           } else if (error.data?.errors && typeof error.data.errors === 'object') {
//             const errorList = Object.values(error.data.errors).join(', ');
//             errorMessage = `Validation failed: ${errorList}`;
//           } else if (error.data?.message) {
//             errorMessage = error.data.message;
//           } else if (error.response?.data?.errors) {
//             const errorList = Object.values(error.response.data.errors).join(', ');
//             errorMessage = `Validation failed: ${errorList}`;
//           } else if (error.response?.data?.message) {
//             errorMessage = error.response.data.message;
//           }

//           console.error('Final error message:', errorMessage);
//           throw new Error(errorMessage);
//         }

//         if (!createdProperty || !createdProperty.id) {
//           throw new Error('Failed to get project ID after creation.');
//         }

//         propertyId = createdProperty.id;
//       }

//       // Upload cover image first so it is stored as the property cover_image
//       if (formData.coverImage?.file && propertyId) {
//         try {
//           const coverResponse = await sellerPropertiesAPI.uploadImage(formData.coverImage.file, propertyId);
//           if (coverResponse.success && coverResponse.data) {
//             const coverUrl = coverResponse.data.image_url || coverResponse.data.url;
//             if (coverUrl) {
//               await sellerPropertiesAPI.update(propertyId, { cover_image: coverUrl });
//               console.log('Cover image uploaded for project:', coverUrl);
//             }
//           }
//         } catch (coverError) {
//           console.error('Cover image upload error:', coverError);
//         }
//       }

//       // Upload images with moderation (images already validated on selection)
//       // Get approved images from validation status
//       const approvedImages = imageValidationStatus.filter(img => img.status === 'approved');

//       if (approvedImages.length > 0) {
//         setUploadingImages(true);
//         try {
//           // Upload each approved image with property ID
//           const uploadPromises = approvedImages.map(async (imgObj, index) => {
//             try {
//               console.log(`Uploading image ${index + 1}/${approvedImages.length}:`, imgObj.file.name);
//               const response = await sellerPropertiesAPI.uploadImage(imgObj.file, propertyId);
//               console.log(`Image ${index + 1} upload response:`, response);

//               if (response.success && response.data) {
//                 const imageUrl = response.data.image_url || response.data.url;
//                 if (imageUrl) {
//                   return { success: true, url: imageUrl };
//                 }
//               }
//               return { success: false, error: response.message || 'Upload failed - no URL returned' };
//             } catch (error) {
//               console.error(`Image ${index + 1} upload error:`, error);
//               return {
//                 success: false,
//                 error: error.message || error.status || 'Upload failed',
//                 details: error
//               };
//             }
//           });

//           const results = await Promise.all(uploadPromises);
//           const successful = results.filter(r => r.success);
//           const failed = results.filter(r => !r.success);

//           console.log(`Image upload results: ${successful.length} successful, ${failed.length} failed`);

//           if (failed.length > 0) {
//             console.warn('Failed image uploads:', failed);
//             // Show warning but don't fail the entire project creation
//             const errorMessages = failed.map((f, i) => `Image ${i + 1}: ${f.error}`).join('; ');
//             console.warn(`Some images failed to upload: ${errorMessages}`);
//           }

//           if (successful.length === 0 && approvedImages.length > 0) {
//             console.warn('All images failed to upload, but project was created successfully');
//           }
//         } catch (uploadError) {
//           console.error('Image upload batch error:', uploadError);
//           // Don't throw - project was created successfully
//         } finally {
//           setUploadingImages(false);
//         }
//       } else if (imageFiles.length > 0) {
//         // Images were selected but none approved
//         console.warn('No approved images found. Project created without images.');
//       }

//       // if (formData.brochure?.file && propertyId) {
//       //   try {
//       //     const brochureResponse = await sellerPropertiesAPI.uploadBrochure(
//       //       formData.brochure.file,
//       //       propertyId
//       //     );
//       //     if (brochureResponse.success && brochureResponse.data?.url) {
//       //       console.log('Brochure uploaded for project:', brochureResponse.data.url);
//       //     }
//       //   } catch (brochureError) {
//       //     console.error('Brochure upload error:', brochureError);
//       //   }
//       // }

//       if (formData.brochures && formData.brochures.length > 0 && propertyId) {
//         try {
//           // Filter only new brochures that have a file (not existing ones)
//           const newBrochures = formData.brochures.filter(b => b.file && !b.isExisting);
          
//           if (newBrochures.length > 0) {
//             console.log(`Uploading ${newBrochures.length} brochures...`);
            
//             // Upload each brochure
//             const uploadPromises = newBrochures.map(async (brochure, index) => {
//               try {
//                 console.log(`Uploading brochure ${index + 1}/${newBrochures.length}:`, brochure.file.name);
//                 const response = await sellerPropertiesAPI.uploadBrochure(
//                   brochure.file,
//                   propertyId
//                 );
//                 console.log(`Brochure ${index + 1} upload response:`, response);
                
//                 if (response.success && response.data?.url) {
//                   return { success: true, url: response.data.url, name: brochure.name };
//                 }
//                 return { success: false, error: response.message || 'Upload failed' };
//               } catch (error) {
//                 console.error(`Brochure ${index + 1} upload error:`, error);
//                 return { 
//                   success: false, 
//                   error: error.message || 'Upload failed',
//                   name: brochure.name
//                 };
//               }
//             });
            
//             const results = await Promise.all(uploadPromises);
//             const successful = results.filter(r => r.success);
//             const failed = results.filter(r => !r.success);
            
//             console.log(`Brochure upload results: ${successful.length} successful, ${failed.length} failed`);
            
//             if (failed.length > 0) {
//               console.warn('Failed brochure uploads:', failed);
//               const errorMessages = failed.map(f => `${f.name}: ${f.error}`).join('; ');
//               console.warn(`Some brochures failed to upload: ${errorMessages}`);
//             }
//           }
//         } catch (brochureError) {
//           console.error('Brochure upload batch error:', brochureError);
//           // Don't throw - project was created successfully
//         }
//       }
//       // ========== END BROCHURE UPLOAD ==========
      
//       setUploadingImages(false);
//       setIsPublished(true); // Mark as published before closing
//       alert(isEditMode
//         ? 'Upcoming project updated successfully!'
//         : 'Upcoming project published successfully! It is now visible to buyers.');
      
//       // Refresh data after successful update/create
//       if (refreshData) {
//         await refreshData();
//       }
      
//       onClose();

//       // setUploadingImages(false);
//       // setIsPublished(true); // Mark as published before closing
//       // alert(isEditMode
//       //   ? 'Upcoming project updated successfully!'
//       //   : 'Upcoming project published successfully! It is now visible to buyers.');

//       // // Refresh data after successful update/create
//       // if (refreshData) {
//       //   await refreshData();
//       // }

//       onClose();
//     } catch (error) {
//       console.error('Project save error:', error);
//       alert(error.message || 'Failed to save project. Please try again.');
//     } finally {
//       setIsSubmitting(false);
//       setUploadingImages(false);
//     }
//   };

//   const renderStepIndicator = () => (
//     <div className="step-indicator">
//       {STEPS.map((step, idx) => {
//         const isCompleted = isStepCompleted(step.id);
//         const isClickable = isCompleted || step.id === currentStep;

//         return (
//           <div
//             key={step.id}
//             className={`step-item ${currentStep === step.id ? 'active' : ''} ${isCompleted ? 'completed' : ''} ${isClickable ? 'clickable' : ''}`}
//           >
//             <div
//               className="step-circle"
//               onClick={() => isClickable && handleStepClick(step.id)}
//               style={{ cursor: isClickable ? 'pointer' : 'default' }}
//             >
//               {isCompleted ? (
//                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
//                   <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
//                 </svg>
//               ) : (
//                 <span>{step.icon}</span>
//               )}
//             </div>
//             <span className="step-title">{step.title}</span>
//             {idx < STEPS.length - 1 && <div className="step-line" />}
//           </div>
//         );
//       })}
//     </div>
//   );

//   // Step 1: Basic Project Information
//   const renderStep1 = () => (
//     <div className="step-content">
//       <div style={{ marginBottom: '1.5rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border-color)' }}>
//         <span style={{ fontSize: '0.85rem', color: 'var(--text-muted)', fontWeight: '500' }}>
//           Step {currentStep} of {STEPS.length} — {STEPS[currentStep - 1].title}
//         </span>
//       </div>
//       <h3 className="step-heading">Basic Details</h3>
//       <p className="step-subheading">Let's start with the basic details of your upcoming project</p>

//       <div className="form-group">
//         <label>Project Name <span className="required">*</span></label>
//         <input
//           type="text"
//           value={formData.projectName}
//           onChange={(e) => handleChange('projectName', e.target.value)}
//           placeholder="e.g., Green Valley Residency"
//           className={errors.projectName ? 'error' : ''}
//         />
//         {errors.projectName && <span className="error-text">{errors.projectName}</span>}
//       </div>

//       <div className="form-group">
//         <label>Builder / Developer Name</label>
//         {/* <input
//           type="text"
//           value={formData.builderName || builderName}
//           onChange={(e) => handleChange('builderName', e.target.value)}
//           placeholder="Auto-filled from your account"
//           //disabled
//           style={{ background: '#f3f4f6' }}
//         /> */}
//   <input
//   type="text"
//   value={formData.builderName}
//   onChange={(e) =>
//     handleChange('builderName', e.target.value.toUpperCase())
//   }
//   placeholder="Enter Builder/Developer Name"
//   style={{ background: '#ffffff' }}
// />
//       </div>

//       <div className="form-group">
//         <label>Project Type <span className="required">*</span></label>
//         <div className={`property-type-grid ${errors.projectType ? 'error' : ''}`}>
//           {PROJECT_TYPES.map(type => (
//             <button
//               key={type.value}
//               type="button"
//               className={`property-type-btn ${formData.projectType === type.value ? 'active' : ''}`}
//               onClick={() => handleChange('projectType', type.value)}
//             >
//               <span className="type-icon">{type.icon}</span>
//               <span className="type-label">{type.value}</span>
//             </button>
//           ))}
//         </div>
//         {errors.projectType && <span className="error-text">{errors.projectType}</span>}
//       </div>

//       <div className="form-group">
//         <label>Project Status <span className="required">*</span></label>
//         <select
//           value={formData.projectStatus}
//           onChange={(e) => handleChange('projectStatus', e.target.value)}
//           className={errors.projectStatus ? 'error' : ''}
//         >
//           {PROJECT_STATUS_OPTIONS.map(option => (
//             <option key={option.value} value={option.value}>{option.label}</option>
//           ))}
//         </select>
//         {errors.projectStatus && <span className="error-text">{errors.projectStatus}</span>}
//       </div>

//       <div className="form-group">
//         <label>RERA Number (Optional but recommended)</label>
//         <input
//           type="text"
//           value={formData.reraNumber}
//           onChange={(e) => handleChange('reraNumber', e.target.value)}
//           placeholder="e.g., RERA/PKR/2019/001234"
//         />
//       </div>

//     </div>
//   );

//   // Step 2: Location Details
//   const renderStep2 = () => (
//     <div className="step-content">
//       <div style={{ marginBottom: '1.5rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border-color)' }}>
//         <span style={{ fontSize: '0.85rem', color: 'var(--text-muted)', fontWeight: '500' }}>
//           Step {currentStep} of {STEPS.length} — {STEPS[currentStep - 1].title}
//         </span>
//       </div>
//       <h3 className="step-heading">Location</h3>
//       <p className="step-subheading">Where is your project located?</p>

//       <div className="form-group">
//         <label>Location <span className="required">*</span></label>
//         <LocationAutoSuggest
//           placeholder="Enter locality, area or landmark"
//           value={formData.location || formData.area || ''}
//           onChange={handleLocationDropdownSelect}
//           className={errors.location || errors.area ? 'error' : ''}
//           error={errors.location || errors.area}
//         />
//         {(errors.location || errors.area) && (
//           <span className="error-text">{errors.location || errors.area}</span>
//         )}
//       </div>

//       {/* Location Picker Button */}
//       <div className="form-group-map">
//         <label style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', width: '100%' }}>Project Location on Map <span className='required'>*</span></label>
//         {!formData.latitude || !formData.longitude ? (
//           <>
//             <button
//               type="button"
//               className="location-picker-btn"
//               onClick={() => setShowLocationPicker(true)}
//               style={{
//                 width: '100%',
//                 padding: '0.875rem 1rem',
//                 display: 'flex',
//                 alignItems: 'flex-start',
//                 justifyContent: 'flex-start',
//                 gap: '0.5rem',
//                 background: 'white',
//                 border: '2px solid var(--border-color)',
//                 borderRadius: 'var(--radius-md)',
//                 cursor: 'pointer',
//                 fontSize: '0.95rem',
//                 fontWeight: '600',
//                 color: 'var(--text-primary)',
//                 transition: 'all var(--transition-fast)'
//               }}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.borderColor = 'var(--accent-color)';
//                 e.currentTarget.style.color = 'var(--accent-color)';
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.borderColor = 'var(--border-color)';
//                 e.currentTarget.style.color = 'var(--text-primary)';
//               }}
//             >
//               <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
//                 <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" />
//                 <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2" />
//               </svg>
//               <span>Add Location on Map</span>
//             </button>
//             <span className="hint-text" style={{
//               display: 'block',
//               marginTop: '0.5rem',
//               fontSize: '0.85rem',
//               color: 'var(--text-muted)'
//             }}>
//               Select exact location on map for better visibility
//             </span>
//           </>
//         ) : (
//           <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//             <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
//               <span className="location-icon" style={{ fontSize: '18px' }}>📍</span>
//               <div style={{ flex: 1 }}>
//                 <span style={{ fontSize: '0.875rem', color: '#059669', fontWeight: '500' }}>
//                   Location set on map
//                 </span>
//               </div>
//             </div>
//             <small className="location-picker-coordinates" style={{
//               marginLeft: '26px',
//               fontSize: '0.75rem',
//               color: '#059669',
//               fontFamily: 'monospace'
//             }}>
//               Coordinates: {parseFloat(formData.latitude).toFixed(6)}, {parseFloat(formData.longitude).toFixed(6)}
//             </small>



            
//             <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
//               <button
//                 type="button"
//                 className="location-picker-change-btn"
//                 onClick={() => setShowLocationPicker(true)}
//                 style={{
//                   width: '100%',
//                 padding: '0.875rem 1rem',
//                 display: 'flex',
//                 alignItems: 'flex-start',
//                 justifyContent: 'flex-start',
//                 gap: '0.5rem',
//                 background: '',
//                 border: '2px solid var(--border-color)',
//                 borderRadius: 'var(--radius-md)',
//                 cursor: 'pointer',
//                 fontSize: '0.95rem',
//                 fontWeight: '600',
//                 color: 'var(--text-primary)',
//                 transition: 'all var(--transition-fast)'
//                 }}
//               >
//                   <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
//                 <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" />
//                 <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2" />
//               </svg>
//               Add Location on Map
//               </button>




//               {/* <button
//                 type="button"
//                 onClick={() => {
//                   setFormData(prev => ({ ...prev, latitude: '', longitude: '' }));
//                 }}
//                 style={{
//                   padding: '6px 12px',
//                   fontSize: '0.875rem',
//                   backgroundColor: '#fee2e2',
//                   border: '1px solid #fecaca',
//                   borderRadius: '6px',
//                   cursor: 'pointer',
//                   color: '#991b1b',
//                   fontWeight: '500'
//                 }}
//               >
//                 Remove
//               </button> */}
//             </div>
//           </div>
//         )}
//       </div>

//       {/* State and Additional Address Fields */}
//       <div className={`form-row two-cols ${stateDropdownOpen ? 'state-dropdown-row-active' : ''}`}>
//         <div className={`form-group ${stateDropdownOpen ? 'state-dropdown-open' : ''}`}>
//           <label>
//             State <span className="required">*</span>
//             {stateAutoFilled && (
//               <span style={{
//                 fontSize: '0.75rem',
//                 color: '#059669',
//                 marginLeft: '8px',
//                 fontWeight: 'normal'
//               }}>
//                 (Auto-filled from location)
//               </span>
//             )}
//           </label>
//           <div style={{ position: 'relative' }} ref={stateDropdownRef}>
//             <input
//               type="text"
//               placeholder="Enter state or select from list"
//               value={formData.state || ''}
//               onChange={(e) => {
//                 handleChange('state', e.target.value);
//                 if (stateAutoFilled && e.target.value !== formData.state) setStateAutoFilled(false);
//                 setStateDropdownOpen(true);
//               }}
//               onFocus={() => !stateAutoFilled && setStateDropdownOpen(true)}
//               className={errors.state ? 'error' : ''}
//               readOnly={stateAutoFilled}
//               disabled={stateAutoFilled}
//               style={stateAutoFilled ? {
//                 background: '#f3f4f6',
//                 cursor: 'not-allowed',
//                 color: '#374151'
//               } : {}}
//               autoComplete="off"
//             />
//             {/* {stateAutoFilled && (
//               <button
//                 type="button"
//                 onClick={() => {
//                   setStateAutoFilled(false);
//                   setStateDropdownOpen(true);
//                 }}
//                 style={{
//                   position: 'absolute',
//                   right: '8px',
//                   top: '50%',
//                   transform: 'translateY(-50%)',
//                   background: 'none',
//                   border: 'none',
//                   color: '#7c3aed',
//                   cursor: 'pointer',
//                   fontSize: '0.75rem',
//                   fontWeight: '600',
//                   padding: '4px 8px',
//                   borderRadius: '4px',
//                   zIndex: 10
//                 }}
//                 title="Edit state manually"
//               >
//                 Edit
//               </button>
//             )}
//             {!stateAutoFilled && stateDropdownOpen && (formData.state || '').trim().length >= 2 && (
//               <ul
//                 className="state-suggestions-dropdown"
//                 style={{
//                   position: 'absolute',
//                   top: '100%',
//                   left: 0,
//                   right: 0,
//                   margin: 0,
//                   padding: 0,
//                   listStyle: 'none',
//                   background: '#fff',
//                   border: '1px solid var(--border-color)',
//                   borderRadius: '8px',
//                   boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//                   maxHeight: '220px',
//                   overflowY: 'auto',
//                   zIndex: 100
//                 }}
//               >
//                 {INDIAN_STATES.filter(s =>
//                   s.toLowerCase().includes((formData.state || '').toLowerCase())
//                 ).slice(0, 15).map(state => (
//                   <li
//                     key={state}
//                     onClick={() => {
//                       handleChange('state', state);
//                       setStateDropdownOpen(false);
//                       if (errors.state) setErrors(prev => ({ ...prev, state: null }));
//                     }}
//                     style={{
//                       padding: '10px 12px',
//                       cursor: 'pointer',
//                       fontSize: '0.9rem',
//                       borderBottom: '1px solid #f3f4f6'
//                     }}
//                     onMouseEnter={(e) => { e.currentTarget.style.background = '#f3f4f6'; }}
//                     onMouseLeave={(e) => { e.currentTarget.style.background = '#fff'; }}
//                   >
//                     {state}
//                   </li>
//                 ))}
//                 {INDIAN_STATES.filter(s =>
//                   s.toLowerCase().includes((formData.state || '').toLowerCase())
//                 ).length === 0 && (
//                     <li style={{ padding: '10px 12px', color: '#6b7280', fontSize: '0.9rem' }}>
//                       No matching state
//                     </li>
//                   )}
//               </ul>
//             )} */}
//           </div>
//           {errors.state && <span className="error-text">{errors.state}</span>}
//         </div>

//         <div className="form-group">
//           <label>Additional Address <span className="required">*</span></label>
//           <input
//             type="text"
//             placeholder="Enter additional address details"
//             value={formData.fullAddress || ''}
//             onChange={(e) => handleChange('fullAddress', e.target.value)}
//             className={errors.fullAddress ? 'error' : ''}
//           />
//           {errors.fullAddress && <span className="error-text">{errors.fullAddress}</span>}
//         </div>
//       </div>

//       <div className="form-group">
//         <label>Pincode <span className="required">*</span></label>
//         <input
//           type="text"
//           value={formData.pincode || ''}
//           onChange={(e) => handleChange('pincode', e.target.value.replace(/\D/g, ''))}
//           placeholder="Enter 6-digit pincode"
//           maxLength={6}
//           className={errors.pincode ? 'error' : ''}
//         />
//         {errors.pincode && <span className="error-text">{errors.pincode}</span>}
//       </div>
//     </div>
//   );

//   // Step 3: Configuration & Inventory — options and fields depend on project type
//   const configurationOptions = formData.projectType
//     ? (CONFIGURATION_BY_PROJECT_TYPE[formData.projectType] || [])
//     : [];
//   const pt = formData.projectType;
//   const isPlotOrLand = pt === "Plot / Land / Indusrtial Property";
//   const isWarehouse = pt === "Warehouse / Godown";
//   const isCommercialOffice = pt === "Commercial Office";
//   const isVilla = pt === "Villa / Banglow";
//   const isIndependentHouse = pt === "Independent House";
//   const isPGHostel = pt === "PG / Hostel";
//   const isApartment = pt === "Apartment";
//   // Area label by type
//   const areaLabel = isPlotOrLand ? "Plot Size Range (sq.ft)" : (isCommercialOffice || pt === "Commercial Shop") ? "Area Range" : isWarehouse ? "Built-up Area Range" : isPGHostel ? "Carpet Area Range" : "Carpet Area Range (sq.ft)";
//   const areaSuffix = "sq.ft";

//   const renderStep3 = () => (
//     <div className="step-content">
//       <div style={{ marginBottom: '1.5rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border-color)' }}>
//         <span style={{ fontSize: '0.85rem', color: 'var(--text-muted)', fontWeight: '500' }}>
//           Step {currentStep} of {STEPS.length} — {STEPS[currentStep - 1].title}
//         </span>
//       </div>
//       <h3 className="step-heading">Configuration</h3>
//       <p className="step-subheading">
//         {formData.projectType
//           ? `Configurations for ${formData.projectType}`
//           : "Select project type in Step 1 to see configuration options"}
//       </p>

//       <div className="form-group">
//         <label>Property Configurations <span className="required">*</span></label>
//         {configurationOptions.length > 0 ? (
//           <>
//             <div className={`amenities-grid ${errors.configurations ? 'error' : ''}`}>
//               {configurationOptions.map(config => (
//                 <button
//                   key={config}
//                   type="button"
//                   className={`amenity-btn ${formData.configurations.includes(config) ? 'active' : ''}`}
//                   onClick={() => toggleConfiguration(config)}
//                 >
//                   {config}
//                 </button>
//               ))}
//             </div>
//             {errors.configurations && <span className="error-text">{errors.configurations}</span>}
//           </>
//         ) : (
//           <p className="step-subheading" style={{ marginTop: '0.5rem', color: 'var(--text-muted)' }}>
//             Please select a project type in Step 1 (Basic Details) first.
//           </p>
//         )}
//       </div>

//       <div className="form-group">
//         <label>{areaLabel} <span className="required">*</span></label>
//         <div className="input-with-suffix">
//           <input
//             type="text"
//             value={formData.carpetAreaRange}
//             onChange={(e) => handleCarpetAreaChange(e.target.value)}
//             placeholder={isPlotOrLand ? "e.g., 500 - 2000" : "e.g., 650 - 1200"}
//             className={errors.carpetAreaRange ? 'error' : ''}
//           />
//           <span className="suffix">{areaSuffix}</span>
//         </div>
//         {errors.carpetAreaRange && <span className="error-text">{errors.carpetAreaRange}</span>}
//       </div>

//       {/* Apartment: Number of Towers, Units per floor (optional) */}
//       {isApartment && (
//         <div className="form-row">
//           <div className="form-group">
//             <label>Number of Towers</label>
//             <input
//               type="number"
//               value={formData.numberOfTowers}
//               onChange={(e) => handleChange('numberOfTowers', e.target.value)}
//               placeholder="e.g., 3"
//               min="1"
//             />
//           </div>
//           <div className="form-group">
//             <label>Units per floor </label>
//             <input
//               type="number"
//               value={formData.unitsPerFloor}
//               onChange={(e) => handleChange('unitsPerFloor', e.target.value)}
//               placeholder="e.g., 4"
//               min="1"
//             />
//           </div>
//         </div>
//       )}

//       {/* Villa: Number of Villas */}
//       {isVilla && (
//         <div className="form-group">
//           <label>Number of Villas</label>
//           <input
//             type="number"
//             value={formData.numberOfVillas}
//             onChange={(e) => handleChange('numberOfVillas', e.target.value)}
//             placeholder="e.g., 24"
//             min="1"
//           />
//         </div>
//       )}

//       {/* Independent House: Total Units */}
//       {isIndependentHouse && (
//         <div className="form-group">
//           <label>Total Units</label>
//           <input
//             type="number"
//             value={formData.totalUnits}
//             onChange={(e) => handleChange('totalUnits', e.target.value)}
//             placeholder="e.g., 50"
//             min="1"
//           />
//         </div>
//       )}

//       {/* Row House / Farm House: Total Units */}
//       {pt === "Row House/ Farm House" && (
//         <div className="form-group">
//           <label>Total Units</label>
//           <input
//             type="number"
//             value={formData.totalUnits}
//             onChange={(e) => handleChange('totalUnits', e.target.value)}
//             placeholder="e.g., 30"
//             min="1"
//           />
//         </div>
//       )}

//       {/* Penthouse: Number of Towers (optional for standalone) */}
//       {pt === "Penthouse" && (
//         <div className="form-group">
//           <label>Number of Towers</label>
//           <input
//             type="number"
//             value={formData.numberOfTowers}
//             onChange={(e) => handleChange('numberOfTowers', e.target.value)}
//             placeholder="e.g., 2"
//             min="1"
//           />
//         </div>
//       )}

//       {/* Studio Apartment: Number of Towers, Units per floor (optional) */}
//       {pt === "Studio Apartment" && (
//         <div className="form-row">
//           <div className="form-group">
//             <label>Number of Towers</label>
//             <input
//               type="number"
//               value={formData.numberOfTowers}
//               onChange={(e) => handleChange('numberOfTowers', e.target.value)}
//               placeholder="e.g., 1"
//               min="1"
//             />
//           </div>
//           <div className="form-group">
//             <label>Units per floor (optional)</label>
//             <input
//               type="number"
//               value={formData.unitsPerFloor}
//               onChange={(e) => handleChange('unitsPerFloor', e.target.value)}
//               placeholder="e.g., 8"
//               min="1"
//             />
//           </div>
//         </div>
//       )}

//       {/* Plot / Land: Number of Plots — no towers */}
//       {isPlotOrLand && (
//         <div className="form-group">
//           <label>Number of Plots</label>
//           <input
//             type="number"
//             value={formData.numberOfPlots}
//             onChange={(e) => handleChange('numberOfPlots', e.target.value)}
//             placeholder="e.g., 100"
//             min="1"
//           />
//         </div>
//       )}

//       {/* Commercial Office: Number of Floors / Towers */}
//       {isCommercialOffice && (
//         <div className="form-group">
//           <label>Number  Towers</label>
//           <input
//             type="number"
//             value={formData.numberOfTowers}
//             onChange={(e) => handleChange('numberOfTowers', e.target.value)}
//             placeholder="e.g., 5"
//             min="1"
//           />
//         </div>
        
//       )}
//        {isCommercialOffice && (
//         <div className="form-group">
//           <label>Number of Floors</label>
//           {/* <input
//             type="number"
//             value={formData.numberOfTowers}
//             onChange={(e) => handleChange('numberOfTowers', e.target.value)}
//             placeholder="e.g., 5"
//             min="1"
//           /> */}
//            <input
//               type="number"
//               value={formData.unitsPerFloor}
//               onChange={(e) => handleChange('unitsPerFloor', e.target.value)}
//               placeholder="e.g 4"
//               min="1"
//             />
//         </div>
        
//       )}

//       {/* PG / Hostel: Bed Capacity — no towers */}
//       {isPGHostel && (
//         <div className="form-group">
//           <label>Bed Capacity</label>
//           <input
//             type="number"
//             value={formData.bedCapacity}
//             onChange={(e) => handleChange('bedCapacity', e.target.value)}
//             placeholder="e.g., 50"
//             min="1"
//           />
//         </div>
//       )}

//       {/* Warehouse: Loading Docks (optional) */}
//       {isWarehouse && (
//         <div className="form-group">
//           <label>Loading Docks (optional)</label>
//           <input
//             type="number"
//             value={formData.loadingDocks}
//             onChange={(e) => handleChange('loadingDocks', e.target.value)}
//             placeholder="e.g., 4"
//             min="0"
//           />
//         </div>
//       )}
//     </div>
//   );

//   // Step 4: Pricing & Amenities
//   const renderStep4 = () => (
//     <div className="step-content">
//       <div style={{ marginBottom: '1.5rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border-color)' }}>
//         <span style={{ fontSize: '0.85rem', color: 'var(--text-muted)', fontWeight: '500' }}>
//           Step {currentStep} of {STEPS.length} — {STEPS[currentStep - 1].title}
//         </span>
//       </div>
//       <h3 className="step-heading">Pricing & Amenities</h3>
//       <p className="step-subheading">Set pricing details and select amenities for your project</p>

//       <div className="form-group">
//         <label>Starting Price <span className="required">*</span></label>
//         <div className="price-input-wrapper">
//           <span className="currency">₹</span>
//           <input
//             type="text"
//             value={formData.startingPrice}
//             onChange={(e) => handlePriceChange('startingPrice', e.target.value)}
//             placeholder="e.g., 4500000 or 45-60"
//             className={errors.startingPrice ? 'error' : ''}
//           />
//         </div>
//         {formData.startingPrice && (
//           <span className="price-words">
//             Price: {formatPriceInWords(formData.startingPrice)}
//           </span>
//         )}
//         {errors.startingPrice && <span className="error-text">{errors.startingPrice}</span>}
//       </div>

//       <div className="form-row">
//         <div className="form-group">
//           <label>Price per Sq.ft (Optional)</label>
//           <div className="price-input-wrapper">
//             <span className="currency">₹</span>
//             <input
//               type="text"
//               value={formData.pricePerSqft}
//               onChange={(e) => handlePriceChange('pricePerSqft', e.target.value)}
//               placeholder="e.g., 5000 or 5000-6000"
//             />
//           </div>
//           {formData.pricePerSqft && (
//             <span className="price-words">
//               Price: {formatPriceInWords(formData.pricePerSqft)}/sq.ft
//             </span>
//           )}
//         </div>

//         <div className="form-group">
//           <label>Booking Amount Price (Optional)</label>
//           <div className="price-input-wrapper">
//             <span className="currency">₹</span>
//             <input
//               type="text"
//               value={formData.bookingAmount}
//               onChange={(e) => handlePriceChange('bookingAmount', e.target.value)}
//               placeholder="e.g., 200000 or 1.5-2.5"
//             />
//           </div>
//           {formData.bookingAmount && (
//             <span className="price-words">
//               Price: {formatPriceInWords(formData.bookingAmount)}
//             </span>
//           )}
//         </div>
//       </div>

//       <div className={`form-row ${launchDatePickerOpen || possessionDatePickerOpen ? 'state-dropdown-row-active' : ''}`}>
//         <div className={`form-group ${launchDatePickerOpen ? 'state-dropdown-open' : ''}`}>
//           <label>Launch Date</label>
//           <ModernDatePicker
//             value={formData.expectedLaunchDate}
//             onChange={(val) => handleChange('expectedLaunchDate', val)}
//             placeholder="Select launch date"
//             onOpenChange={setLaunchDatePickerOpen}
//           />
//         </div>

//         <div className={`form-group ${possessionDatePickerOpen ? 'state-dropdown-open' : ''}`}>
//           <label>Expected Possession Date</label>
//           <ModernDatePicker
//             value={formData.expectedPossessionDate}
//             onChange={(val) => handleChange('expectedPossessionDate', val)}
//             placeholder="Select possession date"
//             onOpenChange={setPossessionDatePickerOpen}
//           />
//         </div>
//       </div>

//       <div className="form-group" style={{ marginTop: '2rem' }}>
//         <label>Amenities <span className="required">*</span></label>
//         <div className={`amenities-grid ${errors.amenities ? 'error' : ''}`}>
//           {AMENITIES.map(amenity => (
//             <button
//               key={amenity.id}
//               type="button"
//               className={`amenity-btn ${formData.amenities.includes(amenity.id) ? 'active' : ''}`}
//               onClick={() => toggleAmenity(amenity.id)}
//             >
//               <span className="amenity-icon">{amenity.icon}</span>
//               <span className="amenity-label">{amenity.label}</span>
//               {formData.amenities.includes(amenity.id) && (
//                 <span className="check-icon">✓</span>
//               )}
//             </button>
//           ))}
//         </div>
//         {errors.amenities && <span className="error-text">{errors.amenities}</span>}
//       </div>

//       <div className="form-group" data-field="description">
//         <div className="seller-popup-description-header">
//           <label>Project Description <span className="required">*</span></label>
//           <button
//             type="button"
//             className="generate-description-btn"
//             onClick={handleGenerateDescription}
//           >
//             Generate description
//           </button>
//         </div>
//         <textarea
//           name="description"
//           value={formData.description}
//           onChange={(e) => handleChange('description', e.target.value)}
//           placeholder="Describe your upcoming project in detail (minimum 100 characters). Mention configurations, location advantages, amenities, and possession timeline."
//           rows={6}
//           maxLength={1000}
//           className={errors.description ? 'error' : ''}
//         />
//         <span className="char-count" style={{
//           color: (formData.description || '').length < 100 ? '#dc2626' : 'inherit'
//         }}>
//           Characters: {(formData.description || '').length}/1000 (min: 100)
//         </span>
//         {errors.description && <span className="error-text">{errors.description}</span>}
//       </div>
//     </div>
//   );

//   // Step 5: Media & Contact
//   const renderStep5 = () => (
//     <div className="step-content">
//       <div style={{ marginBottom: '1.5rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border-color)' }}>
//         <span style={{ fontSize: '0.85rem', color: 'var(--text-muted)', fontWeight: '500' }}>
//           Step {currentStep} of {STEPS.length} — {STEPS[currentStep - 1].title}
//         </span>
//       </div>
//       <h3 className="step-heading">Media & Contact</h3>
//       <p className="step-subheading">Upload project images and provide contact information</p>

//       <div className="form-group">
//         <label>Project Cover Image <span className="required">*</span></label>
//         <input
//           type="file"
//           accept="image/*"
//           onChange={(e) => {
//             const file = e.target.files?.[0];
//             if (file) {
//               const url = URL.createObjectURL(file);
//               handleChange('coverImage', { file, url });
//             }
//           }}
//         />
//         {!formData.coverImage?.file && !formData.coverImage?.isExisting && (
//           <div style={{
//             marginTop: '8px',
//             padding: '8px 12px',
//             background: '#fef2f2',
//             border: '1px solid #fecaca',
//             borderRadius: '4px',
//             color: '#991b1b',
//             fontSize: '0.875rem'
//           }}>
//             Please add cover image first
//           </div>
//         )}
//         {formData.coverImage && (
//           <div style={{ marginTop: '10px' }}>
//             <img src={formData.coverImage.url} alt="Cover" style={{ maxWidth: '200px', maxHeight: '200px', borderRadius: '8px' }} />
//           </div>
//         )}
//         {errors.coverImage && <span className="error-text">{errors.coverImage}</span>}
//       </div>

//       <div className="form-group">
//         <label>Project Images <span className="required">*</span> (Concept images / 3D renders allowed)</label>
//         <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
//           <input
//             ref={imagesRef}
//             type="file"
//             accept="image/*"
//             multiple
//             onChange={handleImageUpload}
//             style={{ display: 'none' }}
//             disabled={formData.projectImages?.length >= 20}
//           />
//           <button
//             type="button"
//             className="cancel-btn"
//             onClick={() => imagesRef.current?.click()}
//             disabled={formData.projectImages?.length >= 20}
//             style={{
//               background: formData.projectImages?.length >= 20 ? '#f3f4f6' : 'white',
//               border: '2px solid var(--border-color)',
//               cursor: formData.projectImages?.length >= 20 ? 'not-allowed' : 'pointer',
//               opacity: formData.projectImages?.length >= 20 ? 0.6 : 1
//             }}
//           >
//             📷 Upload Images (Max 20)
//           </button>
//           <span style={{
//             fontSize: '0.875rem',
//             color: formData.projectImages?.length < 3 ? '#dc2626' : '#059669',
//             fontWeight: '500'
//           }}>
//             Images uploaded: {formData.projectImages?.length || 0} / 20
//           </span>
//         </div>
//         {formData.projectImages?.length < 3 && (
//           <div style={{
//             marginBottom: '8px',
//             padding: '8px 12px',
//             // background: '#fef2f2',
//             border: '1px solid #fecaca',
//             borderRadius: '4px',
//             color: '#991b1b',
//             fontSize: '0.875rem'
//           }}>
//             ⚠️ Please upload at least 3 images to continue.
//           </div>
//         )}
//         {errors.projectImages && <span className="error-text">{errors.projectImages}</span>}

//         <div className="image-preview-grid" style={{ marginTop: '15px' }}>
//           {formData.projectImages.map((img, idx) => {
//             const validationStatus = imageValidationStatus[idx] || { status: 'pending', errorMessage: '' };

//             return (
//               <div key={idx} className={`preview-item image-validation-item ${validationStatus.status}`}>
//                 <img src={img} alt={`Project ${idx + 1}`} />

//                 {/* Validation Overlays */}
//                 {validationStatus.status === 'checking' && (
//                   <div className="validation-overlay checking-overlay">
//                     <div className="overlay-content">
//                       <div className="spinner"></div>
//                       <p className="status-message-text">Checking...</p>
//                     </div>
//                   </div>
//                 )}


// {validationStatus.status === 'approved' && (
//   <div className="validation-overlay approved-overlay" style={{ 
//     background: 'transparent',
//     pointerEvents: 'none'
//   }}>
//     <div className="overlay-content" style={{ 
//       display: 'flex', 
//       flexDirection: 'column', 
//       alignItems: 'center',
//       background: 'rgba(0,0,0,0.6)',
//       padding: '8px 12px',
//       borderRadius: '8px',
//       gap: '4px'
//     }}>
//       {/* <svg className="checkmark" width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ stroke: '#4CAF50' }}>
//         <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
//       </svg> */}
//       <p className="approved-text" style={{ color: '#4CAF50', fontSize: '11px', fontWeight: '600', margin: 0 }}>Approved</p>
//     </div>
//   </div>
// )}



//                 {/* {validationStatus.status === 'approved' && (
//                   <div className="validation-overlay approved-overlay" style={{ 
//                     background: 'transparent',
//                     pointerEvents: 'none'
//                   }}>
//                     <div className="overlay-content">
//                       <svg className="checkmark" width="32" height="32" viewBox="0 0 24 24" fill="none">
//                         <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
//                       </svg>
//                       <p className="approved-text">Approved</p>
//                     </div>
//                   </div>
//                 )} */}

//                 {validationStatus.status === 'rejected' && (
//                   <div className="validation-overlay rejected-overlay">
//                     <div className="overlay-content">
//                       <svg className="x-icon" width="32" height="32" viewBox="0 0 24 24" fill="none">
//                         <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
//                       </svg>
//                       <p className="rejected-title">REJECTED</p>
//                       <p className="rejected-message">{validationStatus.errorMessage || 'Image rejected'}</p>
//                       <button
//                         type="button"
//                         className="remove-rejected-btn"
//                         onClick={() => removeImage(idx)}
//                       >
//                         Remove & Try Again
//                       </button>
//                     </div>
//                   </div>
//                 )}

//                 {validationStatus.status === 'approved' && (
//                   <div className="status-badge approved-badge">
//                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
//                       <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                     </svg>
//                   </div>
//                 )}

//                 {validationStatus.status === 'rejected' && (
//                   <div className="status-badge rejected-badge">
//                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
//                       <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
//                     </svg>
//                   </div>
//                 )}

            
//                 {validationStatus.status !== 'checking' && (
//                   <button
//                     type="button"
//                     className="remove-image-btn"
//                     onClick={() => removeImage(idx)}
//                     title="Remove image"
//                   >
//                     ✕
//                   </button>
//                 )}
//               </div>
//             );
//           })}
//         </div>

//         {/* Warning if rejected images exist */}
//         {imageValidationStatus.some(img => img.status === 'rejected') && (
//           <div className="image-validation-warning">
//             <strong>⚠️ Remove rejected images to continue</strong>
//             <p style={{ margin: '4px 0 0 0', fontSize: '13px' }}>
//               {imageValidationStatus.filter(img => img.status === 'rejected').length} image(s) were rejected.
//               Please remove them and upload valid property images only.
//             </p>
//           </div>
//         )}

//         {/* Success message if all approved */}
//         {imageValidationStatus.length > 0 &&
//           imageValidationStatus.every(img => img.status === 'approved') &&
//           !isCheckingImages && (
//             <div className="image-validation-success" style={{
//               background: '#e8f5e9',
//               color: '#2e7d32',
//               padding: '12px',
//               borderRadius: '4px',
//               marginTop: '16px',
//               fontSize: '14px',
//               border: '1px solid #4CAF50',
//               display: 'flex',
//               alignItems: 'center',
//               gap: '8px'
//             }}>
//               <span>✅</span>
//               <span>All images approved!</span>
//             </div>
//           )}
//       </div>

//       {/* <div className="form-group">
//         <label>Brochure (PDF)</label>
//         <input
//           ref={brochureRef}
//           type="file"
//           accept=".pdf"
//             onChange={(e) => {
//             const file = e.target.files?.[0];
//             if (file) {
//               const url = URL.createObjectURL(file);
//               handleChange('brochure', { file, name: file.name, url, isExisting: false });
//             }
//           }}
//           style={{ display: 'none' }}
//         />
//         <button
//           type="button"
//           className="cancel-btn"
//           onClick={() => brochureRef.current?.click()}
//           style={{ background: 'white', border: '2px solid var(--border-color)' }}
//         >
//           📑 Upload Brochure
//         </button>
//         {formData.brochure && (

//           <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
//             <span>📄 {formData.brochure.name}</span>
//             <div style={{flexDirection:'row'}}>
//             {formData.brochure.url && (
//               <a
//                 href={formData.brochure.url}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 style={{ fontSize: '0.875rem', color: '#2563eb' }}
//               >
//                 View PDF
//               </a>
//             )}
//              <button
//       type="button"
//       onClick={() => {
//         // Revoke blob URL to free memory
//         if (formData.brochure.url && formData.brochure.url.startsWith('blob:')) {
//           URL.revokeObjectURL(formData.brochure.url);
//         }
//         // Clear brochure data
//         handleChange('brochure', null);
//         // Reset file input
//         if (brochureRef.current) {
//           brochureRef.current.value = '';
//         }
//       }}
//       style={{
//         background: 'none',
//         border: 'none',
//         cursor: 'pointer',
//         color: '#dc2626',
//         fontSize: '1.2rem',
//         padding: '0 4px',
//         marginLeft: '10px'
//       }}
//       title="Remove brochure"
//     >
//       ✕
//     </button>

//     </div>
//             <button
//               type="button"
//               className="cancel-btn"
//               onClick={() => brochureRef.current?.click()}
//               style={{ background: 'white', border: '2px solid var(--border-color)', maxWidth: '200px' }}
//             >
//               Replace brochure
//             </button>
//           </div>
//         )}
//       </div> */}


// <div className="form-group">
//   <label>Brochure (PDF) - Multiple files allowed</label>
//   <input
//     ref={brochureRef}
//     type="file"
//     accept=".pdf"
//     multiple
//     onChange={(e) => {
//       const files = Array.from(e.target.files || []);
//       if (files.length > 0) {
//         // Process each file and add to brochures array
//         const newBrochures = files.map(file => ({
//           file: file,
//           name: file.name,
//           url: URL.createObjectURL(file),
//           isExisting: false,
//           id: Date.now() + Math.random().toString(36).substr(2, 9)
//         }));
        
//         // Get existing brochures
//         const existingBrochures = formData.brochures || [];
//         // Add new brochures
//         handleChange('brochures', [...existingBrochures, ...newBrochures]);
//       }
//       // Reset file input
//       if (brochureRef.current) {
//         brochureRef.current.value = '';
//       }
//     }}
//     style={{ display: 'none' }}
//   />
//   <button
//     type="button"
//     className="cancel-btn"
//     onClick={() => brochureRef.current?.click()}
//     style={{ background: 'white', border: '2px solid var(--border-color)' }}
//   >
//     📑 Upload Brochures (Multiple)
//   </button>
  
//   {/* Display multiple brochures */}
//   {(formData.brochures && formData.brochures.length > 0) && (
//     <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
//       {formData.brochures.map((brochure, index) => (
//         <div 
//           key={brochure.id || index}
//           style={{ 
//             display: 'flex', 
//             alignItems: 'center', 
//             justifyContent: 'space-between',
//             padding: '8px 12px',
//             border: '1px solid var(--border-color)',
//             borderRadius: '6px',
//             background: '#f9fafb'
//           }}
//         >
//           <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
//             <span style={{ fontSize: '0.9rem' }}>📄</span>
//             <span style={{ fontSize: '0.9rem', fontWeight: '500' }}>{brochure.name}</span>
//           </div>
//           <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//             {brochure.url && (
//               <a
//                 href={brochure.url}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 style={{ fontSize: '0.875rem', color: '#2563eb', textDecoration: 'none' }}
//               >
//                 View PDF
//               </a>
//             )}
//             <button
//               type="button"
//               onClick={() => {
//                 // Revoke blob URL to free memory
//                 if (brochure.url && brochure.url.startsWith('blob:')) {
//                   URL.revokeObjectURL(brochure.url);
//                 }
//                 // Remove this brochure from the list
//                 const updatedBrochures = formData.brochures.filter((_, i) => i !== index);
//                 handleChange('brochures', updatedBrochures.length > 0 ? updatedBrochures : null);
//               }}
//               style={{
//                 background: 'none',
//                 border: 'none',
//                 cursor: 'pointer',
//                 color: '#dc2626',
//                 fontSize: '1.2rem',
//                 padding: '0 4px'
//               }}
//               title="Remove brochure"
//             >
//               ✕
//             </button>
//           </div>
//         </div>
//       ))}
//     </div>
//   )}
// </div>




//       {/* Contact Information Section */}
//       <div className="form-group" style={{ marginTop: '2rem', paddingTop: '2rem', borderTop: '1px solid var(--border-color)' }}>
//         <h3 className="step-heading" style={{ fontSize: '1.1rem', marginBottom: '1rem' }}>Contact Information</h3>
//         <p className="step-subheading" style={{ fontSize: '0.9rem', marginBottom: '1.25rem' }}>How can buyers reach you? Add one or more sales person details.</p>

//         {(formData.salesPersons || [{ name: '', number: '', email: '', landlineNumber: '', whatsappNumber: '', alternativeNumber: '' }]).map((sp, idx) => (
//           <div key={idx} style={{ marginBottom: '1.5rem', padding: '1rem', border: '1px solid var(--border-color)', borderRadius: '8px', background: '#fafafa' }}>
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
//               <span style={{ fontWeight: '600', fontSize: '0.9rem' }}>Sales Person {idx + 1}</span>
//               {(formData.salesPersons || []).length > 1 && (
//                 <button
//                   type="button"
//                   onClick={() => removeSalesPerson(idx)}
//                   style={{ padding: '4px 10px', fontSize: '0.8rem', background: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: '6px', cursor: 'pointer' }}
//                 >
//                   Remove
//                 </button>
//               )}
//             </div>
//             <div className="form-row two-cols">
//               {/* <div className="form-group">
//                 <label>Name <span className="required">*</span></label>
//                 <input
//                   type="text"
//                   value={sp.name}
//                   onChange={(e) => updateSalesPerson(idx, 'name', e.target.value.replace(/[^a-zA-Z\s]/g, ''))}
//                   placeholder="Sales person name (letters only)"
//                   className={errors[`salesPerson_name_${idx}`] ? 'error' : ''}
//                 />
//                 {errors[`salesPerson_name_${idx}`] && <span className="error-text">{errors[`salesPerson_name_${idx}`]}</span>}
//               </div> */}

// <div className="form-group">
//   <label>Name <span className="required">*</span></label>
//   <input
//     type="text"
//     value={sp.name.toUpperCase()}
//     onChange={(e) => updateSalesPerson(idx, 'name', e.target.value.replace(/[^a-zA-Z\s]/g, '').toUpperCase())}
//     placeholder="Sales person name"
//     className={errors[`salesPerson_name_${idx}`] ? 'error' : ''}
//     style={{ textTransform: 'uppercase' }}
//   />
//   {errors[`salesPerson_name_${idx}`] && <span className="error-text">{errors[`salesPerson_name_${idx}`]}</span>}
// </div>



//               <div className="form-group">
//                 <label>Contact Number <span className="required">*</span></label>
//                 <input
//                   type="tel"
//                   value={sp.number}
//                   onChange={(e) => updateSalesPerson(idx, 'number', e.target.value.replace(/\D/g, '').slice(0, 10))}
//                   placeholder="10-digit mobile number"
//                   maxLength={10}
//                   className={errors[`salesPerson_number_${idx}`] ? 'error' : ''}
//                 />
//                 {errors[`salesPerson_number_${idx}`] && <span className="error-text">{errors[`salesPerson_number_${idx}`]}</span>}
//               </div>
//             </div>
//             <div className="form-group">
//               <label>Email ID <span className="required">*</span></label>
//               <input
//                 type="email"
//                 value={sp.email}
//                 onChange={(e) => updateSalesPerson(idx, 'email', e.target.value)}
//                 placeholder="Email address"
//                 className={errors[`salesPerson_email_${idx}`] ? 'error' : ''}
//               />
//               {errors[`salesPerson_email_${idx}`] && <span className="error-text">{errors[`salesPerson_email_${idx}`]}</span>}
//             </div>
//             <div className="form-group">
//               <label>Landline Number (Optional)</label>
//               <input
//                 type="tel"
//                 value={sp.landlineNumber ?? ''}
//                 onChange={(e) => updateSalesPerson(idx, 'landlineNumber', e.target.value.replace(/[^\d\s\-]/g, ''))}
//                 placeholder="e.g. 020-12345678 or 0123-1234567"
//                 maxLength={15}
//               />
//             </div>
//             <div className="form-row two-cols">
//               <div className="form-group">
//                 <label>WhatsApp Number (Optional)</label>
//                 <input
//                   type="tel"
//                   value={sp.whatsappNumber ?? ''}
//                   onChange={(e) => updateSalesPerson(idx, 'whatsappNumber', e.target.value.replace(/\D/g, '').slice(0, 10))}
//                   placeholder="10-digit Mobile number"
//                   maxLength={10}
//                 />
//               </div>
//               <div className="form-group">
//                 <label>Alternative Number (Optional)</label>
//                 <input
//                   type="tel"
//                   value={sp.alternativeNumber ?? ''}
//                   onChange={(e) => updateSalesPerson(idx, 'alternativeNumber', e.target.value.replace(/\D/g, '').slice(0, 10))}
//                   placeholder="10-digit mobile number"
//                   maxLength={10}
//                 />
//               </div>
//             </div>
//           </div>
//         ))}

//         {(formData.salesPersons || []).length < 5 && (
//           <button
//             type="button"
//             onClick={addSalesPerson}
//             style={{
//               display: 'inline-flex',
//               alignItems: 'center',
//               gap: '8px',
//               padding: '10px 16px',
//               marginBottom: '1.25rem',
//               background: 'white',
//               border: '2px dashed var(--border-color)',
//               borderRadius: '8px',
//               cursor: 'pointer',
//               fontSize: '0.9rem',
//               fontWeight: '600',
//               color: 'var(--accent-color, #7c3aed)'
//             }}
//           >
//             <span>+ Add another sales person</span>
//           </button>
//         )}
//       </div>
//     </div>
//   );

//   const renderCurrentStep = () => {
//     switch (currentStep) {
//       case 1: return renderStep1();
//       case 2: return renderStep2();
//       case 3: return renderStep3();
//       case 4: return renderStep4();
//       case 5: return renderStep5();
//       default: return renderStep1();
//     }
//   };

//   return (
//     <>
//       {/* Close Warning Modal - Show when trying to close on final step without publishing */}
//       {showCloseWarning && (
//         <div className="popup-overlay" style={{ zIndex: 10000 }}>
//           <div className="popup-container" style={{ maxWidth: '500px' }}>
//             <div className="popup-header">
//               <h2>Publishing Not Completed</h2>
//               <button
//                 className="close-btn"
//                 onClick={() => setShowCloseWarning(false)}
//                 aria-label="Close"
//               >
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
//                   <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
//                 </svg>
//               </button>
//             </div>
//             <div className="popup-body" style={{ padding: '2rem' }}>
//               <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
//                 <svg width="48" height="48" viewBox="0 0 24 24" fill="none" style={{ margin: '0 auto 1rem', color: 'var(--warning-color, #f59e0b)' }}>
//                   <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
//                   <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
//                 </svg>
//                 <p style={{ fontSize: '1rem', lineHeight: '1.6', color: 'var(--text-color, #333)' }}>
//                   You haven't published this project yet.
//                   <br />
//                   Please publish before closing, or your data will be lost.
//                 </p>
//               </div>
//             </div>
//             <div className="popup-footer" style={{ justifyContent: 'center', gap: '1rem' }}>
//               <button
//                 type="button"
//                 className="cancel-btn"
//                 onClick={() => setShowCloseWarning(false)}
//               >
//                 Continue Editing
//               </button>

//             </div>
//           </div>
//         </div>
//       )}

//       {/* Main Popup Overlay - Only show if close warning not shown */}
//       {!showCloseWarning && (
//         <div className="popup-overlay">
//           <div className="popup-container" onClick={(e) => e.stopPropagation()}>
//             {/* Header */}
//             <div className="popup-header">
//               <h2>{isEditMode ? 'Edit Upcoming Project' : 'Add Upcoming Project'}</h2>
//               <button className="close-btn" onClick={handleCloseAttempt}>
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
//                   <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
//                 </svg>
//               </button>
//             </div>

//             {/* Step Indicator */}
//             {renderStepIndicator()}

//             {/* Body */}
//             <div className="popup-body" ref={popupBodyRef}>
//               {renderCurrentStep()}
//             </div>

//             {/* Footer */}
//             <div className="popup-footer">
//               {currentStep > 1 && (
//                 <button type="button" className="back-btn" onClick={handleBack}>
//                   <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
//                     <path d="M19 12H5M12 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
//                   </svg>
//                   Back
//                 </button>
//               )}

//               <div className="footer-right">
//                 <button type="button" className="cancel-btn" onClick={handleCloseAttempt}>
//                   Cancel
//                 </button>

//                 {currentStep < 5 ? (
//                   <button type="button" className="next-btn" onClick={handleNext}>
//                     Next
//                     <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
//                       <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
//                     </svg>
//                   </button>
//                 ) : (
//                   <button
//                     type="button"
//                     className="submit-btn"
//                     onClick={handleSubmit}
//                     disabled={
//                       isSubmitting
//                       || isDiscarded
//                       || (!formData.coverImage?.file && !formData.coverImage?.isExisting)
//                       || (formData.projectImages?.length || 0) < 3
//                       || (formData.projectImages?.length || 0) > 20
//                     }
//                     style={{
//                       opacity: (
//                         isSubmitting
//                         || isDiscarded
//                         || (!formData.coverImage?.file && !formData.coverImage?.isExisting)
//                         || (formData.projectImages?.length || 0) < 3
//                         || (formData.projectImages?.length || 0) > 20
//                       ) ? 0.6 : 1,
//                       cursor: (
//                         isSubmitting
//                         || isDiscarded
//                         || (!formData.coverImage?.file && !formData.coverImage?.isExisting)
//                         || (formData.projectImages?.length || 0) < 3
//                         || (formData.projectImages?.length || 0) > 20
//                       ) ? 'not-allowed' : 'pointer'
//                     }}
//                   >
//                     {isSubmitting ? (
//                       <>
//                         <span className="spinner"></span>
//                         Submitting...
//                       </>
//                     ) : (
//                       <>
//                         <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
//                           <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
//                         </svg>
//                         Publish Project
//                       </>
//                     )}
//                   </button>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Location Picker Modal */}
//       {showLocationPicker && (
//         <div className="location-picker-modal-overlay" onClick={(e) => {
//           if (e.target.classList.contains('location-picker-modal-overlay')) {
//             setShowLocationPicker(false);
//           }
//         }}>
//           <LocationPicker
//             initialLocation={
//               formData.latitude && formData.longitude
//                 ? {
//                     latitude: parseFloat(formData.latitude),
//                     longitude: parseFloat(formData.longitude),
//                     fullAddress: formData.location || formData.fullAddress
//                   }
//                 : mapCenterFromAddress
//                   ? {
//                       latitude: mapCenterFromAddress.lat,
//                       longitude: mapCenterFromAddress.lng,
//                       fullAddress: formData.location || formData.area || ''
//                     }
//                   : null
//             }
//             defaultCenter={formData.latitude && formData.longitude ? undefined : (mapCenterFromAddress ? [mapCenterFromAddress.lng, mapCenterFromAddress.lat] : undefined)}
//             defaultZoom={formData.latitude && formData.longitude ? undefined : (mapCenterFromAddress ? 14 : undefined)}
//             onLocationChange={handleLocationSelect}
//             onClose={() => setShowLocationPicker(false)}
//           />
//         </div>
//       )}
//     </>
//   );
// }



// src/components/AddUpcomingProjectPopup.jsx
import React, { useState, useRef, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Calendar as CalendarIcon, ChevronLeft, ChevronRight } from "lucide-react";
import { useProperty } from "./PropertyContext";
import { sellerPropertiesAPI, authAPI, sellerDashboardAPI, sellerProfileAPI } from "../../services/api.service";
import { API_BASE_URL, API_ENDPOINTS } from "../../config/api.config";
import { validateImageFile } from "../../utils/validation";
import {
  collectAmenityLabels,
  generateUpcomingProjectDescription,
} from "../../utils/generatePropertyDescription";
import {
  buildBrochureFromUrl,
  collectProjectBrochures,
  createExistingImageValidationStatus,
  decodeHtmlEntitiesInUrl,
  isBlobUrl,
  parseUpcomingProjectData,
  resolvePropertyImageUrls,
  resolvePropertyMediaUrl,
  normalizeConfigurationLabels,
  sanitizeConfigurationsForProjectType,
} from "../../utils/propertyMedia";
import {
  formatIndianPriceDisplay,
  formatIndianPriceForEditInput,
  formatIndianPriceRangeDisplay,
  parseIndianPriceToRupees,
  resolveEditStartingPriceInput,
} from "../../utils/indianPriceFormat";
import { formatAreaRangeWithSqFt, stripAreaSqFtUnit } from "../../utils/formatAreaRange";
import LocationPicker from "../../components/Map/LocationPicker";
import LocationAutoSuggest from "../../components/LocationAutoSuggest/LocationAutoSuggest";
import "../styles/AddPropertyPopup.css";

const FREE_LISTING_SLOTS = 1;
const MAX_BROCHURE_SIZE_BYTES = 10 * 1024 * 1024; // 10 MB
const MAX_BROCHURE_SIZE_LABEL = '10 MB';
const BROCHURE_SIZE_HINT = `Max size ${MAX_BROCHURE_SIZE_LABEL}`;
const BROCHURE_SIZE_EXCEEDED_MSG = `You have exceeded the size. Max size is ${MAX_BROCHURE_SIZE_LABEL} to upload brochure.`;

const EMPTY_UPCOMING_FORM = {
  projectName: "",
  builderName: "",
  projectType: "",
  projectStatus: "UNDER CONSTRUCTION",
  reraNumber: "",
  description: "",
  city: "",
  area: "",
  fullAddress: "",
  latitude: "",
  longitude: "",
  state: "",
  pincode: "",
  mapLink: "",
  configurations: [],
  carpetAreaRange: "",
  numberOfTowers: "",
  totalUnits: "",
  floorsCount: "",
  unitsPerFloor: "",
  numberOfVillas: "",
  numberOfPlots: "",
  bedCapacity: "",
  loadingDocks: "",
  startingPrice: "",
  pricePerSqft: "",
  bookingAmount: "",
  expectedLaunchDate: "",
  expectedPossessionDate: "",
  amenities: [],
  reraStatus: "",
  landOwnershipType: "",
  bankApproved: "",
  approvedBanks: [],
  otherBankName: "",
  coverImage: null,
  projectImages: [],
  brochures: [],
  salesPersons: [{ name: "", number: "", email: "", landlineNumber: "", whatsappNumber: "", alternativeNumber: "" }],
  landlineNumber: "",
  whatsappNumber: "",
  alternativeNumber: "",
  projectHighlights: "",
  usp: "",
};

/** Build edit/create form state from property list/edit payload (includes brochures). */
const buildUpcomingFormFromEditData = (editData, builderName = "") => {
  if (!editData) {
    return { ...EMPTY_UPCOMING_FORM, builderName: builderName || "" };
  }

  const upcomingData = parseUpcomingProjectData(
    editData.upcomingProjectData ?? editData.upcoming_project_data
  );

  const legacyProjectTypeMap = {
    Villa: "Villa / Banglow",
    Plot: "Plot / Land / Indusrtial Property",
    Commercial: "Commercial Office",
  };
  const projectType =
    legacyProjectTypeMap[editData.propertyType] || editData.propertyType || "";

  const rawAmenities = Array.isArray(editData.amenities) ? editData.amenities : [];
  const amenities = rawAmenities.map((a) => (a === "play_area" ? "playground" : a));

  const brochures = collectProjectBrochures({
    upcomingData,
    brochureUrl:
      editData.brochureUrl ||
      editData.brochure_url ||
      upcomingData.brochure ||
      null,
    forEdit: true,
  });

  const resolvedImages = resolvePropertyImageUrls(editData.images);

  const configurations = sanitizeConfigurationsForProjectType(
    upcomingData.configurations,
    projectType,
    CONFIGURATION_BY_PROJECT_TYPE
  );

  return {
    projectName: editData.title || "",
    builderName: upcomingData.builderName || builderName || "",
    projectType,
    projectStatus: upcomingData.projectStatus || "UNDER CONSTRUCTION",
    reraNumber: upcomingData.reraNumber || "",
    description: editData.description || "",
    city: "",
    area: editData.location || "",
    location: editData.location || "",
    fullAddress: editData.additionalAddress || "",
    latitude: editData.latitude || "",
    longitude: editData.longitude || "",
    state: editData.state || "",
    pincode: upcomingData.pincode || "",
    mapLink: upcomingData.mapLink || "",
    configurations,
    carpetAreaRange: stripAreaSqFtUnit(upcomingData.carpetAreaRange) || "",
    numberOfTowers: upcomingData.numberOfTowers || "",
    totalUnits: upcomingData.totalUnits || "",
    floorsCount: upcomingData.floorsCount || "",
    unitsPerFloor: upcomingData.unitsPerFloor || "",
    numberOfVillas: upcomingData.numberOfVillas || "",
    numberOfPlots: upcomingData.numberOfPlots || "",
    bedCapacity: upcomingData.bedCapacity || "",
    loadingDocks: upcomingData.loadingDocks || "",
    startingPrice: resolveEditStartingPriceInput(
      upcomingData.startingPrice,
      editData.price ?? editData.Price ?? upcomingData.price
    ),
    pricePerSqft: upcomingData.pricePerSqft || "",
    bookingAmount: upcomingData.bookingAmount || "",
    expectedLaunchDate: upcomingData.expectedLaunchDate || "",
    expectedPossessionDate: upcomingData.expectedPossessionDate || "",
    amenities,
    reraStatus: upcomingData.reraStatus || "",
    landOwnershipType: upcomingData.landOwnershipType || "",
    bankApproved: upcomingData.bankApproved || "",
    approvedBanks: Array.isArray(upcomingData.approvedBanks)
      ? upcomingData.approvedBanks
      : [],
    otherBankName: "",
    coverImage:
      resolvedImages.length > 0
        ? { url: resolvedImages[0], isExisting: true }
        : null,
    projectImages: resolvedImages,
    brochures,
    salesPersons:
      Array.isArray(upcomingData.salesPersons) && upcomingData.salesPersons.length > 0
        ? upcomingData.salesPersons.map((sp) => ({
            name: sp.name || "",
            number: sp.number || "",
            email: sp.email || "",
            landlineNumber: sp.landlineNumber || "",
            whatsappNumber: sp.whatsappNumber || "",
            alternativeNumber: sp.alternativeNumber || "",
          }))
        : [
            {
              name: upcomingData.salesName || "",
              number: upcomingData.salesNumber || "",
              email: upcomingData.emailId || "",
              landlineNumber:
                upcomingData.landlineNumber || upcomingData.mobileNumber || "",
              whatsappNumber: upcomingData.whatsappNumber || "",
              alternativeNumber: upcomingData.alternativeNumber || "",
            },
          ].filter((sp) => sp.name || sp.number || sp.email).length > 0
          ? [
              {
                name: upcomingData.salesName || "",
                number: upcomingData.salesNumber || "",
                email: upcomingData.emailId || "",
                landlineNumber:
                  upcomingData.landlineNumber || upcomingData.mobileNumber || "",
                whatsappNumber: upcomingData.whatsappNumber || "",
                alternativeNumber: upcomingData.alternativeNumber || "",
              },
            ]
          : [
              {
                name: "",
                number: "",
                email: "",
                landlineNumber: "",
                whatsappNumber: "",
                alternativeNumber: "",
              },
            ],
    landlineNumber: upcomingData.landlineNumber || upcomingData.mobileNumber || "",
    whatsappNumber: upcomingData.whatsappNumber || "",
    alternativeNumber: upcomingData.alternativeNumber || "",
    projectHighlights: upcomingData.projectHighlights || "",
    usp: upcomingData.usp || "",
  };
};

const hasActiveFreeTrial = (subscription, user) => {
  const source = String(subscription?.source || '').toLowerCase();
  const expiryRaw = subscription?.end_date || subscription?.nearest_expiry;
  const expiryDate = expiryRaw ? new Date(expiryRaw) : null;
  const isSubscriptionTrialActive =
    expiryDate &&
    !Number.isNaN(expiryDate.getTime()) &&
    expiryDate.getTime() > Date.now() &&
    source !== 'paid_plan';

  if (isSubscriptionTrialActive) {
    return true;
  }

  const createdAtRaw = user?.created_at || user?.createdAt;
  if (!createdAtRaw) {
    return false;
  }

  const createdAt = new Date(createdAtRaw);
  if (Number.isNaN(createdAt.getTime())) {
    return false;
  }

  const trialEndsAt = createdAt.getTime() + (30 * 24 * 60 * 60 * 1000);
  return Date.now() < trialEndsAt;
};

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function ModernDatePicker({ value, onChange, placeholder = "Select date", id, onOpenChange }) {
  const [open, setOpen] = useState(false);
  const [viewDate, setViewDate] = useState(() => {
    if (value) {
      const [y, m] = value.split("-").map(Number);
      return new Date(y, m - 1, 1);
    }
    return new Date();
  });
  const containerRef = useRef(null);

  useEffect(() => {
    if (value) {
      const [y, m] = value.split("-").map(Number);
      setViewDate(new Date(y, m - 1, 1));
    }
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) setOpen(false);
    };
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [open]);

  useEffect(() => {
    if (onOpenChange) {
      onOpenChange(open);
    }
  }, [open, onOpenChange]);

  const formatDisplay = (val) => {
    if (!val) return "";
    const [y, m, d] = val.split("-").map(Number);
    return `${d} ${MONTHS[m - 1]} ${y}`;
  };

  const toYYYYMMDD = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  const year = viewDate.getFullYear();
  const month = viewDate.getMonth();
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const startPad = firstDay.getDay();
  const daysInMonth = lastDay.getDate();
  const days = [];
  for (let i = 0; i < startPad; i++) days.push(null);
  for (let d = 1; d <= daysInMonth; d++) days.push(d);

  const handleSelect = (d) => {
    if (!d) return;
    const date = new Date(year, month, d);
    onChange(toYYYYMMDD(date));
    setOpen(false);
  };

  const prevMonth = () => setViewDate(new Date(year, month - 1, 1));
  const nextMonth = () => setViewDate(new Date(year, month + 1, 1));
  const handleYearChange = (e) => setViewDate(new Date(parseInt(e.target.value), month, 1));
  const handleMonthChange = (e) => setViewDate(new Date(year, parseInt(e.target.value), 1));
  const selectToday = () => {
    onChange(toYYYYMMDD(new Date()));
    setOpen(false);
  };

  const selectedYMD = value ? value.split("-").map(Number) : null;

  return (
    <div className="modern-date-picker" ref={containerRef}>
      <button
        type="button"
        className="modern-date-picker-input"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="dialog"
        aria-expanded={open}
        aria-label={placeholder}
        id={id}
      >
        <CalendarIcon size={18} className="modern-date-picker-icon" />
        <span className={value ? "" : "modern-date-picker-placeholder"}>
          {value ? formatDisplay(value) : placeholder}
        </span>
      </button>
      {open && (
        <div className="modern-date-picker-dropdown" role="dialog" aria-modal="true">
          <div className="modern-date-picker-header">
            <button type="button" className="modern-date-picker-nav" onClick={prevMonth} aria-label="Previous month">
              <ChevronLeft size={18} />
            </button>
            <div className="modern-date-picker-selectors">
              <select
                className="modern-date-picker-select"
                value={month}
                onChange={handleMonthChange}
              >
                {MONTHS.map((m, i) => (
                  <option key={m} value={i}>{m}</option>
                ))}
              </select>
              <select
                className="modern-date-picker-select"
                value={year}
                onChange={handleYearChange}
              >
                {Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - 3 + i).map(y => (
                  <option key={y} value={y}>{y}</option>
                ))}
              </select>
            </div>
            <button type="button" className="modern-date-picker-nav" onClick={nextMonth} aria-label="Next month">
              <ChevronRight size={18} />
            </button>
          </div>
          <div className="modern-date-picker-weekdays">
            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((w) => (
              <span key={w} className="modern-date-picker-weekday">{w}</span>
            ))}
          </div>
          <div className="modern-date-picker-grid">
            {days.map((d, i) => {
              const isSelected = selectedYMD && selectedYMD[0] === year && selectedYMD[1] === month + 1 && selectedYMD[2] === d;
              const isToday = (() => {
                const t = new Date();
                return d && t.getFullYear() === year && t.getMonth() === month && t.getDate() === d;
              })();
              return (
                <button
                  key={i}
                  type="button"
                  className={`modern-date-picker-day ${!d ? "empty" : ""} ${isSelected ? "selected" : ""} ${isToday ? "today" : ""}`}
                  onClick={() => handleSelect(d)}
                  disabled={!d}
                >
                  {d || ""}
                </button>
              );
            })}
          </div>
          <div className="modern-date-picker-footer">
            <button type="button" className="modern-date-picker-today" onClick={selectToday}>
              Today
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

const STEPS = [
  { id: 1, title: "Basic Details", icon: "📝" },
  { id: 2, title: "Location", icon: "📍" },
  { id: 3, title: "Configuration", icon: "🏗️" },
  { id: 4, title: "Pricing & Amenities", icon: "💰" },
  { id: 5, title: "Media & Contact", icon: "📷" }
];

// Same property types as in property form (Seller AddPropertyPopup) for consistency
const PROJECT_TYPES = [
  { value: "Apartment", icon: "🏢" },
  { value: "Villa / Banglow", icon: "🏡" },
  { value: "Independent House", icon: "🏘️" },
  { value: "Row House/ Farm House", icon: "🏘️" },
  { value: "Penthouse", icon: "🌆" },
  { value: "Studio Apartment", icon: "🛏️" },
  { value: "Plot / Land / Indusrtial Property", icon: "📐" },
  { value: "Commercial Office", icon: "🏢" },
  { value: "Commercial Shop", icon: "🏪" },
  { value: "PG / Hostel", icon: "🛏️" },
  { value: "Warehouse / Godown", icon: "🏪" }
];

const PROJECT_STATUS_OPTIONS = [
  { value: "UNDER CONSTRUCTION", label: "UNDER CONSTRUCTION" },
  { value: "PRE-LAUNCH", label: "PRE-LAUNCH" },
  { value: "COMPLETED", label: "COMPLETED" }
];

// Configuration options per project type — fields in Step 3 change based on this (2BHK style)
const CONFIGURATION_BY_PROJECT_TYPE = {
  "Apartment": ["Studio Apartment", "1BHK", "2BHK", "3BHK", "4BHK", "5+BHK", "Duplex Apartment", "Penthouse"],
  "Villa / Banglow": ["2BHK Villa", "3BHK Villa", "4BHK Villa", "5+BHK Villa", "Luxury Villa"],
  "Independent House": ["1BHK Independent House", "2BHK Independent House", "3BHK Independent House", "4+BHK Independent House"],
  "Row House/ Farm House": ["2BHK Row House", "3BHK Row House", "4BHK Row House", "Farm House Plot", "Luxury Farm House"],
  "Penthouse": ["3BHK Penthouse", "4BHK Penthouse", "5+BHK Penthouse"],
  "Studio Apartment": ["Studio Unit", "Studio + Balcony", "Studio Deluxe"],
  "Plot / Land / Indusrtial Property": ["Residential Plot", "Commercial Plot", "Industrial Plot", "NA Plot", "Agricultural Land"],
  "Commercial Office":[  "Bare Shell Office",
    "Warm Shell Office",
    "Furnished Office",
    "Semi-Furnished Office",
    "Ready-to-Move Office",
    "Plug & Play Office",
    "Managed Office",
    "Serviced Office",
    "Co-working Space",
    "Private Cabin",
    "Shared Office",
    "Virtual Office",
    "Business Center Office",
    "IT / Tech Park Office",
    "Corporate Office",
    "Commercial Floor",
    "Independent Office Building",
    "Office in Business Park",
    "Office in Commercial Tower"] ,
  // ["Office Space (Bare Shell)", "Furnished Office", "IT / Tech Park Office", "Business Center Office", "Call Center / BPO Office", "Head Office",
  //                       "Branch Office", "Ready-to-Move Office",  "Shared Office",  "Co-working Space"],
  "Commercial Shop": ["Retail Shop", "Showroom", "Food Court Shop", "Kiosk", "Mall Shop"],
  "PG / Hostel": ["Single Sharing", "Double Sharing", "Triple Sharing", "Dormitory", "Girls Hostel / Boys Hostel"],
  "Warehouse / Godown": ["Small Warehouse", "Medium Warehouse", "Large Warehouse", "Cold Storage", "Logistics Warehouse"]
};

// Same amenities as in property form (Seller AddPropertyPopup) for consistency
const AMENITIES = [
 { id: "parking", label: "Parking", icon: "🚗" },
  //{ id: "lift", label: "Lift", icon: "🛗" },
 // { id: "security", label: "24x7 Security", icon: "👮" },
 // { id: "power_backup", label: "Power Backup", icon: "⚡" },
  //{ id: "gym", label: "Gym", icon: "🏋️" },
  { id: "cctv", label: "CCTV", icon: "📹" },
  { id: "fire_safety", label: "Fire Safety", icon: "🔥" },
  { id: "water_supply", label: "24x7 Water", icon: "💧" },
  { id: "swimming_pool", label: "Swimming Pool", icon: "🏊" },
  // { id: "garden", label: "Garden", icon: "🌳" },
  { id: "clubhouse", label: "Club House", icon: "🏛️" },
  { id: "playground", label: "Children's Play Area", icon: "🎢" },
  // { id: "cctv", label: "CCTV", icon: "📹" },
  { id: "intercom", label: "Intercom", icon: "📞" },
  // { id: "fire_safety", label: "Fire Safety", icon: "🔥" },
  // { id: "water_supply", label: "24x7 Water", icon: "💧" },
  { id: "gas_pipeline", label: "Gas Pipeline", icon: "🔥" },
 // { id: "wifi", label: "WiFi", icon: "📶" },
  { id: "ac", label: "Air Conditioning", icon: "❄️" },
 // { id: "electricity", label: "Electricity", icon: "⚡" },

  // Plot/Land specific
  { id: "internal_roads", label: "Internal Roads", icon: "🛣️" },
  { id: "led_lighting", label: "LED Street Lighting", icon: "💡" },
  { id: "rainwater_harvesting", label: "Rainwater Harvesting", icon: "🌧️" },
  { id: "underground_drainage", label: "Underground Drainage", icon: "🚰" },
  { id: "stormwater_drainage", label: "Stormwater Drainage", icon: "🌊" },
  { id: "water_line", label: "Water Supply Line/Borewell", icon: "💧" },
  // { id: "electricity_provision", label: "Electricity Provision", icon: "⚡" },
  { id: "gated_entrance", label: "Gated Entrance", icon: "🚧" },
  { id: "compound_wall", label: "Compound Wall", icon: "🧱" },
  { id: "security_cabin", label: "Security Cabin", icon: "🏠" },
  { id: "landscaped_garden", label: "Landscaped Garden", icon: "🌳" },
  { id: "jogging_track", label: "Jogging/Walking Track", icon: "🏃" },
  { id: "open_gym", label: "Open Gym/Fitness Zone", icon: "💪" },
 // { id: "visitor_parking", label: "Visitor Parking", icon: "🅿️" },

  // Commercial/Office/Coworking
  { id: "power_backup_ups", label: "24/7 Power Backup (UPS/DG)", icon: "⚡" },
  { id: "high_speed_internet", label: "High-Speed Internet/Fiber Ready", icon: "🌐" },
  { id: "centralized_ac", label: "Centralized AC (HVAC)", icon: "❄️" },
  { id: "lifts_high_speed", label: "Elevators/High-Speed Lifts", icon: "🛗" },
  { id: "access_control", label: "Access Control (RFID/Biometric)", icon: "🔐" },
  { id: "security_staff", label: "Security Staff (24×7)", icon: "👮" },
  { id: "reception_desk", label: "Reception Desk", icon: "💁" },
  { id: "lobby_area", label: "Lobby Area", icon: "🛋️" },
  { id: "conference_room", label: "Conference Room", icon: "🤝" },
  { id: "washrooms", label: "Washrooms (Private/Common)", icon: "🚻" },
  { id: "pantry", label: "Pantry/Kitchenette", icon: "☕" },

  // Commercial Shop
  { id: "power_supply_247", label: "24/7 Power Supply", icon: "⚡" },
 // { id: "customer_parking", label: "Customer Parking", icon: "🚗" },
//  { id: "two_wheeler_parking", label: "Two-Wheeler Parking", icon: "🛵" },
  { id: "wheelchair_accessible", label: "Wheelchair Accessible/Ramp", icon: "♿" },
 // { id: "escalator_access", label: "Lift/Escalator Access", icon: "🛗" },
  { id: "display_window", label: "Glass Front/Display Window", icon: "🪟" },
  { id: "shutter_door", label: "Shutter Door", icon: "🚪" },
  { id: "mezzanine_floor", label: "Mezzanine Floor/Storage Room", icon: "📦" },

  // Coworking specific
  { id: "dedicated_desk", label: "Dedicated Desk/Hot Desk", icon: "💻" },
  { id: "private_cabins", label: "Private Cabins", icon: "🏢" },
  { id: "meeting_rooms", label: "Meeting Rooms", icon: "👥" },
 // { id: "coffee_tea", label: "Coffee/Tea/Water", icon: "☕" },
  { id: "office_supplies", label: "Printer/Scanner/Office Supplies", icon: "🖨️" },
  { id: "housekeeping", label: "Housekeeping & Daily Cleaning", icon: "🧹" },
  { id: "quiet_zones", label: "Quiet Zones", icon: "🤫" },
  { id: "mobile_app_access", label: "Mobile App Access", icon: "📱" },
  { id: "event_space", label: "Event Space/Community Area", icon: "🎉" },
  { id: "lounge", label: "Lounge/Breakout Zones", icon: "🛋️" }
];

const RERA_STATUS_OPTIONS = [
  { value: "Applied", label: "Applied" },
  { value: "Approved", label: "Approved" }
];

/** Allowed email TLDs for sales person contact emails */
const ALLOWED_SALES_EMAIL_TLDS = [
  'com', 'in', 'co', 'org', 'net', 'ai', 'io', 'app', 'store', 'online', 'shop', 'blog',
  'us', 'uk', 'ca', 'au', 'jp', 'de',
  'tech', 'site', 'website', 'xyz',
  'gov', 'edu', 'museum', 'travel', 'aero', 'coop',
];

/** Well-known consumer/business email providers (suggest when misspelled) */
const KNOWN_SALES_EMAIL_PROVIDERS = [
  'gmail.com',
  'outlook.com',
  'hotmail.com',
  'live.com',
  'yahoo.com',
  'icloud.com',
  'proton.me',
  'protonmail.com',
  'zohomail.com',
  'aol.com',
  'gmx.com',
  'mail.com',
  'yandex.com',
  'fastmail.com',
  'tuta.com',
  'tutamail.com',
];

/** Common misspellings → correct provider (covers cases fuzzy match may miss) */
const SALES_EMAIL_PROVIDER_ALIAS_BASE = {
  // Gmail
  'gaiml.com': 'gmail.com',
  'gmial.com': 'gmail.com',
  'gmal.com': 'gmail.com',
  'gmai.com': 'gmail.com',
  'gaml.com': 'gmail.com',
  'gmdg.com': 'gmail.com',
  'gnail.com': 'gmail.com',
  'gmaill.com': 'gmail.com',
  'gmil.com': 'gmail.com',
  'gmeil.com': 'gmail.com',
  'gmsil.com': 'gmail.com',
  'gmaik.com': 'gmail.com',
  'gmaio.com': 'gmail.com',
  'gmaol.com': 'gmail.com',
  'ggmail.com': 'gmail.com',
  'gmaul.com': 'gmail.com',
  'gemail.com': 'gmail.com',
  // Outlook
  'outlok.com': 'outlook.com',
  'outloo.com': 'outlook.com',
  'outlokk.com': 'outlook.com',
  'outllok.com': 'outlook.com',
  'outilook.com': 'outlook.com',
  'outs.com': 'outlook.com',
  'outl.com': 'outlook.com',
  'outlk.com': 'outlook.com',
  // Hotmail
  'hotmial.com': 'hotmail.com',
  'hotmal.com': 'hotmail.com',
  'hotmali.com': 'hotmail.com',
  'hotnail.com': 'hotmail.com',
  'hotmaill.com': 'hotmail.com',
  'hitmail.com': 'hotmail.com',
  'hots.com': 'hotmail.com',
  'hotm.com': 'hotmail.com',
  'hotma.com': 'hotmail.com',
  'hotmai.com': 'hotmail.com',
  'hotamil.com': 'hotmail.com',
  // Live
  'livve.com': 'live.com',
  'liev.com': 'live.com',
  'livr.com': 'live.com',
  // Yahoo
  'yahooo.com': 'yahoo.com',
  'yaho.com': 'yahoo.com',
  'yahho.com': 'yahoo.com',
  'yhaoo.com': 'yahoo.com',
  'yaoo.com': 'yahoo.com',
  'yahool.com': 'yahoo.com',
  'yahs.com': 'yahoo.com',
  // iCloud
  'iclod.com': 'icloud.com',
  'icoud.com': 'icloud.com',
  'iclould.com': 'icloud.com',
  'icluod.com': 'icloud.com',
  // Proton
  'protonmali.com': 'protonmail.com',
  'protonmil.com': 'protonmail.com',
  'protonmai.com': 'protonmail.com',
  'protone.me': 'proton.me',
  'protonn.me': 'proton.me',
  'protom.me': 'proton.me',
  // Zoho
  'zohomali.com': 'zohomail.com',
  'zohomil.com': 'zohomail.com',
  'zoohmail.com': 'zohomail.com',
  // AOL / GMX / Mail
  'aoll.com': 'aol.com',
  'aool.com': 'aol.com',
  'gmxx.com': 'gmx.com',
  'gmxz.com': 'gmx.com',
  'mai.com': 'mail.com',
  'maill.com': 'mail.com',
  // Yandex / Fastmail / Tuta
  'yandx.com': 'yandex.com',
  'yandeex.com': 'yandex.com',
  'fastmai.com': 'fastmail.com',
  'fastmali.com': 'fastmail.com',
  'fatmail.com': 'fastmail.com',
  'tutaa.com': 'tuta.com',
  'tutta.com': 'tuta.com',
  'tutamali.com': 'tutamail.com',
  'tutamil.com': 'tutamail.com',
};

/** Auto-add common TLD typos (.con / .cm / .om / .co) for every known provider */
const buildSalesEmailProviderAliases = () => {
  const aliases = { ...SALES_EMAIL_PROVIDER_ALIAS_BASE };
  const badTlds = ['con', 'cm', 'om', 'cmo', 'comm', 'co'];

  KNOWN_SALES_EMAIL_PROVIDERS.forEach((provider) => {
    const parts = provider.split('.');
    if (parts.length < 2) return;
    const tld = parts[parts.length - 1];
    const sld = parts.slice(0, -1).join('.');
    if (tld !== 'com' && tld !== 'me') return;

    badTlds.forEach((badTld) => {
      const badDomain = `${sld}.${badTld}`;
      if (!KNOWN_SALES_EMAIL_PROVIDERS.includes(badDomain) && !aliases[badDomain]) {
        aliases[badDomain] = provider;
      }
    });
  });

  return aliases;
};

const SALES_EMAIL_PROVIDER_ALIASES = buildSalesEmailProviderAliases();

const SALES_EMAIL_BASIC_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const getSalesEmailDomain = (email) => {
  const trimmed = String(email || '').trim().toLowerCase();
  const at = trimmed.lastIndexOf('@');
  if (at < 0) return '';
  return trimmed.slice(at + 1).replace(/\.+/g, '.').replace(/^\.|\.$/g, '');
};

const getSalesEmailTld = (email) => {
  const domain = getSalesEmailDomain(email);
  const parts = domain.split('.').filter(Boolean);
  return parts.length ? parts[parts.length - 1] : '';
};

const isAllowedSalesEmailDomain = (email) => {
  const tld = getSalesEmailTld(email);
  return Boolean(tld && ALLOWED_SALES_EMAIL_TLDS.includes(tld));
};

const levenshteinDistance = (a, b) => {
  const s = String(a || '');
  const t = String(b || '');
  if (s === t) return 0;
  if (!s.length) return t.length;
  if (!t.length) return s.length;

  const rows = s.length + 1;
  const cols = t.length + 1;
  const matrix = Array.from({ length: rows }, () => new Array(cols).fill(0));
  for (let i = 0; i < rows; i += 1) matrix[i][0] = i;
  for (let j = 0; j < cols; j += 1) matrix[0][j] = j;

  for (let i = 1; i < rows; i += 1) {
    for (let j = 1; j < cols; j += 1) {
      const cost = s[i - 1] === t[j - 1] ? 0 : 1;
      matrix[i][j] = Math.min(
        matrix[i - 1][j] + 1,
        matrix[i][j - 1] + 1,
        matrix[i - 1][j - 1] + cost
      );
    }
  }
  return matrix[s.length][t.length];
};

const LEGITIMATE_NON_PROVIDER_DOMAINS = [
  'google.com',
  'gmail.com',
  'gmx.com',
  'github.com',
  'gitlab.com',
  'godaddy.com',
  'groupon.com',
  'microsoft.com',
  'apple.com',
  'amazon.com',
  'zoho.com',
  'hotel.com',
  'hotels.com',
  'hotwire.com',
  'hotspot.com',
];

/**
 * Near-prefix / truncated provider names for ALL known providers.
 * e.g. hots.com → hotmail.com (hots ≈ hotm), outloo.com → outlook.com, gmai.com → gmail.com
 */
const getProviderSuggestionByNearPrefix = (domain) => {
  if (!domain || KNOWN_SALES_EMAIL_PROVIDERS.includes(domain)) return null;
  if (LEGITIMATE_NON_PROVIDER_DOMAINS.includes(domain)) return null;

  const parts = domain.split('.').filter(Boolean);
  if (parts.length < 2) return null;

  const typedTld = parts[parts.length - 1];
  const typedSld = parts.slice(0, -1).join('.');
  if (typedSld.length < 3 || typedSld.length > 14) return null;

  let bestProvider = null;
  let bestScore = Infinity;

  KNOWN_SALES_EMAIL_PROVIDERS.forEach((provider) => {
    const providerParts = provider.split('.').filter(Boolean);
    const providerTld = providerParts[providerParts.length - 1];
    const providerSld = providerParts.slice(0, -1).join('.');

    if (levenshteinDistance(typedTld, providerTld) > 1) return;
    if (typedSld === providerSld) return;

    let score = Infinity;

    // Exact truncation: "gmai" → "gmail", "outloo" → "outlook", "hotmai" → "hotmail"
    if (providerSld.startsWith(typedSld) && typedSld.length >= 3) {
      score = (providerSld.length - typedSld.length) * 0.5;
    } else if (typedSld.length <= providerSld.length) {
      // 1-edit from the same-length provider prefix: "hots" ≈ "hotm"
      const providerPrefix = providerSld.slice(0, typedSld.length);
      const prefixDistance = levenshteinDistance(typedSld, providerPrefix);
      if (prefixDistance <= 1 && typedSld.length >= 3) {
        score = prefixDistance + (providerSld.length - typedSld.length) * 0.35;
      }
    } else if (typedSld.length === providerSld.length + 1) {
      // One extra character: "gmaill" → "gmail"
      const extraDistance = levenshteinDistance(typedSld, providerSld);
      if (extraDistance <= 2) {
        score = extraDistance;
      }
    }

    // Shared first 3+ chars and close overall SLD distance
    if (score === Infinity && typedSld.length >= 3 && providerSld.length >= 4) {
      const shared = Math.min(4, typedSld.length, providerSld.length);
      if (typedSld.slice(0, shared) === providerSld.slice(0, shared)) {
        const sldDistance = levenshteinDistance(typedSld, providerSld);
        if (sldDistance > 0 && sldDistance <= 3) {
          score = sldDistance + 0.25;
        }
      }
    }

    if (score < bestScore) {
      bestScore = score;
      bestProvider = provider;
    }
  });

  if (!bestProvider || bestScore === Infinity) return null;

  // Guard short providers (aol/gmx/live/mail/tuta) — require very close match
  const bestSld = bestProvider.split('.').slice(0, -1).join('.');
  if (bestSld.length <= 4 && bestScore > 1.5) return null;

  return bestProvider;
};

/**
 * Pattern heuristics for known provider families
 * (misspelled SLD that still clearly belongs to one of our listed providers)
 */
const getProviderSuggestionByPattern = (domain) => {
  if (LEGITIMATE_NON_PROVIDER_DOMAINS.includes(domain)) return null;

  const hotmailFalsePositives = [
    'hotel.com',
    'hotels.com',
    'hotwire.com',
    'hotspot.com',
    'hotmail.com',
  ];

  const rules = [
    // Gmail: gmXXXX.com (except exact gmx.com)
    {
      provider: 'gmail.com',
      test: (d) => d !== 'gmx.com' && d !== 'gmail.com' && /^gm[a-z0-9]{1,6}\.com$/.test(d),
    },
    // Yahoo
    {
      provider: 'yahoo.com',
      test: (d) => d !== 'yahoo.com' && /^yah[a-z0-9]{0,5}\.com$/.test(d),
    },
    // Outlook
    {
      provider: 'outlook.com',
      test: (d) => d !== 'outlook.com' && /^outl[a-z0-9]{0,8}\.com$/.test(d),
    },
    // Hotmail — catch hots.com / hotm.com / hotmai.com (not hotel.com)
    {
      provider: 'hotmail.com',
      test: (d) => !hotmailFalsePositives.includes(d) && /^hot[a-z0-9]{1,8}\.com$/.test(d),
    },
    // Live
    {
      provider: 'live.com',
      test: (d) => d !== 'live.com' && /^liv[a-z0-9]{1,3}\.com$/.test(d),
    },
    // iCloud
    {
      provider: 'icloud.com',
      test: (d) => d !== 'icloud.com' && /^icl[a-z0-9]{1,8}\.com$/.test(d),
    },
    // Proton Mail / Proton
    {
      provider: 'protonmail.com',
      test: (d) => d !== 'protonmail.com' && /^protonm[a-z0-9]{0,8}\.com$/.test(d),
    },
    {
      provider: 'proton.me',
      test: (d) => d !== 'proton.me' && /^prot[a-z0-9]{0,5}\.me$/.test(d),
    },
    // Zoho Mail
    {
      provider: 'zohomail.com',
      test: (d) => d !== 'zohomail.com' && d !== 'zoho.com' && /^zohom[a-z0-9]{0,8}\.com$/.test(d),
    },
    // AOL
    {
      provider: 'aol.com',
      test: (d) => d !== 'aol.com' && /^ao[a-z0-9]{1,3}\.com$/.test(d),
    },
    // GMX
    {
      provider: 'gmx.com',
      test: (d) => d !== 'gmx.com' && /^gmx[a-z0-9]{1,3}\.com$/.test(d),
    },
    // Yandex
    {
      provider: 'yandex.com',
      test: (d) => d !== 'yandex.com' && /^yan[a-z0-9]{1,6}\.com$/.test(d),
    },
    // Fastmail
    {
      provider: 'fastmail.com',
      test: (d) => d !== 'fastmail.com' && /^fastm[a-z0-9]{0,8}\.com$/.test(d),
    },
    // Tuta / Tuta Mail
    {
      provider: 'tutamail.com',
      test: (d) => d !== 'tutamail.com' && /^tutam[a-z0-9]{0,8}\.com$/.test(d),
    },
    {
      provider: 'tuta.com',
      test: (d) => d !== 'tuta.com' && d !== 'tutamail.com' && /^tut[a-z0-9]{1,3}\.com$/.test(d),
    },
    // Mail.com
    {
      provider: 'mail.com',
      test: (d) => d !== 'mail.com' && /^mai[a-z0-9]{1,3}\.com$/.test(d),
    },
  ];

  for (let i = 0; i < rules.length; i += 1) {
    if (rules[i].test(domain)) return rules[i].provider;
  }
  return null;
};

/** Preferred provider when a gibberish / mangled free-mail domain starts with this letter */
const PROVIDER_BY_FIRST_LETTER = {
  g: 'gmail.com',
  y: 'yahoo.com',
  o: 'outlook.com',
  h: 'hotmail.com',
  i: 'icloud.com',
  p: 'protonmail.com',
  z: 'zohomail.com',
  a: 'aol.com',
  l: 'live.com',
  f: 'fastmail.com',
  t: 'tutamail.com',
  m: 'mail.com',
};

const isGibberishEmailSld = (sld) => {
  const value = String(sld || '').toLowerCase();
  if (!value || value.length < 4 || value.length > 12) return false;
  if (value.includes('-')) return false;

  // Treat "y" as a vowel so real words like "myths" are less likely flagged
  const vowels = (value.match(/[aeiouy]/g) || []).length;
  const vowelRatio = vowels / value.length;
  const hasTripleRepeat = /(.)\1{2,}/.test(value);
  const consonantRuns = /[bcdfghjklmnpqrstvwxz]{4,}/.test(value);

  // Random typed domains like "gsdfddf" have almost no vowels / long consonant runs
  return (
    vowels === 0
    || hasTripleRepeat
    || (consonantRuns && vowelRatio < 0.25)
    || (vowelRatio < 0.18 && value.length >= 6)
  );
};

/**
 * Catch heavily misspelled / randomly typed free-mail domains
 * (e.g. gsdfddf.com → gmail.com) while keeping real company domains valid.
 */
const getProviderSuggestionForMangledDomain = (domain) => {
  if (!domain || KNOWN_SALES_EMAIL_PROVIDERS.includes(domain)) return null;
  if (LEGITIMATE_NON_PROVIDER_DOMAINS.includes(domain)) return null;

  const parts = domain.split('.').filter(Boolean);
  if (parts.length !== 2) return null;

  const [sld, tld] = parts;
  if (!['com', 'me', 'net'].includes(tld)) return null;
  if (!isGibberishEmailSld(sld)) return null;

  // Prefer gmx only when it clearly starts like gmx
  if (/^gmx[a-z0-9]*$/.test(sld) && sld !== 'gmx') {
    return 'gmx.com';
  }

  const byLetter = PROVIDER_BY_FIRST_LETTER[sld.charAt(0)];
  if (!byLetter) return null;

  // Avoid mapping long brand-like names that happen to look noisy
  if (sld.length > 10 && byLetter === 'mail.com') return null;

  return byLetter;
};

/**
 * If domain looks like a misspelled known provider, return the correct domain.
 * Applies to ALL listed providers (gmail, outlook, yahoo, hotmail, etc.).
 */
const getMisspelledEmailProviderSuggestion = (email) => {
  const domain = getSalesEmailDomain(email);
  if (!domain || KNOWN_SALES_EMAIL_PROVIDERS.includes(domain)) return null;
  if (LEGITIMATE_NON_PROVIDER_DOMAINS.includes(domain)) return null;

  // 1) Exact alias map (strongest)
  if (SALES_EMAIL_PROVIDER_ALIASES[domain]) {
    return SALES_EMAIL_PROVIDER_ALIASES[domain];
  }

  // 2) Provider-family patterns (all listed providers)
  const patternSuggestion = getProviderSuggestionByPattern(domain);
  if (patternSuggestion) return patternSuggestion;

  // 3) Truncated / near-prefix matches (hots → hotmail, gmai → gmail, outloo → outlook)
  const nearPrefixSuggestion = getProviderSuggestionByNearPrefix(domain);
  if (nearPrefixSuggestion) return nearPrefixSuggestion;

  // 4) Heavily mangled / random free-mail typing (gsdfddf.com → gmail.com)
  const mangledSuggestion = getProviderSuggestionForMangledDomain(domain);
  if (mangledSuggestion) return mangledSuggestion;

  const typedParts = domain.split('.').filter(Boolean);
  if (typedParts.length < 2) return null;
  const typedTld = typedParts[typedParts.length - 1];
  const typedSld = typedParts.slice(0, -1).join('.');

  let bestProvider = null;
  let bestScore = Infinity;
  let bestMeta = null;

  KNOWN_SALES_EMAIL_PROVIDERS.forEach((provider) => {
    const providerParts = provider.split('.').filter(Boolean);
    const providerTld = providerParts[providerParts.length - 1];
    const providerSld = providerParts.slice(0, -1).join('.');

    const fullDistance = levenshteinDistance(domain, provider);
    const sldDistance = levenshteinDistance(typedSld, providerSld);
    const tldDistance = levenshteinDistance(typedTld, providerTld);
    const lenDiff = Math.abs(typedSld.length - providerSld.length);
    const prefix2Match =
      typedSld.length >= 2
      && providerSld.length >= 2
      && typedSld.slice(0, 2) === providerSld.slice(0, 2);
    const prefix3Match =
      typedSld.length >= 3
      && providerSld.length >= 3
      && typedSld.slice(0, 3) === providerSld.slice(0, 3);

    // Prefer closer SLD + similar length; bonus for shared prefix
    const score =
      sldDistance
      + tldDistance * 0.4
      + lenDiff * 0.35
      - (prefix3Match ? 1.1 : prefix2Match ? 0.75 : 0)
      + (fullDistance * 0.05)
      // Prefer longer/more specific providers when scores are close
      - Math.min(providerSld.length, 10) * 0.02;

    if (score > 0 && score < bestScore) {
      bestScore = score;
      bestProvider = provider;
      bestMeta = {
        fullDistance,
        sldDistance,
        tldDistance,
        providerSld,
        providerTld,
        prefix2Match,
        prefix3Match,
      };
    }
  });

  if (!bestProvider || !bestMeta) return null;

  const {
    fullDistance,
    sldDistance,
    tldDistance,
    providerSld,
    prefix2Match,
    prefix3Match,
  } = bestMeta;

  const sameLengthSld = typedSld.length === providerSld.length;
  const firstCharMatch = typedSld.charAt(0) === providerSld.charAt(0);
  const sortedSldMatch =
    sameLengthSld
    && typedSld.split('').sort().join('') === providerSld.split('').sort().join('');

  // Longer providers (outlook/hotmail/yahoo/gmail/...) allow up to 3 edits
  const maxSldDistance =
    (prefix3Match && providerSld.length >= 4)
    || (prefix2Match && providerSld.length >= 5)
      ? 3
      : 2;

  const isLikelyTypo =
    (fullDistance > 0 && fullDistance <= maxSldDistance && firstCharMatch)
    || (sldDistance > 0 && sldDistance <= maxSldDistance && tldDistance <= 1 && firstCharMatch)
    || (sortedSldMatch && tldDistance <= 1 && typedSld !== providerSld)
    || (prefix3Match && sldDistance > 0 && sldDistance <= 3 && tldDistance <= 1);

  if (!isLikelyTypo) return null;

  // Avoid forcing unrelated short domains onto mail.com / aol.com / gmx.com / live.com / tuta.com
  if (
    providerSld.length <= 4
    && sldDistance > 1
    && !sortedSldMatch
    && !prefix3Match
  ) {
    return null;
  }

  return bestProvider;
};

/** Error message shown for misspelled / invalid sales emails */
const getSalesPersonEmailProviderErrorMessage = (correctProvider) => (
  `Correct your mail id, it should be ${correctProvider}`
);

/** Returns error message or '' if valid */
const getSalesPersonEmailError = (email) => {
  const trimmed = String(email || '').trim();
  if (!trimmed) return 'Email ID is required';
  if (!trimmed.includes('@')) return 'Email must contain @ symbol';
  if (!trimmed.includes('.')) return 'Email must contain a domain (e.g., .com, .in)';
  if (!SALES_EMAIL_BASIC_REGEX.test(trimmed)) {
    return 'Please enter a valid email address (e.g., name@domain.com)';
  }

  const providerSuggestion = getMisspelledEmailProviderSuggestion(trimmed);
  if (providerSuggestion) {
    return getSalesPersonEmailProviderErrorMessage(providerSuggestion);
  }

  if (!isAllowedSalesEmailDomain(trimmed)) {
    return 'Email domain not allowed. Use Accurate Email ID.';
  }
  return '';
};

const isValidSalesPersonEmail = (email) => !getSalesPersonEmailError(email);

const LAND_OWNERSHIP_OPTIONS = [
  "Freehold", "Leasehold", "Power of Attorney", "Co-operative Society"
];

const BANK_OPTIONS = [
  "SBI",
  "HDFC Bank",
  "Kotak Mahindra Bank",
  "ICICI Bank",
  "Axis Bank",
  "Bank of Baroda (BoB)",
  "Other"
];

// Indian states for state suggestion dropdown
const INDIAN_STATES = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand',
  'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
  'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab',
  'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura',
  'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
  'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu',
  'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Lakshadweep', 'Puducherry'
];

export default function AddUpcomingProjectPopup({ onClose, editData = null }) {
  const navigate = useNavigate();
  const { addProperty, updateProperty, refreshData, properties } = useProperty();
  const isEditMode = !!editData;

  const [currentStep, setCurrentStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadingImages, setUploadingImages] = useState(false);
  const [errors, setErrors] = useState({});
  const [brochureSizeExceeded, setBrochureSizeExceeded] = useState(false);
  const [isPublished, setIsPublished] = useState(false); // Track if publishing is completed
  const [showCloseWarning, setShowCloseWarning] = useState(false); // Show warning modal when trying to close on final step
  const [isDiscarded, setIsDiscarded] = useState(false); // Track if user discarded the form
  const [showLocationPicker, setShowLocationPicker] = useState(false);
  const [mapCenterFromAddress, setMapCenterFromAddress] = useState(null);
  const [imageFiles, setImageFiles] = useState([]);
  const [imageValidationStatus, setImageValidationStatus] = useState([]); // Track validation status for each image
  const [isCheckingImages, setIsCheckingImages] = useState(false);
  const [builderName, setBuilderName] = useState('');
  const [stateAutoFilled, setStateAutoFilled] = useState(false); // Track if state was auto-filled from map
  const [stateDropdownOpen, setStateDropdownOpen] = useState(false); // State suggestion dropdown visibility
  const [launchDatePickerOpen, setLaunchDatePickerOpen] = useState(false); // Launch date picker dropdown visibility
  const [possessionDatePickerOpen, setPossessionDatePickerOpen] = useState(false); // Possession date picker dropdown visibility
  const stateDropdownRef = useRef(null);
  const imagesRef = useRef();
  const brochureRef = useRef(null);
  const popupBodyRef = useRef(null);

  // Get builder name from logged-in user
  useEffect(() => {
    const user = authAPI.getUser();
    if (user && user.full_name) {
      setBuilderName(user.full_name);
    }
  }, []);

  // Prevent body scroll when LocationPicker is open
useEffect(() => {
  if (showLocationPicker) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'unset';
  }
  return () => {
    document.body.style.overflow = 'unset';
  };
}, [showLocationPicker]);

  // Pre-fill form data when in edit mode
//   useEffect(() => {
//     if (editData && isEditMode) {
//       // Parse upcoming_project_data if it's a string
//       let upcomingData = {};
//       try {
//         if (typeof editData.upcomingProjectData === 'string') {
//           upcomingData = JSON.parse(editData.upcomingProjectData);
//         } else if (typeof editData.upcomingProjectData === 'object' && editData.upcomingProjectData) {
//           upcomingData = editData.upcomingProjectData;
//         }
//       } catch (e) {
//         console.warn('Failed to parse upcoming_project_data:', e);
//       }

//       // Map legacy project types to current property form values
//       const legacyProjectTypeMap = {
//         "Villa": "Villa / Banglow",
//         "Plot": "Plot / Land / Indusrtial Property",
//         "Commercial": "Commercial Office"
//       };
//       const projectType = legacyProjectTypeMap[editData.propertyType] || editData.propertyType || "";

//       // Map legacy amenity ids to current (e.g. play_area -> playground)
//       const rawAmenities = Array.isArray(editData.amenities) ? editData.amenities : [];
//       const amenities = rawAmenities.map((a) => (a === "play_area" ? "playground" : a));

//       // Pre-fill form with existing data
//       setFormData({
//         // Step 1: Basic Project Information
//         projectName: editData.title || "",
//         builderName: upcomingData.builderName || builderName || "",
//         projectType,
//         projectStatus: upcomingData.projectStatus || "UNDER CONSTRUCTION",
//         reraNumber: upcomingData.reraNumber || "",
//         description: editData.description || "",

//         // Step 2: Location Details
//         city: "",
//         area: editData.location || "",
//         location: editData.location || "", // Also set location field for form compatibility
//         fullAddress: editData.additionalAddress || "",
//         latitude: editData.latitude || "",
//         longitude: editData.longitude || "",
//         state: editData.state || "",
//         pincode: upcomingData.pincode || "",
//         mapLink: upcomingData.mapLink || "",

//         // Step 3: Configuration & Inventory
//         configurations: Array.isArray(upcomingData.configurations) ? upcomingData.configurations : [],
//         carpetAreaRange: upcomingData.carpetAreaRange || "",
//         numberOfTowers: upcomingData.numberOfTowers || "",
//         totalUnits: upcomingData.totalUnits || "",
//         floorsCount: upcomingData.floorsCount || "",
//         unitsPerFloor: upcomingData.unitsPerFloor || "",
//         numberOfVillas: upcomingData.numberOfVillas || "",
//         numberOfPlots: upcomingData.numberOfPlots || "",
//         bedCapacity: upcomingData.bedCapacity || "",
//         loadingDocks: upcomingData.loadingDocks || "",

//         // Step 4: Pricing & Timeline
//         startingPrice: editData.price ? (parseFloat(editData.price) / 10000000).toFixed(2) + " Cr" : "",
//         pricePerSqft: upcomingData.pricePerSqft || "",
//         bookingAmount: upcomingData.bookingAmount || "",
//         expectedLaunchDate: upcomingData.expectedLaunchDate || "",
//         expectedPossessionDate: upcomingData.expectedPossessionDate || "",

//         // Step 5: Amenities (normalized for legacy ids)
//         amenities,

//         // Step 6: Legal & Approval
//         reraStatus: upcomingData.reraStatus || "",
//         landOwnershipType: upcomingData.landOwnershipType || "",
//         bankApproved: upcomingData.bankApproved || "",
//         approvedBanks: Array.isArray(upcomingData.approvedBanks) ? upcomingData.approvedBanks : [],
//         otherBankName: "",

//         // Step 7: Media
//         coverImage: (() => {
//           const resolved = resolvePropertyImageUrls(editData.images);
//           return resolved.length > 0 ? { url: resolved[0], isExisting: true } : null;
//         })(),
//         projectImages: resolvePropertyImageUrls(editData.images),
//       //  brochure: buildBrochureFromUrl(editData.brochureUrl || editData.brochure_url),
//       // brochures: editData.brochureUrl || editData.brochure_url 
//       // ? [{ 
//       //     name: 'Brochure.pdf', 
//       //     url: editData.brochureUrl || editData.brochure_url, 
//       //     isExisting: true 
//       //   }] 
//       // : [],


// // NEW CODE (multiple brochures):
// brochures: (() => {
//   // Check if there are multiple brochure URLs
//   const brochureUrls = editData.brochureUrl || editData.brochure_url || [];
  
//   // If it's a string (single brochure), convert to array
//   let urls = [];
//   if (typeof brochureUrls === 'string') {
//     // Check if it's a JSON string containing an array
//     try {
//       const parsed = JSON.parse(brochureUrls);
//       if (Array.isArray(parsed)) {
//         urls = parsed;
//       } else {
//         urls = [brochureUrls];
//       }
//     } catch {
//       // Not JSON, treat as single URL
//       urls = [brochureUrls];
//     }
//   } else if (Array.isArray(brochureUrls)) {
//     urls = brochureUrls;
//   }
  
//   // Filter out empty/null values and create brochure objects
//   return urls
//     .filter(url => url && url.trim() !== '')
//     .map((url, index) => ({
//       name: `Brochure ${index + 1}.pdf`,
//       url: url,
//       isExisting: true,
//       id: `existing-${Date.now()}-${index}`
//     }));
// })(),



//         // Step 8: Contact & Sales (support both legacy single contact and salesPersons array)
//         salesPersons: Array.isArray(upcomingData.salesPersons) && upcomingData.salesPersons.length > 0
//           ? upcomingData.salesPersons.map(sp => ({
//             name: sp.name || '',
//             number: sp.number || '',
//             email: sp.email || '',
//             landlineNumber: sp.landlineNumber || '',
//             whatsappNumber: sp.whatsappNumber || '',
//             alternativeNumber: sp.alternativeNumber || ''
//           }))
//           : [{
//             name: upcomingData.salesName || "",
//             number: upcomingData.salesNumber || "",
//             email: upcomingData.emailId || "",
//             landlineNumber: upcomingData.landlineNumber || upcomingData.mobileNumber || "",
//             whatsappNumber: upcomingData.whatsappNumber || "",
//             alternativeNumber: upcomingData.alternativeNumber || ""
//           }].filter(sp => sp.name || sp.number || sp.email).length > 0
//             ? [{ name: upcomingData.salesName || "", number: upcomingData.salesNumber || "", email: upcomingData.emailId || "", landlineNumber: upcomingData.landlineNumber || upcomingData.mobileNumber || "", whatsappNumber: upcomingData.whatsappNumber || "", alternativeNumber: upcomingData.alternativeNumber || "" }]
//             : [{ name: "", number: "", email: "", landlineNumber: "", whatsappNumber: "", alternativeNumber: "" }],
//         landlineNumber: upcomingData.landlineNumber || upcomingData.mobileNumber || "",
//         whatsappNumber: upcomingData.whatsappNumber || "",
//         alternativeNumber: upcomingData.alternativeNumber || "",

//         // Step 9: Marketing
//         projectHighlights: upcomingData.projectHighlights || "",
//         usp: upcomingData.usp || ""
//       });

//       const resolvedImages = resolvePropertyImageUrls(editData.images);
//       if (resolvedImages.length > 0) {
//         setImageValidationStatus(createExistingImageValidationStatus(resolvedImages));
//       }
//     }
//   }, [editData, isEditMode, builderName]);


  // formData MUST be declared before any effect that calls setFormData
  const [formData, setFormData] = useState(() =>
    buildUpcomingFormFromEditData(editData, "")
  );

  // Prefill / refresh when opening edit (or when builder name loads)
  useEffect(() => {
    if (!editData || !isEditMode) return;

    const next = buildUpcomingFormFromEditData(editData, builderName);
    setFormData(next);

    if (Array.isArray(next.projectImages) && next.projectImages.length > 0) {
      setImageValidationStatus(
        createExistingImageValidationStatus(next.projectImages)
      );
    }

    // Flag misspelled / invalid sales emails immediately in edit mode
    const emailErrors = {};
    (next.salesPersons || []).forEach((sp, idx) => {
      const email = (sp.email || '').trim();
      if (!email) return;
      const emailError = getSalesPersonEmailError(email);
      if (emailError) {
        emailErrors[`salesPerson_email_${idx}`] = emailError;
      }
    });
    setErrors((prev) => {
      const cleaned = { ...prev };
      Object.keys(cleaned).forEach((key) => {
        if (key.startsWith('salesPerson_email_')) delete cleaned[key];
      });
      return { ...cleaned, ...emailErrors };
    });

    // Debug aid in local/dev: confirm brochures loaded for Media step
    if (process.env.NODE_ENV === "development") {
      console.log("[Edit Project] brochures loaded:", next.brochures?.length || 0, next.brochures);
    }
  }, [editData, isEditMode, builderName]);

  // Reset all form state (for hard discard)
  const resetFormState = useCallback(() => {
    setFormData({ ...EMPTY_UPCOMING_FORM });
    setCurrentStep(1);
    setErrors({});
    setBrochureSizeExceeded(false);
    setImageFiles([]);
    setImageValidationStatus([]);
    setIsCheckingImages(false);
    setStateAutoFilled(false);
    setMapCenterFromAddress(null);
    setIsSubmitting(false);
    setUploadingImages(false);
    setIsPublished(false);
  }, []);

  // Handle discard and close - HARD DISCARD
  const handleDiscardAndClose = useCallback(() => {
    setIsDiscarded(true);
    resetFormState();
    setShowCloseWarning(false);
    onClose();
  }, [resetFormState, onClose]);

  // Handle close attempt - check if on final step and not published
  const handleCloseAttempt = useCallback(() => {
    const isFinalStep = currentStep === STEPS.length;
    if (isFinalStep && !isPublished) {
      // Show warning modal instead of closing
      setShowCloseWarning(true);
      return;
    }
    // Allow closing if not on final step or already published
    onClose();
  }, [currentStep, isPublished, onClose]);

  // Close on escape
  useEffect(() => {
    if (showCloseWarning) return; // Don't close main popup when warning modal is open
    const onKey = (e) => {
      if (e.key === "Escape") {
        handleCloseAttempt();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [handleCloseAttempt, showCloseWarning]);

  // Close state dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (stateDropdownRef.current && !stateDropdownRef.current.contains(e.target)) {
        setStateDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Cleanup blob URLs on unmount
  useEffect(() => {
    return () => {
      if (formData.projectImages) {
        formData.projectImages.forEach(img => {
          if (typeof img === 'string' && img.startsWith('blob:')) {
            URL.revokeObjectURL(img);
          }
        });
      }
    };
  }, []);

  const handleChange = (field, value) => {
    setFormData(prev => {
      const next = { ...prev, [field]: value };
      // When project type changes, keep only configurations valid for the new type
      if (field === "projectType") {
        const options = CONFIGURATION_BY_PROJECT_TYPE[value] || [];
        next.configurations = (prev.configurations || []).filter((c) => options.includes(c));
      }
      return next;
    });
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: null }));
    }
  };

  // Handle price input — allow Indian units so edit can keep Lakh / Thousand / Cr
  const handlePriceChange = (field, value) => {
    // Digits, separators, and unit words (Lakh, Lac, Thousand, Cr, Crore)
    const sanitized = value.replace(/[^\d.\-\s,a-zA-Z]/g, '');
    handleChange(field, sanitized);
  };

  // Handle carpet area range input - strip sq.ft if user types it; unit shown via suffix
  const handleCarpetAreaChange = (value) => {
    handleChange('carpetAreaRange', stripAreaSqFtUnit(value));
  };

  const toggleConfiguration = (config) => {
    setFormData(prev => {
      const current = sanitizeConfigurationsForProjectType(
        prev.configurations,
        prev.projectType,
        CONFIGURATION_BY_PROJECT_TYPE
      );
      const next = current.includes(config)
        ? current.filter((item) => item !== config)
        : [...current, config];
      return { ...prev, configurations: next };
    });
    if (errors.configurations) {
      setErrors(prev => ({ ...prev, configurations: null }));
    }
  };

  const toggleAmenity = (amenityId) => {
    setFormData(prev => ({
      ...prev,
      amenities: prev.amenities.includes(amenityId)
        ? prev.amenities.filter(a => a !== amenityId)
        : [...prev.amenities, amenityId]
    }));
    // Clear amenities error when user selects/deselects an amenity
    if (errors.amenities) {
      setErrors(prev => ({ ...prev, amenities: null }));
    }
  };

  const handleGenerateDescription = () => {
    const amenityLabels = collectAmenityLabels(formData.amenities, AMENITIES);
    const generated = generateUpcomingProjectDescription(formData,
      {
      amenityLabels,
  //    builderName,
    }
  );
    handleChange('description', generated);
    if (errors.description) {
      setErrors(prev => ({ ...prev, description: null }));
    }
  };

  const toggleBank = (bank) => {
    setFormData(prev => ({
      ...prev,
      approvedBanks: (prev.approvedBanks || []).includes(bank)
        ? (prev.approvedBanks || []).filter(b => b !== bank)
        : [...(prev.approvedBanks || []), bank]
    }));
  };

  const defaultSalesPerson = () => ({ name: '', number: '', email: '', landlineNumber: '', whatsappNumber: '', alternativeNumber: '' });

  // const updateSalesPerson = (index, field, value) => {
  //   setFormData(prev => {
  //     const next = [...(prev.salesPersons || [defaultSalesPerson()])];
  //     if (!next[index]) next[index] = defaultSalesPerson();
  //     next[index] = { ...next[index], [field]: value };
  //     return { ...prev, salesPersons: next };
  //   });
  //   setErrors(prev => {
  //     const next = { ...prev };
  //     ['name', 'number', 'email'].forEach(f => {
  //       if (next[`salesPerson_${f}_${index}`]) delete next[`salesPerson_${f}_${index}`];
  //     });
  //     return next;
  //   });
  // };

  // const updateSalesPerson = (index, field, value) => {
  //   // Format the value based on field type
  //   let formattedValue = value;
    
  //   if (field === 'number') {
  //     // Only allow digits, max 10 characters
  //     formattedValue = value.replace(/\D/g, '').slice(0, 10);
      
  //     // Real-time validation: clear error if exactly 10 digits
  //     if (formattedValue.length === 10 && /^[6-9]\d{9}$/.test(formattedValue)) {
  //       setErrors(prev => {
  //         const next = { ...prev };
  //         delete next[`salesPerson_number_${index}`];
  //         return next;
  //       });
  //     }
  //   } else if (field === 'email') {
  //     formattedValue = value.trim();
  //   } else if (field === 'name') {
  //     formattedValue = value.replace(/[^a-zA-Z\s]/g, '');
  //   }
    
  //   setFormData(prev => {
  //     const next = [...(prev.salesPersons || [defaultSalesPerson()])];
  //     if (!next[index]) next[index] = defaultSalesPerson();
  //     next[index] = { ...next[index], [field]: formattedValue };
  //     return { ...prev, salesPersons: next };
  //   });
  // };

  // const updateSalesPerson = (index, field, value) => {
  //   // Format the value based on field type
  //   let formattedValue = value;
    
  //   if (field === 'number') {
  //     // Only allow digits, max 10 characters
  //     formattedValue = value.replace(/\D/g, '').slice(0, 10);
      
  //     // Real-time validation: clear error if exactly 10 valid digits
  //     if (formattedValue.length === 10 && /^[6-9]\d{9}$/.test(formattedValue)) {
  //       setErrors(prev => {
  //         const next = { ...prev };
  //         delete next[`salesPerson_number_${index}`];
  //         return next;
  //       });
  //     }
  //   } else if (field === 'email') {
  //     formattedValue = value.trim();
  //   } else if (field === 'name') {
  //     formattedValue = value.replace(/[^a-zA-Z\s]/g, '');
  //   }
    
  //   setFormData(prev => {
  //     const next = [...(prev.salesPersons || [defaultSalesPerson()])];
  //     if (!next[index]) next[index] = defaultSalesPerson();
  //     next[index] = { ...next[index], [field]: formattedValue };
  //     return { ...prev, salesPersons: next };
  //   });
    
  //   // Clear error for this field if it exists
  //   setErrors(prev => {
  //     const next = { ...prev };
  //     const errorKey = `salesPerson_${field}_${index}`;
  //     if (next[errorKey]) {
  //       delete next[errorKey];
  //     }
  //     return next;
  //   });
  // };

  // const updateSalesPerson = (index, field, value) => {
  //   // Format the value based on field type
  //   let formattedValue = value;
    
  //   if (field === 'number') {
  //     // Only allow digits, max 10 characters
  //     formattedValue = value.replace(/\D/g, '').slice(0, 10);
      
  //     // Real-time validation: clear error if exactly 10 valid digits
  //     if (formattedValue.length === 10 && /^[6-9]\d{9}$/.test(formattedValue)) {
  //       setErrors(prev => {
  //         const next = { ...prev };
  //         delete next[`salesPerson_number_${index}`];
  //         return next;
  //       });
  //     }
  //   } else if (field === 'email') {
  //     formattedValue = value.trim();
      
  //     // Real-time validation for email
  //     const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  //     if (formattedValue.length > 0 && emailRegex.test(formattedValue)) {
  //       setErrors(prev => {
  //         const next = { ...prev };
  //         delete next[`salesPerson_email_${index}`];
  //         return next;
  //       });
  //     }
  //   } else if (field === 'name') {
  //     formattedValue = value.replace(/[^a-zA-Z\s]/g, '');
  //   }
    
  //   setFormData(prev => {
  //     const next = [...(prev.salesPersons || [defaultSalesPerson()])];
  //     if (!next[index]) next[index] = defaultSalesPerson();
  //     next[index] = { ...next[index], [field]: formattedValue };
  //     return { ...prev, salesPersons: next };
  //   });
    
  //   // Clear error for this field if it exists
  //   setErrors(prev => {
  //     const next = { ...prev };
  //     const errorKey = `salesPerson_${field}_${index}`;
  //     if (next[errorKey]) {
  //       delete next[errorKey];
  //     }
  //     return next;
  //   });
  // };
  // const updateSalesPerson = (index, field, value) => {
  //   // Format the value based on field type
  //   let formattedValue = value;
    
  //   if (field === 'number') {
  //     // Only allow digits, max 10 characters
  //     formattedValue = value.replace(/\D/g, '').slice(0, 10);
      
  //     // Real-time validation: clear error if exactly 10 valid digits
  //     if (formattedValue.length === 10 && /^[6-9]\d{9}$/.test(formattedValue)) {
  //       setErrors(prev => {
  //         const next = { ...prev };
  //         delete next[`salesPerson_number_${index}`];
  //         return next;
  //       });
  //     }
  //   } else if (field === 'email') {
  //     formattedValue = value.trim();
      
  //     // Real-time validation for email
  //     const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  //     if (formattedValue.length > 0 && emailRegex.test(formattedValue)) {
  //       setErrors(prev => {
  //         const next = { ...prev };
  //         delete next[`salesPerson_email_${index}`];
  //         return next;
  //       });
  //     }
  //   } else if (field === 'name') {
  //     formattedValue = value.replace(/[^a-zA-Z\s]/g, '');
  //   }
    
  //   setFormData(prev => {
  //     const next = [...(prev.salesPersons || [defaultSalesPerson()])];
  //     if (!next[index]) next[index] = defaultSalesPerson();
  //     next[index] = { ...next[index], [field]: formattedValue };
  //     return { ...prev, salesPersons: next };
  //   });
    
  //   // Clear error for this field if it exists
  //   setErrors(prev => {
  //     const next = { ...prev };
  //     const errorKey = `salesPerson_${field}_${index}`;
  //     if (next[errorKey]) {
  //       delete next[errorKey];
  //     }
  //     return next;
  //   });
  // };

  const updateSalesPerson = (index, field, value) => {
    // Format the value based on field type
    let formattedValue = value;
    
    if (field === 'number' || field === 'whatsappNumber' || field === 'alternativeNumber') {
      // Only allow digits, max 10 characters
      formattedValue = value.replace(/\D/g, '').slice(0, 10);
      
      // Real-time validation: clear error if exactly 10 valid digits
      if (formattedValue.length === 10 && /^[6-9]\d{9}$/.test(formattedValue)) {
        setErrors(prev => {
          const next = { ...prev };
          delete next[`salesPerson_${field}_${index}`];
          return next;
        });
      }
    } else if (field === 'landlineNumber') {
      // Allow digits, spaces, and hyphens for landline
      formattedValue = value.replace(/[^\d\s\-]/g, '').slice(0, 15);
      
      // Real-time validation for landline (basic check)
      const cleanLandline = formattedValue.replace(/\D/g, '');
      if (cleanLandline.length > 0 && cleanLandline.length >= 10 && cleanLandline.length <= 15) {
        setErrors(prev => {
          const next = { ...prev };
          delete next[`salesPerson_landlineNumber_${index}`];
          return next;
        });
      }
    } else if (field === 'email') {
      formattedValue = value.trim();

      // Live validation (format, misspelled providers, allowed TLDs)
      if (!formattedValue) {
        setErrors((prev) => {
          const next = { ...prev };
          delete next[`salesPerson_email_${index}`];
          return next;
        });
      } else if (isValidSalesPersonEmail(formattedValue)) {
        setErrors((prev) => {
          const next = { ...prev };
          delete next[`salesPerson_email_${index}`];
          return next;
        });
      } else if (formattedValue.includes('@') && formattedValue.includes('.')) {
        const emailError = getSalesPersonEmailError(formattedValue);
        if (emailError) {
          setErrors((prev) => ({
            ...prev,
            [`salesPerson_email_${index}`]: emailError,
          }));
        }
      }
    } else if (field === 'name') {
      formattedValue = value.replace(/[^a-zA-Z\s]/g, '');
    }
    
    setFormData(prev => {
      const next = [...(prev.salesPersons || [defaultSalesPerson()])];
      if (!next[index]) next[index] = defaultSalesPerson();
      next[index] = { ...next[index], [field]: formattedValue };
      return { ...prev, salesPersons: next };
    });
    
    // Clear error for this field if it exists (email handled live above)
    if (field !== 'email') {
      setErrors(prev => {
        const next = { ...prev };
        const errorKey = `salesPerson_${field}_${index}`;
        if (next[errorKey]) {
          delete next[errorKey];
        }
        return next;
      });
    }
  };

  

  const addSalesPerson = () => {
    setFormData(prev => {
      const currentSalesPersons = prev.salesPersons || [];
      if (currentSalesPersons.length >= 5) return prev;
      return {
        ...prev,
        salesPersons: [...currentSalesPersons, defaultSalesPerson()]
      };
    });
  };

  const removeSalesPerson = (index) => {
    setFormData(prev => {
      const next = (prev.salesPersons || []).filter((_, i) => i !== index);
      if (next.length === 0) next.push(defaultSalesPerson());
      return { ...prev, salesPersons: next };
    });
    setErrors(prev => {
      const next = { ...prev };
      Object.keys(next).forEach(k => {
        if (k.startsWith('salesPerson_')) delete next[k];
      });
      return next;
    });
  };

  // Handle location selection from LocationPicker (map)
  const handleLocationSelect = (locationData) => {
    // Auto-populate state from map selection if available
    const stateFromMap = locationData.state || '';
    const wasStateAutoFilled = !!stateFromMap;

    setFormData(prev => ({
      ...prev,
      latitude: locationData.latitude.toString(),
      longitude: locationData.longitude.toString(),
      location: locationData.fullAddress || prev.location || prev.area,
      // DO NOT auto-fill fullAddress - it should remain NULL unless manually entered
      // fullAddress: locationData.fullAddress || prev.fullAddress, // REMOVED
      // Always update state from map (even if empty) to reflect the new location
      state: stateFromMap
    }));

    // Track if state was auto-filled from map
    setStateAutoFilled(wasStateAutoFilled);
    setShowLocationPicker(false);
    if (errors.location || errors.area || errors.state) {
      setErrors(prev => ({ ...prev, location: null, area: null, state: null }));
    }
  };

  // Handle location selection from LocationAutoSuggest dropdown
  const handleLocationDropdownSelect = (locationData) => {
    if (!locationData) {
      // Clear location and state when location is cleared
      setFormData(prev => ({
        ...prev,
        location: '',
        area: '',
        state: '',
        latitude: '',
        longitude: ''
      }));
      setStateAutoFilled(false);
      setMapCenterFromAddress(null);
      if (errors.location || errors.area || errors.state) {
        setErrors(prev => ({ ...prev, location: null, area: null, state: null }));
      }
      return;
    }

    // Auto-populate state from location dropdown selection
    const stateFromLocation = locationData.state || '';
    const wasStateAutoFilled = !!stateFromLocation;

    setFormData(prev => ({
      ...prev,
      location: locationData.placeName || locationData.fullAddress || prev.location || prev.area,
      area: locationData.placeName || locationData.fullAddress || prev.area,
      // Do not auto-pin from typed address: user must confirm location on map
      latitude: '',
      longitude: '',
      // Always update state from location dropdown (even if empty) to reflect the new location
      state: stateFromLocation
      // DO NOT auto-fill fullAddress - it should remain NULL unless manually entered
      // fullAddress is NOT updated here - user must manually enter it
    }));

    // Center map on selected list location when user opens LocationPicker
    if (locationData.coordinates?.lat != null && locationData.coordinates?.lng != null) {
      setMapCenterFromAddress({
        lng: locationData.coordinates.lng,
        lat: locationData.coordinates.lat,
      });
    } else {
      setMapCenterFromAddress(null);
    }

    // Track if state was auto-filled from location dropdown
    setStateAutoFilled(wasStateAutoFilled);
    if (errors.location || errors.area || errors.state) {
      setErrors(prev => ({ ...prev, location: null, area: null, state: null }));
    }
  };

  const handleImageUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    const currentCount = formData.projectImages?.length || 0;
    if (currentCount + files.length > 20) {
      setErrors(prev => ({
        ...prev,
        projectImages: `You can upload a maximum of 20 images. You have ${currentCount} and trying to add ${files.length}`
      }));
      return;
    }

    // Basic file validation first
    const validFiles = [];
    for (const file of files) {
      const fileValidation = validateImageFile(file);
      if (!fileValidation.valid) {
        setErrors(prev => ({
          ...prev,
          projectImages: fileValidation.message
        }));
        continue;
      }
      validFiles.push(file);
    }

    if (validFiles.length === 0) {
      return;
    }

    // Create image objects with pending status
    const newImageObjects = validFiles.map(file => ({
      file: file,
      preview: URL.createObjectURL(file),
      status: 'pending', // pending, checking, approved, rejected
      errorMessage: '',
      imageId: null,
      imageUrl: null
    }));

    // Add to state immediately
    setImageFiles(prev => [...prev, ...validFiles].slice(0, 20));
    setImageValidationStatus(prev => [...prev, ...newImageObjects].slice(0, 20));

    // Create blob URLs for preview
    const newImages = validFiles.map(f => URL.createObjectURL(f));
    setFormData(prev => ({
      ...prev,
      projectImages: [...(prev.projectImages || []), ...newImages].slice(0, 20)
    }));

    // Clear any previous errors
    if (errors.projectImages) {
      setErrors(prev => ({ ...prev, projectImages: null }));
    }

    // Immediately validate each image through moderation API (in parallel for speed)
    setIsCheckingImages(true);
    const startIndex = imageValidationStatus.length;

    // Validate all images in parallel for faster processing
    const validationPromises = newImageObjects.map((imgObj, i) =>
      validateImageThroughModeration(imgObj, startIndex + i)
    );

    // Wait for all validations to complete
    await Promise.all(validationPromises);

    setIsCheckingImages(false);
  };

  // Validate single image through moderation API
  const validateImageThroughModeration = async (imageObj, index) => {
    // Update status to checking
    setImageValidationStatus(prev => {
      const updated = [...prev];
      if (updated[index]) {
        updated[index] = {
          ...updated[index],
          status: 'checking'
        };
      }
      return updated;
    });

    try {
      // Use 0 for property ID (validation-only mode for new projects)
      const propertyId = 0;

      const formData = new FormData();
      formData.append('image', imageObj.file);
      formData.append('property_id', propertyId);
      formData.append('validate_only', 'true');

      const token = localStorage.getItem('authToken');
      console.log(`[Image ${index + 1}] Starting validation...`);

      const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.MODERATE_AND_UPLOAD}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });

      console.log(`[Image ${index + 1}] Response status:`, response.status);

      // Check if response is OK
      if (!response.ok) {
        const errorText = await response.text();
        console.error(`[Image ${index + 1}] HTTP Error ${response.status}:`, errorText);
        let errorData;
        try {
          errorData = JSON.parse(errorText);
        } catch (e) {
          errorData = { message: errorText || `HTTP ${response.status} Error` };
        }

        setImageValidationStatus(prev => {
          const updated = [...prev];
          if (updated[index]) {
            updated[index] = {
              ...updated[index],
              status: 'rejected',
              errorMessage: errorData.message || 'Validation failed',
              fullErrorMessage: errorData.message || `HTTP ${response.status} Error`
            };
          }
          return updated;
        });
        return;
      }

      const result = await response.json();
      console.log(`[Image ${index + 1}] API Response:`, result);

      // CRITICAL: Check moderation_status explicitly, not just response status
      // Backend returns: { status: "success", data: { moderation_status: "PENDING" | "NEEDS_REVIEW" | "SAFE" } }
      const moderationStatus = result.data?.moderation_status;

      const formatModerationError = (message) => {
        let errorReason = message || 'Image was rejected';
        if (errorReason.includes('animal appearance')) {
          const match = errorReason.match(/\(([^)]+)\)/);
          errorReason = match ? `${match[1]} detected` : 'Animal detected';
        } else if (errorReason.includes('human appearance') || errorReason.includes('Human')) {
          errorReason = 'Human appearance detected';
        } else if (errorReason.includes('blurry') || errorReason.includes('blur')) {
          errorReason = 'Image is too blurry';
        } else if (errorReason.includes('low quality') || errorReason.includes('pixels')) {
          errorReason = 'Image quality too low';
        } else if (
          errorReason.includes('text') ||
          errorReason.includes('document') ||
          errorReason.includes('OCR') ||
          errorReason.includes('visiting') ||
          errorReason.includes('phone number') ||
          errorReason.includes('email')
        ) {
          errorReason = 'Text or document detected';
        }
        return errorReason;
      };

      setImageValidationStatus(prev => {
        const updated = [...prev];
        if (!updated[index]) {
          return updated;
        }

        if (
          result.status === 'error' ||
          moderationStatus === 'REJECTED' ||
          moderationStatus === 'UNSAFE'
        ) {
          const errorReason = formatModerationError(result.message);
          updated[index] = {
            ...updated[index],
            status: 'rejected',
            errorMessage: errorReason,
            fullErrorMessage: result.message || 'Image was rejected',
          };
        } else {
          updated[index] = {
            ...updated[index],
            status: 'approved',
            imageId: result.data?.image_id ?? null,
            imageUrl: result.data?.image_url || null,
            moderationStatus: moderationStatus || 'SAFE',
          };
        }

        return updated;
      });

    } catch (error) {
      console.error(`[Image ${index + 1}] ❌ Validation error:`, error);
      console.error(`[Image ${index + 1}] Error details:`, {
        name: error.name,
        message: error.message,
        stack: error.stack
      });

      setImageValidationStatus(prev => {
        const updated = [...prev];
        if (updated[index]) {
          updated[index] = {
            ...updated[index],
            status: 'rejected',
            errorMessage: error.message || 'Validation failed. Please check console for details.',
            fullErrorMessage: error.message || 'Failed to validate image. Please try again.'
          };
        }
        return updated;
      });
    }
  };

  const removeImage = (idx) => {
    // Revoke blob URL to free memory
    if (formData.projectImages && formData.projectImages[idx] && formData.projectImages[idx].startsWith('blob:')) {
      URL.revokeObjectURL(formData.projectImages[idx]);
    }

    // Also revoke preview URL from validation status
    if (imageValidationStatus[idx]?.preview && imageValidationStatus[idx].preview.startsWith('blob:')) {
      URL.revokeObjectURL(imageValidationStatus[idx].preview);
    }

    setFormData(prev => ({
      ...prev,
      projectImages: prev.projectImages.filter((_, i) => i !== idx)
    }));

    // Also remove from imageFiles array
    setImageFiles(prev => prev.filter((_, i) => i !== idx));

    // Remove from validation status
    setImageValidationStatus(prev => prev.filter((_, i) => i !== idx));
  };

  const validateStep = (step) => {
    const newErrors = {};

    switch (step) {
      case 1: {
        if (!formData.projectName?.trim()) newErrors.projectName = "Project name is required";
        if (!formData.projectType) newErrors.projectType = "Project type is required";
        if (!formData.projectStatus) newErrors.projectStatus = "Project status is required";
        const rera = (formData.reraNumber || '').trim();
        if (rera && (rera.length < 12 || rera.length > 20)) {
          newErrors.reraNumber = "Add RERA number between 12 to 20 characters only";
        }
        break;
      }
      case 2:
        if (!formData.location?.trim() && !formData.area?.trim()) {
          newErrors.location = "Location is required";
        }
        if (!formData.state?.trim()) {
          newErrors.state = "State is required";
        }
        if (!formData.fullAddress?.trim()) {
          newErrors.fullAddress = "Additional address is required";
        }
        if (!formData.pincode?.trim()) {
          newErrors.pincode = "Pincode is required";
        } else if (!/^\d{6}$/.test(formData.pincode.trim())) {
          newErrors.pincode = "Pincode must be 6 digits";
        }
        break;
      case 3: {
        const configOptions = formData.projectType ? (CONFIGURATION_BY_PROJECT_TYPE[formData.projectType] || []) : [];
        if (configOptions.length === 0) {
          newErrors.configurations = "Select a project type in Step 1 first.";
        } else if (formData.configurations.length === 0) {
          newErrors.configurations = "At least one configuration is required";
        }
        if (!formData.carpetAreaRange?.trim()) newErrors.carpetAreaRange = "Area range is required";
        break;
      }
      case 4:
        if (!formData.startingPrice?.trim()) newErrors.startingPrice = "Starting price is required";
        if (!formData.amenities || formData.amenities.length < 3) {
          newErrors.amenities = "Select at least 3 amenities compulsory";
        }
        if (!formData.description?.trim()) {
          newErrors.description = "Project description is required";
        } else if (formData.description.trim().length < 100) {
          newErrors.description = "Project description must be at least 100 characters";
        }
        break;
    //   case 5:
    //     if (!formData.coverImage?.file && !formData.coverImage?.isExisting) {
    //       newErrors.coverImage = "Please add cover image first";
    //     }
    //     // Validate images
    //     const imageCount = Math.max(
    //       imageValidationStatus.length,
    //       formData.projectImages.length || 0
    //     );
    //     if (imageCount < 2) {
    //       newErrors.projectImages = `Please upload at least 2 images. Currently uploaded: ${imageCount}`;
    //     } else if (imageCount > 20) {
    //       newErrors.projectImages = `You can upload a maximum of 20 images. Currently uploaded: ${imageCount}`;
    //     } else {
    //       // Check if any images are still being validated
    //       if (isCheckingImages) {
    //         newErrors.projectImages = "Please wait for all images to be validated";
    //       }
    //       // Check if any images were rejected
    //       const rejectedCount = imageValidationStatus.filter(img => img.status === 'rejected').length;
    //       if (rejectedCount > 0) {
    //         newErrors.projectImages = `Please remove ${rejectedCount} rejected image(s) before proceeding`;
    //       }
    //       // Check if at least one image is approved
    //       const approvedCount = imageValidationStatus.filter(img => img.status === 'approved').length;
    //       if (approvedCount === 0 && imageValidationStatus.length > 0 && !isCheckingImages) {
    //         newErrors.projectImages = "At least one image must be approved";
    //       }
    //     }
    //     // Validate contact fields (at least one sales person with all required fields)
    //     const salesPersons = formData.salesPersons || [];
    //     if (salesPersons.length === 0) {
    //       newErrors.salesPersons = "At least one sales person is required";
    //     } else {
    //       salesPersons.forEach((sp, idx) => {
    //         if (!sp.name?.trim()) newErrors[`salesPerson_name_${idx}`] = "Sales person name is required";
    //         else if (/[^a-zA-Z\s]/.test(sp.name)) newErrors[`salesPerson_name_${idx}`] = "Name should contain only letters";
    //         if (!sp.number?.trim()) newErrors[`salesPerson_number_${idx}`] = "Sales number is required";
    //         else if (sp.number.replace(/\D/g, '').length !== 10) newErrors[`salesPerson_number_${idx}`] = "Sales number must be 10 digits";
    //         if (!sp.email?.trim()) newErrors[`salesPerson_email_${idx}`] = "Email ID is required";
    //       });
    //     }
    //     break;
    //   default:
    //     break;
    // }


// Find this section in the validateStep function (around line 500-520)
// case 5:
//   if (!formData.coverImage?.file && !formData.coverImage?.isExisting) {
//     newErrors.coverImage = "Please add cover image first";
//   }
//   // Validate images
//   const imageCount = Math.max(
//     imageValidationStatus.length,
//     formData.projectImages.length || 0
//   );
//   // CHANGE THIS: Update from 2 to 3
//   if (imageCount < 3) {  // Changed from 2 to 3
//     newErrors.projectImages = `Please upload at least 3 images. Currently uploaded: ${imageCount}`;
//   } else if (imageCount > 20) {
//     newErrors.projectImages = `You can upload a maximum of 20 images. Currently uploaded: ${imageCount}`;
//   } else {
//     // Check if any images are still being validated
//     if (isCheckingImages) {
//       newErrors.projectImages = "Please wait for all images to be validated";
//     }
//     // Check if any images were rejected
//     const rejectedCount = imageValidationStatus.filter(img => img.status === 'rejected').length;
//     if (rejectedCount > 0) {
//       newErrors.projectImages = `Please remove ${rejectedCount} rejected image(s) before proceeding`;
//     }
//     // Check if at least one image is approved
//     const approvedCount = imageValidationStatus.filter(img => img.status === 'approved').length;
//     if (approvedCount === 0 && imageValidationStatus.length > 0 && !isCheckingImages) {
//       newErrors.projectImages = "At least one image must be approved";
//     }
//   }
//   // ... rest of the validation
 // break;

 case 5:
  if (!formData.coverImage?.file && !formData.coverImage?.isExisting) {
    newErrors.coverImage = "Please add cover image first";
  }
  // Validate images
  const imageCount = Math.max(
    imageValidationStatus.length,
    formData.projectImages.length || 0
  );
  // CHANGE THIS: Update from 2 to 3
  if (imageCount < 3) {  // Changed from 2 to 3
    newErrors.projectImages = `Please upload at least 3 images. Currently uploaded: ${imageCount}`;
  } else if (imageCount > 20) {
    newErrors.projectImages = `You can upload a maximum of 20 images. Currently uploaded: ${imageCount}`;
  } else {
    // Check if any images are still being validated
    if (isCheckingImages) {
      newErrors.projectImages = "Please wait for all images to be validated";
    }
    // Check if any images were rejected
    const rejectedCount = imageValidationStatus.filter(img => img.status === 'rejected').length;
    if (rejectedCount > 0) {
      newErrors.projectImages = `Please remove ${rejectedCount} rejected image(s) before proceeding`;
    }
    // Check if at least one image is approved
    const approvedCount = imageValidationStatus.filter(img => img.status === 'approved').length;
    if (approvedCount === 0 && imageValidationStatus.length > 0 && !isCheckingImages) {
      newErrors.projectImages = "At least one image must be approved";
    }
  }

  const oversizedBrochure = (formData.brochures || []).find(
    (b) => b?.file && b.file.size > MAX_BROCHURE_SIZE_BYTES
  );
  if (brochureSizeExceeded || oversizedBrochure) {
    newErrors.brochures = BROCHURE_SIZE_EXCEEDED_MSG;
  }
  
  // ========== ADD CONTACT VALIDATION HERE ==========
  // Validate contact fields (sales persons)
  const salesPersons = formData.salesPersons || [];
  
  // Check if at least one sales person exists with required fields
  let hasValidSalesPerson = false;
  
  salesPersons.forEach((sp, idx) => {
    // Skip empty rows (all fields empty)
    const isNameEmpty = !sp.name?.trim();
    const isNumberEmpty = !sp.number?.trim();
    const isEmailEmpty = !sp.email?.trim();
    
    // If all fields are empty, skip validation for this row
    if (isNameEmpty && isNumberEmpty && isEmailEmpty) {
      return;
    }
    
    hasValidSalesPerson = true;
    
    // Name validation
    if (isNameEmpty) {
      newErrors[`salesPerson_name_${idx}`] = "Sales person name is required";
    } else if (/[^a-zA-Z\s]/.test(sp.name)) {
      newErrors[`salesPerson_name_${idx}`] = "Name should contain only letters and spaces";
    }
    
    // Phone number validation - STRICT (exactly 10 digits)
    if (isNumberEmpty) {
      newErrors[`salesPerson_number_${idx}`] = "Contact number is required (exactly 10 digits)";
    } else {
      const cleanNumber = sp.number.replace(/\D/g, '');
      if (cleanNumber.length === 0) {
        newErrors[`salesPerson_number_${idx}`] = "Contact number is required";
      } else if (cleanNumber.length < 10) {
        newErrors[`salesPerson_number_${idx}`] = `Please add correct number - exactly 10 digits required (currently ${cleanNumber.length})`;
      } else if (cleanNumber.length > 10) {
        newErrors[`salesPerson_number_${idx}`] = "Contact number cannot exceed 10 digits";
      } 
      else if (cleanNumber.length === 10 && !/^[6-9]\d{9}$/.test(cleanNumber)) {
        newErrors[`salesPerson_number_${idx}`] = "Contact number must start with 6, 7, 8, or 9";
      }
    }
    
    // Email validation
    // if (isEmailEmpty) {
    //   newErrors[`salesPerson_email_${idx}`] = "Email ID is required";
    // } else {
    //   const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    //   if (!emailRegex.test(sp.email.trim())) {
    //     newErrors[`salesPerson_email_${idx}`] = "Please enter a valid email address (e.g., name@domain.com)";
    //   }
    // }

// WhatsApp Number validation (optional - only validate if entered)
if (sp.whatsappNumber && sp.whatsappNumber.trim()) {
  const cleanWhatsapp = sp.whatsappNumber.replace(/\D/g, '');
  if (cleanWhatsapp.length < 10) {
    newErrors[`salesPerson_whatsappNumber_${idx}`] = "WhatsApp number must be exactly 10 digits";
  } else if (cleanWhatsapp.length > 10) {
    newErrors[`salesPerson_whatsappNumber_${idx}`] = "WhatsApp number cannot exceed 10 digits";
  } else if (cleanWhatsapp.length === 10 && !/^[6-9]\d{9}$/.test(cleanWhatsapp)) {
    newErrors[`salesPerson_whatsappNumber_${idx}`] = "WhatsApp number must start with 6, 7, 8, or 9";
  }
}

// Alternative Number validation (optional - only validate if entered)
if (sp.alternativeNumber && sp.alternativeNumber.trim()) {
  const cleanAlternative = sp.alternativeNumber.replace(/\D/g, '');
  if (cleanAlternative.length < 10) {
    newErrors[`salesPerson_alternativeNumber_${idx}`] = "Alternative number must be exactly 10 digits";
  } else if (cleanAlternative.length > 10) {
    newErrors[`salesPerson_alternativeNumber_${idx}`] = "Alternative number cannot exceed 10 digits";
  } else if (cleanAlternative.length === 10 && !/^[6-9]\d{9}$/.test(cleanAlternative)) {
    newErrors[`salesPerson_alternativeNumber_${idx}`] = "Alternative number must start with 6, 7, 8, or 9";
  }
}

// Landline Number validation (optional - only validate if entered)
if (sp.landlineNumber && sp.landlineNumber.trim()) {
  const cleanLandline = sp.landlineNumber.replace(/\D/g, '');
  if (cleanLandline.length < 10) {
    newErrors[`salesPerson_landlineNumber_${idx}`] = "Landline number must have at least 10 digits";
  } else if (cleanLandline.length > 15) {
    newErrors[`salesPerson_landlineNumber_${idx}`] = "Landline number cannot exceed 15 digits";
  }
}


    // Email validation - STRICT (format + allowed domains only)
if (isEmailEmpty) {
  newErrors[`salesPerson_email_${idx}`] = "Email ID is required";
} else {
  const emailError = getSalesPersonEmailError(sp.email);
  if (emailError) {
    newErrors[`salesPerson_email_${idx}`] = emailError;
  }
}
  });
  
  // If no valid sales person found, show error
  if (!hasValidSalesPerson && salesPersons.length > 0) {
    newErrors.salesPersons = "At least one sales person with complete details is required";
  }
  break;



}


    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (validateStep(currentStep)) {
      setCurrentStep(prev => Math.min(prev + 1, 5));
    } else {
      setTimeout(() => {
        if (popupBodyRef.current) {
          const firstErrorField = popupBodyRef.current.querySelector('.error, .error-text');
          if (firstErrorField) {
            firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else {
            popupBodyRef.current.scrollTop = 0;
          }
        }
      }, 100);
    }
  };

  const handleBack = () => {
    setCurrentStep(prev => Math.max(prev - 1, 1));
  };

  const isStepCompleted = (stepId) => {
    return currentStep > stepId;
  };

  const handleStepClick = (stepId) => {
    if (stepId === currentStep) return;
    if (stepId < currentStep) {
      setCurrentStep(stepId);
    }
  };

  useEffect(() => {
    if (popupBodyRef.current) {
      popupBodyRef.current.scrollTop = 0;
    }
  }, [currentStep]);

  // Format price in words — Thousand / Lakh / Crore based on value (not always Crore)
  const formatPriceInWords = (price) => {
    if (!price) return '';
    return formatIndianPriceRangeDisplay(price, { short: false }) || formatIndianPriceDisplay(price);
  };

  const handleSubmit = async () => {
    // CRITICAL: Block all publishing if form was discarded
    if (isDiscarded) {
      console.log('Publishing blocked: Form was discarded');
      return;
    }

    // Block publish until brochure is ≤ 10 MB (or oversized attempt is replaced)
    const hasOversizedBrochure = (formData.brochures || []).some(
      (b) => b?.file && b.file.size > MAX_BROCHURE_SIZE_BYTES
    );
    if (brochureSizeExceeded || hasOversizedBrochure) {
      setBrochureSizeExceeded(true);
      setErrors((prev) => ({
        ...prev,
        brochures: BROCHURE_SIZE_EXCEEDED_MSG,
        submit: BROCHURE_SIZE_EXCEEDED_MSG,
      }));
      setCurrentStep(5);
      if (popupBodyRef.current) {
        popupBodyRef.current.scrollTop = 0;
      }
      return;
    }

    // Final slot check before publishing a new project.
    if (!isEditMode) {
      try {
        const currentUser = authAPI.getUser();
        const [statsResponse, subscriptionsResponse, profileResult] = await Promise.all([
          sellerDashboardAPI.getStats(),
          sellerDashboardAPI.getSubscriptions(),
          sellerProfileAPI.get().catch(() => null),
        ]);
        const activeSubscriptions = subscriptionsResponse?.success
          ? (subscriptionsResponse.data?.subscriptions || []).filter((subscription) => subscription.status === 'active')
          : [];
        const paidSlots = activeSubscriptions.reduce(
          (total, subscription) => total + Number(subscription.properties_limit || 0),
          0
        );
        const statsSubscription = statsResponse?.data?.subscription || null;
        const trialUser = profileResult?.success
          ? profileResult.data?.profile
          : currentUser;
        const totalSlots = paidSlots + (hasActiveFreeTrial(statsSubscription, trialUser) ? FREE_LISTING_SLOTS : 0);
        const currentPropertyCount = properties?.length || 0;
        const remainingSlots = Math.max(0, totalSlots - currentPropertyCount);

        if (remainingSlots <= 0) {
          const errorMsg = 'You have reached your current plan limit. Purchase another plan to add more properties.';
          setErrors(prev => ({ ...prev, submit: errorMsg }));
          alert(errorMsg);
          navigate('/agent-dashboard/subscription');
          return;
        }
      } catch (err) {
        console.error('Failed to verify plan slots before project publish:', err);
        // Proceed and rely on backend enforcement when stats check fails transiently
      }
    }

    // Always validate step 5 (images and contact) before submission
    // if (!validateStep(5)) {
    //   // Switch to step 5 if validation fails
    //   setCurrentStep(5);
    //   return;
    // }

// Always validate step 5 (images and contact) before submission
if (!validateStep(5)) {
  // Switch to step 5 if validation fails
  setCurrentStep(5);
  // Scroll to top to show errors
  if (popupBodyRef.current) {
    popupBodyRef.current.scrollTop = 0;
  }
  return;
}


// ========== ADD EXTRA CONTACT & EMAIL VALIDATION ==========
// Validate contact numbers and emails directly before submission
const salesPersons = formData.salesPersons || [];
let hasInvalidNumber = false;
let hasInvalidEmail = false;
let firstEmailError = '';
const emailErrorsToSet = {};

for (let idx = 0; idx < salesPersons.length; idx += 1) {
  const sp = salesPersons[idx];
  const isNameEmpty = !sp.name?.trim();
  const isNumberEmpty = !sp.number?.trim();
  const isEmailEmpty = !sp.email?.trim();
  if (isNameEmpty && isNumberEmpty && isEmailEmpty) continue;

  // Check if user has entered any digits but less than 10
  const num = (sp.number || '').replace(/\D/g, '');
  if (num.length > 0 && num.length < 10) {
    hasInvalidNumber = true;
  }

  // Block publish on invalid / misspelled provider emails
  const email = (sp.email || '').trim();
  if (email.length > 0) {
    const emailError = getSalesPersonEmailError(email);
    if (emailError) {
      hasInvalidEmail = true;
      emailErrorsToSet[`salesPerson_email_${idx}`] = emailError;
      if (!firstEmailError) firstEmailError = emailError;
    }
  } else if (!isNameEmpty || !isNumberEmpty) {
    hasInvalidEmail = true;
    emailErrorsToSet[`salesPerson_email_${idx}`] = 'Email ID is required';
    if (!firstEmailError) firstEmailError = 'Email ID is required';
  }
}


if (hasInvalidNumber) {
  // Show a friendly alert
  alert('Please ensure all contact numbers have exactly 10 digits before publishing.');
  setCurrentStep(5);
  return;
}

if (hasInvalidEmail) {
  setErrors((prev) => ({
    ...prev,
    ...emailErrorsToSet,
  }));
  alert(
    firstEmailError
    || (isEditMode
      ? 'Correct your mail id before updating the project.'
      : 'Correct your mail id before publishing the project.')
  );
  setCurrentStep(5);
  if (popupBodyRef.current) {
    popupBodyRef.current.scrollTop = 0;
  }
  return;
}
// ========== END VALIDATION ==========
// ========== END VALIDATION ==========


    setIsSubmitting(true);
    setUploadingImages(true);

    try {
      // Convert form data to property format
      // Extract numeric price in rupees (supports Thousand / Lakh / Crore / raw rupees)
      let priceValue = 0;
      if (formData.startingPrice) {
        // For ranges like "45-60 Lakh", use the first value for DB `price`
        const firstPart = String(formData.startingPrice)
          .split(/[-–—]|to/i)[0]
          ?.trim();
        priceValue = parseIndianPriceToRupees(firstPart || formData.startingPrice);
      }

      // Validate required fields before submission
      if (!priceValue || priceValue <= 0) {
        throw new Error('Starting price is required and must be greater than 0');
      }

      // Persist starting price with natural unit (10 Lakh) so edit never shows 0.10 Cr
      const startingPriceForSave =
        formatIndianPriceForEditInput(priceValue) || formData.startingPrice || null;

      const propertyData = {
        title: formData.projectName,
        property_type: formData.projectType,
        status: "sale", // Upcoming projects are always for sale
        location: formData.location || formData.area || '',
        latitude: formData.latitude || null,
        longitude: formData.longitude || null,
        state: formData.state || null,
        additional_address: formData.fullAddress || null,
        description: formData.description,
        price: priceValue,
        area: 1, // Required field, set minimum value for upcoming projects (1 sq ft as placeholder)
        project_type: "upcoming", // CRITICAL FLAG
        // Additional upcoming project fields stored as JSON
        upcoming_project_data: {
          builderName: formData.builderName || builderName,
          projectStatus: formData.projectStatus,
          startingPrice: startingPriceForSave,
          reraNumber: formData.reraNumber || null,
          configurations: sanitizeConfigurationsForProjectType(
            formData.configurations,
            formData.projectType,
            CONFIGURATION_BY_PROJECT_TYPE
          ),
          carpetAreaRange: formatAreaRangeWithSqFt(formData.carpetAreaRange) || null,
          numberOfTowers: formData.numberOfTowers || null,
          totalUnits: formData.totalUnits || null,
          floorsCount: formData.floorsCount || null,
          unitsPerFloor: formData.unitsPerFloor || null,
          numberOfVillas: formData.numberOfVillas || null,
          numberOfPlots: formData.numberOfPlots || null,
          bedCapacity: formData.bedCapacity || null,
          loadingDocks: formData.loadingDocks || null,
          pricePerSqft: formData.pricePerSqft || null,
          bookingAmount: formData.bookingAmount || null,
          expectedLaunchDate: formData.expectedLaunchDate || null,
          expectedPossessionDate: formData.expectedPossessionDate || null,
          reraStatus: formData.reraStatus || null,
          landOwnershipType: formData.landOwnershipType || null,
          bankApproved: formData.bankApproved || null,
          approvedBanks: (() => {
            // Combine selected banks and custom bank names
            const banks = [...(formData.approvedBanks || [])];
            // Remove "Other" from the array as it's just a trigger
            const banksWithoutOther = banks.filter(b => b !== 'Other');
            if (formData.otherBankName && formData.otherBankName.trim()) {
              // Parse comma-separated custom bank names and add them
              const customBanks = formData.otherBankName.split(',').map(b => b.trim()).filter(b => b);
              banksWithoutOther.push(...customBanks);
            }
            return banksWithoutOther;
          })(),
          salesPersons: (formData.salesPersons || []).filter(sp => sp.name?.trim() || sp.number?.trim() || sp.email?.trim()).map(sp => ({
            name: sp.name || null,
            number: sp.number || null,
            email: sp.email || null,
            landlineNumber: sp.landlineNumber?.trim() || null,
            whatsappNumber: sp.whatsappNumber?.trim() || null,
            alternativeNumber: sp.alternativeNumber?.trim() || null
          })),
          salesName: formData.salesPersons?.[0]?.name || null,
          salesNumber: formData.salesPersons?.[0]?.number || null,
          emailId: formData.salesPersons?.[0]?.email || null,
          landlineNumber: formData.salesPersons?.[0]?.landlineNumber?.trim() || formData.landlineNumber || null,
          whatsappNumber: formData.salesPersons?.[0]?.whatsappNumber?.trim() || formData.whatsappNumber || null,
          alternativeNumber: formData.salesPersons?.[0]?.alternativeNumber?.trim() || formData.alternativeNumber || null,
          projectHighlights: formData.projectHighlights || null,
          usp: formData.usp || null,
          pincode: formData.pincode || null,
          mapLink: formData.mapLink || null,
          // Multiple brochures stored here (no DB schema change)
          brochures: (formData.brochures || [])
            .filter((b) => b?.isExisting && b.url && !isBlobUrl(b.url))
            .map((b) => ({
              url: decodeHtmlEntitiesInUrl(b.url),
              name: b.name || 'Brochure.pdf',
            })),
        },
        images: (formData.projectImages || []).filter(
          (img) => typeof img === 'string' && !isBlobUrl(img)
        ),
        amenities: formData.amenities || [],
        // Single column kept for backward compatibility (first brochure only)
        brochure_url: (() => {
          const existing = (formData.brochures || [])
            .filter((b) => b?.isExisting && b.url && !isBlobUrl(b.url))
            .map((b) => b.url);
          if (existing.length > 0) return existing[0];
          if (formData.brochure?.url && !formData.brochure.file && !isBlobUrl(formData.brochure.url)) {
            return formData.brochure.url;
          }
          // New files upload after create — clear until then if none kept
          const hasNewFiles = (formData.brochures || []).some((b) => b?.file);
          if (hasNewFiles) return undefined;
          return null;
        })(),
      };

      let propertyId;

      if (isEditMode && editData && editData.id) {
        // UPDATE MODE: Update existing upcoming project
        try {
          console.log('Updating upcoming project:', editData.id, propertyData);

          // Call API directly with the same structure as create
          const response = await sellerPropertiesAPI.update(editData.id, propertyData);

          if (!response.success) {
            throw new Error(response.message || 'Failed to update upcoming project');
          }

          propertyId = editData.id;
          console.log('Upcoming project updated successfully:', propertyId);

          // Refresh data after successful update
          if (refreshData) {
            await refreshData();
          }
        } catch (error) {
          console.error('Upcoming project update failed - Full error:', error);
          console.error('Error details:', {
            message: error.message,
            status: error.status,
            errors: error.errors,
            data: error.data,
            response: error.response
          });

          // Extract validation errors if available
          let errorMessage = 'Failed to update project. Please try again.';

          // Check various error formats
          if (error.message) {
            errorMessage = error.message;
          } else if (error.errors && typeof error.errors === 'object') {
            const errorList = Object.values(error.errors).join(', ');
            errorMessage = `Validation failed: ${errorList}`;
          } else if (error.data?.errors && typeof error.data.errors === 'object') {
            const errorList = Object.values(error.data.errors).join(', ');
            errorMessage = `Validation failed: ${errorList}`;
          } else if (error.data?.message) {
            errorMessage = error.data.message;
          } else if (error.response?.data?.errors) {
            const errorList = Object.values(error.response.data.errors).join(', ');
            errorMessage = `Validation failed: ${errorList}`;
          } else if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
          }

          console.error('Final error message:', errorMessage);
          throw new Error(errorMessage);
        }
      } else {
        // CREATE MODE: Create new upcoming project
        let createdProperty;
        try {
          console.log('Submitting property data:', propertyData);
          createdProperty = await addProperty(propertyData);
          console.log('Property created successfully:', createdProperty);
        } catch (error) {
          console.error('Property creation failed - Full error:', error);
          console.error('Error details:', {
            message: error.message,
            status: error.status,
            errors: error.errors,
            data: error.data,
            response: error.response
          });

          // Extract validation errors if available
          let errorMessage = 'Failed to create project. Please try again.';

          // Check various error formats
          if (error.message) {
            errorMessage = error.message;
          } else if (error.errors && typeof error.errors === 'object') {
            const errorList = Object.values(error.errors).join(', ');
            errorMessage = `Validation failed: ${errorList}`;
          } else if (error.data?.errors && typeof error.data.errors === 'object') {
            const errorList = Object.values(error.data.errors).join(', ');
            errorMessage = `Validation failed: ${errorList}`;
          } else if (error.data?.message) {
            errorMessage = error.data.message;
          } else if (error.response?.data?.errors) {
            const errorList = Object.values(error.response.data.errors).join(', ');
            errorMessage = `Validation failed: ${errorList}`;
          } else if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
          }

          console.error('Final error message:', errorMessage);
          throw new Error(errorMessage);
        }

        if (!createdProperty || !createdProperty.id) {
          throw new Error('Failed to get project ID after creation.');
        }

        propertyId = createdProperty.id;
      }

      // Upload cover image first so it is stored as the property cover_image
      if (formData.coverImage?.file && propertyId) {
        try {
          const coverResponse = await sellerPropertiesAPI.uploadImage(formData.coverImage.file, propertyId);
          if (coverResponse.success && coverResponse.data) {
            const coverUrl = coverResponse.data.image_url || coverResponse.data.url;
            if (coverUrl) {
              await sellerPropertiesAPI.update(propertyId, { cover_image: coverUrl });
              console.log('Cover image uploaded for project:', coverUrl);
            }
          }
        } catch (coverError) {
          console.error('Cover image upload error:', coverError);
        }
      }

      // Upload images with moderation (images already validated on selection)
      // Get approved images from validation status
      const approvedImages = imageValidationStatus.filter(img => img.status === 'approved');

      if (approvedImages.length > 0) {
        setUploadingImages(true);
        try {
          // Upload each approved image with property ID
          const uploadPromises = approvedImages.map(async (imgObj, index) => {
            try {
              console.log(`Uploading image ${index + 1}/${approvedImages.length}:`, imgObj.file.name);
              const response = await sellerPropertiesAPI.uploadImage(imgObj.file, propertyId);
              console.log(`Image ${index + 1} upload response:`, response);

              if (response.success && response.data) {
                const imageUrl = response.data.image_url || response.data.url;
                if (imageUrl) {
                  return { success: true, url: imageUrl };
                }
              }
              return { success: false, error: response.message || 'Upload failed - no URL returned' };
            } catch (error) {
              console.error(`Image ${index + 1} upload error:`, error);
              return {
                success: false,
                error: error.message || error.status || 'Upload failed',
                details: error
              };
            }
          });

          const results = await Promise.all(uploadPromises);
          const successful = results.filter(r => r.success);
          const failed = results.filter(r => !r.success);

          console.log(`Image upload results: ${successful.length} successful, ${failed.length} failed`);

          if (failed.length > 0) {
            console.warn('Failed image uploads:', failed);
            // Show warning but don't fail the entire project creation
            const errorMessages = failed.map((f, i) => `Image ${i + 1}: ${f.error}`).join('; ');
            console.warn(`Some images failed to upload: ${errorMessages}`);
          }

          if (successful.length === 0 && approvedImages.length > 0) {
            console.warn('All images failed to upload, but project was created successfully');
          }
        } catch (uploadError) {
          console.error('Image upload batch error:', uploadError);
          // Don't throw - project was created successfully
        } finally {
          setUploadingImages(false);
        }
      } else if (imageFiles.length > 0) {
        // Images were selected but none approved
        console.warn('No approved images found. Project created without images.');
      }

      // if (formData.brochure?.file && propertyId) {
      //   try {
      //     const brochureResponse = await sellerPropertiesAPI.uploadBrochure(
      //       formData.brochure.file,
      //       propertyId
      //     );
      //     if (brochureResponse.success && brochureResponse.data?.url) {
      //       console.log('Brochure uploaded for project:', brochureResponse.data.url);
      //     }
      //   } catch (brochureError) {
      //     console.error('Brochure upload error:', brochureError);
      //   }
      // }

      if (formData.brochures && formData.brochures.length > 0 && propertyId) {
        try {
          const existingBrochures = (formData.brochures || [])
            .filter((b) => b.isExisting && b.url && !isBlobUrl(b.url))
            .map((b) => ({
              url: decodeHtmlEntitiesInUrl(b.url),
              name: b.name || 'Brochure.pdf',
            }));

          const newBrochures = formData.brochures.filter((b) => b.file && !b.isExisting);
          let uploadedBrochures = [];
          const failedUploads = [];

          if (newBrochures.length > 0) {
            console.log(`Uploading ${newBrochures.length} brochures...`);
            // Sequential uploads so server-side brochures[] appends do not race
            for (let index = 0; index < newBrochures.length; index++) {
              const brochure = newBrochures[index];
              if (brochure.file && brochure.file.size > MAX_BROCHURE_SIZE_BYTES) {
                failedUploads.push({
                  name: brochure.name,
                  error: BROCHURE_SIZE_EXCEEDED_MSG,
                });
                continue;
              }
              try {
                console.log(`Uploading brochure ${index + 1}/${newBrochures.length}:`, brochure.file.name);
                const response = await sellerPropertiesAPI.uploadBrochure(
                  brochure.file,
                  propertyId,
                  { skipDbSave: true }
                );
                if (response.success && response.data?.url) {
                  uploadedBrochures.push({
                    url: response.data.url,
                    name: brochure.name || 'Brochure.pdf',
                  });
                } else {
                  failedUploads.push({
                    name: brochure.name,
                    error: response.message || 'Upload failed',
                  });
                }
              } catch (error) {
                console.error(`Brochure ${index + 1} upload error:`, error);
                failedUploads.push({
                  name: brochure.name,
                  error: error.message || 'Upload failed',
                });
              }
            }
            if (failedUploads.length > 0) {
              console.warn('Failed brochure uploads:', failedUploads);
            }
          }

          const allBrochures = [...existingBrochures, ...uploadedBrochures];

          // Preserve flags like isVisible from existing upcoming_project_data
          let previousUpcoming = {};
          try {
            const raw = editData?.upcomingProjectData ?? editData?.upcoming_project_data;
            if (typeof raw === 'string' && raw) previousUpcoming = JSON.parse(raw) || {};
            else if (raw && typeof raw === 'object') previousUpcoming = raw;
          } catch (e) {
            previousUpcoming = {};
          }

          // Always persist the authoritative brochure list after uploads
          const updateResponse = await sellerPropertiesAPI.update(propertyId, {
            brochure_url: allBrochures[0]?.url || '',
            upcoming_project_data: {
              ...previousUpcoming,
              ...propertyData.upcoming_project_data,
              brochures: allBrochures,
            },
          });

          if (updateResponse && updateResponse.success === false) {
            throw new Error(updateResponse.message || 'Failed to save brochures');
          }

          console.log(`Saved ${allBrochures.length} brochure(s) to upcoming_project_data`);

          if (failedUploads.length > 0 && allBrochures.length === 0) {
            alert(`Brochure upload failed: ${failedUploads.map((f) => f.error).join('; ')}`);
          } else if (failedUploads.length > 0) {
            alert(
              `${allBrochures.length} brochure(s) saved, but ${failedUploads.length} failed to upload.`
            );
          }
        } catch (brochureError) {
          console.error('Brochure upload/save error:', brochureError);
          alert(
            `Project saved, but brochures failed to save: ${
              brochureError.message || 'Unknown error'
            }. Please edit the project and re-upload the PDFs.`
          );
        }
      } else if (isEditMode && propertyId && (!formData.brochures || formData.brochures.length === 0)) {
        try {
          let previousUpcoming = {};
          try {
            const raw = editData?.upcomingProjectData ?? editData?.upcoming_project_data;
            if (typeof raw === 'string' && raw) previousUpcoming = JSON.parse(raw) || {};
            else if (raw && typeof raw === 'object') previousUpcoming = raw;
          } catch (e) {
            previousUpcoming = {};
          }
          await sellerPropertiesAPI.update(propertyId, {
            brochure_url: '',
            upcoming_project_data: {
              ...previousUpcoming,
              ...propertyData.upcoming_project_data,
              brochures: [],
            },
          });
        } catch (clearErr) {
          console.warn('Failed to clear brochures:', clearErr);
        }
      }
      // ========== END BROCHURE UPLOAD ==========
      
      setUploadingImages(false);
      setIsPublished(true); // Mark as published before closing
      alert(isEditMode
        ? 'Upcoming project updated successfully!'
        : 'Upcoming project published successfully! It is now visible to buyers.');
      
      // Refresh data after successful update/create
      if (refreshData) {
        await refreshData();
      }
      
      onClose();

      // setUploadingImages(false);
      // setIsPublished(true); // Mark as published before closing
      // alert(isEditMode
      //   ? 'Upcoming project updated successfully!'
      //   : 'Upcoming project published successfully! It is now visible to buyers.');

      // // Refresh data after successful update/create
      // if (refreshData) {
      //   await refreshData();
      // }

      onClose();
    } catch (error) {
      console.error('Project save error:', error);
      alert(error.message || 'Failed to save project. Please try again.');
    } finally {
      setIsSubmitting(false);
      setUploadingImages(false);
    }
  };

  const renderStepIndicator = () => (
    <div className="step-indicator">
      {STEPS.map((step, idx) => {
        const isCompleted = isStepCompleted(step.id);
        const isClickable = isCompleted || step.id === currentStep;

        return (
          <div
            key={step.id}
            className={`step-item ${currentStep === step.id ? 'active' : ''} ${isCompleted ? 'completed' : ''} ${isClickable ? 'clickable' : ''}`}
          >
            <div
              className="step-circle"
              onClick={() => isClickable && handleStepClick(step.id)}
              style={{ cursor: isClickable ? 'pointer' : 'default' }}
            >
              {isCompleted ? (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              ) : (
                <span>{step.icon}</span>
              )}
            </div>
            <span className="step-title">{step.title}</span>
            {idx < STEPS.length - 1 && <div className="step-line" />}
          </div>
        );
      })}
    </div>
  );

  // Step 1: Basic Project Information
  const renderStep1 = () => (
    <div className="step-content">
      <div style={{ marginBottom: '1.5rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border-color)' }}>
        <span style={{ fontSize: '0.85rem', color: 'var(--text-muted)', fontWeight: '500' }}>
          Step {currentStep} of {STEPS.length} — {STEPS[currentStep - 1].title}
        </span>
      </div>
      <h3 className="step-heading">Basic Details</h3>
      <p className="step-subheading">Let's start with the basic details of your upcoming project</p>

      <div className="form-group">
        <label>Project Name <span className="required">*</span></label>
        <input
          type="text"
          value={formData.projectName}
          onChange={(e) => handleChange('projectName', e.target.value)}
          placeholder="e.g., Green Valley Residency"
          className={errors.projectName ? 'error' : ''}
        />
        {errors.projectName && <span className="error-text">{errors.projectName}</span>}
      </div>

      <div className="form-group">
        <label>Builder / Developer Name</label>
        {/* <input
          type="text"
          value={formData.builderName || builderName}
          onChange={(e) => handleChange('builderName', e.target.value)}
          placeholder="Auto-filled from your account"
          //disabled
          style={{ background: '#f3f4f6' }}
        /> */}
  <input
  type="text"
  value={formData.builderName}
  onChange={(e) =>
    handleChange('builderName', e.target.value.toUpperCase())
  }
  placeholder="Enter Builder/Developer Name"
  style={{ background: '#ffffff' }}
/>
      </div>

      <div className="form-group">
        <label>Project Type <span className="required">*</span></label>
        <div className={`property-type-grid ${errors.projectType ? 'error' : ''}`}>
          {PROJECT_TYPES.map(type => (
            <button
              key={type.value}
              type="button"
              className={`property-type-btn ${formData.projectType === type.value ? 'active' : ''}`}
              onClick={() => handleChange('projectType', type.value)}
            >
              <span className="type-icon">{type.icon}</span>
              <span className="type-label">{type.value}</span>
            </button>
          ))}
        </div>
        {errors.projectType && <span className="error-text">{errors.projectType}</span>}
      </div>

      <div className="form-group">
        <label>Project Status <span className="required">*</span></label>
        <select
          value={formData.projectStatus}
          onChange={(e) => handleChange('projectStatus', e.target.value)}
          className={errors.projectStatus ? 'error' : ''}
        >
          {PROJECT_STATUS_OPTIONS.map(option => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
        {errors.projectStatus && <span className="error-text">{errors.projectStatus}</span>}
      </div>

      <div className="form-group">
        <label>RERA Number (Optional but recommended)</label>
        <input
          type="text"
          value={formData.reraNumber}
          onChange={(e) => {
            const nextValue = e.target.value.slice(0, 20);
            handleChange('reraNumber', nextValue);
            const len = nextValue.trim().length;
            if (len === 0) {
              setErrors((prev) => {
                if (!prev.reraNumber) return prev;
                const next = { ...prev };
                delete next.reraNumber;
                return next;
              });
            } else if (len < 12) {
              setErrors((prev) => ({
                ...prev,
                reraNumber: "Add RERA number between 12 to 20 characters only",
              }));
            } else {
              setErrors((prev) => {
                if (!prev.reraNumber) return prev;
                const next = { ...prev };
                delete next.reraNumber;
                return next;
              });
            }
          }}
          maxLength={20}
          placeholder="e.g., RERA/PKR/2019/001234"
          className={errors.reraNumber ? 'error' : ''}
        />
        {errors.reraNumber && (
          <span className="error-text">{errors.reraNumber}</span>
        )}
        {!errors.reraNumber && formData.reraNumber?.trim().length > 0 && formData.reraNumber.trim().length < 12 && (
          <span style={{ color: '#f59e0b', fontSize: '0.75rem', marginTop: '2px', display: 'block' }}>
            ⚠️ {formData.reraNumber.trim().length}/12 min — Add RERA number between 12 to 20 characters only
          </span>
        )}
        {!errors.reraNumber && formData.reraNumber?.trim().length >= 12 && formData.reraNumber.trim().length <= 20 && (
          <span style={{ color: '#22c55e', fontSize: '0.75rem', marginTop: '2px', display: 'block' }}>
            ✅ {formData.reraNumber.trim().length}/20 characters
          </span>
        )}
      </div>

    </div>
  );

  // Step 2: Location Details
  const renderStep2 = () => (
    <div className="step-content">
      <div style={{ marginBottom: '1.5rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border-color)' }}>
        <span style={{ fontSize: '0.85rem', color: 'var(--text-muted)', fontWeight: '500' }}>
          Step {currentStep} of {STEPS.length} — {STEPS[currentStep - 1].title}
        </span>
      </div>
      <h3 className="step-heading">Location</h3>
      <p className="step-subheading">Where is your project located?</p>

      {/* <div className="form-group">
        <label>Location <span className="required">*</span></label>
        <LocationAutoSuggest
          placeholder="Enter locality, area or landmark"
          value={formData.location || formData.area || ''}
          onChange={handleLocationDropdownSelect}
          className={errors.location || errors.area ? 'error' : ''}
          error={errors.location || errors.area}
        />
        {(errors.location || errors.area) && (
          <span className="error-text">{errors.location || errors.area}</span>
        )}
      </div> */}
      <div className="form-group" style={{ position: 'relative', zIndex: 1000, overflow: 'visible' }}>
  <label>Location <span className="required">*</span></label>
  <div style={{ position: 'relative', zIndex: 1000 }}>
    <LocationAutoSuggest
      placeholder="Enter locality, area or landmark"
      value={formData.location || formData.area || ''}
      onChange={handleLocationDropdownSelect}
      className={errors.location || errors.area ? 'error' : ''}
      error={errors.location || errors.area}
    />
  </div>
  {(errors.location || errors.area) && (
    <span className="error-text">{errors.location || errors.area}</span>
  )}
</div>

      {/* Location Picker Button */}
      <div className="form-group-map">
        <label style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', width: '100%' }}>Project Location on Map <span className='required'>*</span></label>
        {!formData.latitude || !formData.longitude ? (
          <>
            <button
              type="button"
              className="location-picker-btn"
              onClick={() => setShowLocationPicker(true)}
              style={{
                width: '100%',
                padding: '0.875rem 1rem',
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                gap: '0.5rem',
                background: 'white',
                border: '2px solid var(--border-color)',
                borderRadius: 'var(--radius-md)',
                cursor: 'pointer',
                fontSize: '0.95rem',
                fontWeight: '600',
                color: 'var(--text-primary)',
                transition: 'all var(--transition-fast)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = 'var(--accent-color)';
                e.currentTarget.style.color = 'var(--accent-color)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'var(--border-color)';
                e.currentTarget.style.color = 'var(--text-primary)';
              }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" />
                <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2" />
              </svg>
              <span>Add Location on Map</span>
            </button>
            <span className="hint-text" style={{
              display: 'block',
              marginTop: '0.5rem',
              fontSize: '0.85rem',
              color: 'var(--text-muted)'
            }}>
              Select exact location on map for better visibility
            </span>
          </>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
              <span className="location-icon" style={{ fontSize: '18px' }}>📍</span>
              <div style={{ flex: 1 }}>
                <span style={{ fontSize: '0.875rem', color: '#059669', fontWeight: '500' }}>
                  Location set on map
                </span>
              </div>
            </div>
            <small className="location-picker-coordinates" style={{
              marginLeft: '26px',
              fontSize: '0.75rem',
              color: '#059669',
              fontFamily: 'monospace'
            }}>
              Coordinates: {parseFloat(formData.latitude).toFixed(6)}, {parseFloat(formData.longitude).toFixed(6)}
            </small>



            
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <button
                type="button"
                className="location-picker-change-btn"
                onClick={() => setShowLocationPicker(true)}
                style={{
                  width: '100%',
                padding: '0.875rem 1rem',
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                gap: '0.5rem',
                background: '',
                border: '2px solid var(--border-color)',
                borderRadius: 'var(--radius-md)',
                cursor: 'pointer',
                fontSize: '0.95rem',
                fontWeight: '600',
                color: 'var(--text-primary)',
                transition: 'all var(--transition-fast)'
                }}
              >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" />
                <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2" />
              </svg>
              Add Location on Map
              </button>




              {/* <button
                type="button"
                onClick={() => {
                  setFormData(prev => ({ ...prev, latitude: '', longitude: '' }));
                }}
                style={{
                  padding: '6px 12px',
                  fontSize: '0.875rem',
                  backgroundColor: '#fee2e2',
                  border: '1px solid #fecaca',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  color: '#991b1b',
                  fontWeight: '500'
                }}
              >
                Remove
              </button> */}
            </div>
          </div>
        )}
      </div>

      {/* State and Additional Address Fields */}
      <div className={`form-row two-cols ${stateDropdownOpen ? 'state-dropdown-row-active' : ''}`}>
        <div className={`form-group ${stateDropdownOpen ? 'state-dropdown-open' : ''}`}>
          <label>
            State <span className="required">*</span>
            {stateAutoFilled && (
              <span style={{
                fontSize: '0.75rem',
                color: '#059669',
                marginLeft: '8px',
                fontWeight: 'normal'
              }}>
                (Auto-filled from location)
              </span>
            )}
          </label>
          <div style={{ position: 'relative' }} ref={stateDropdownRef}>
            <input
              type="text"
              placeholder="Enter state or select from list"
              value={formData.state || ''}
              onChange={(e) => {
                handleChange('state', e.target.value);
                if (stateAutoFilled && e.target.value !== formData.state) setStateAutoFilled(false);
                setStateDropdownOpen(true);
              }}
              onFocus={() => !stateAutoFilled && setStateDropdownOpen(true)}
              className={errors.state ? 'error' : ''}
              readOnly={stateAutoFilled}
              disabled={stateAutoFilled}
              style={stateAutoFilled ? {
                background: '#f3f4f6',
                cursor: 'not-allowed',
                color: '#374151'
              } : {}}
              autoComplete="off"
            />
            {/* {stateAutoFilled && (
              <button
                type="button"
                onClick={() => {
                  setStateAutoFilled(false);
                  setStateDropdownOpen(true);
                }}
                style={{
                  position: 'absolute',
                  right: '8px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  color: '#7c3aed',
                  cursor: 'pointer',
                  fontSize: '0.75rem',
                  fontWeight: '600',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  zIndex: 10
                }}
                title="Edit state manually"
              >
                Edit
              </button>
            )}
            {!stateAutoFilled && stateDropdownOpen && (formData.state || '').trim().length >= 2 && (
              <ul
                className="state-suggestions-dropdown"
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  margin: 0,
                  padding: 0,
                  listStyle: 'none',
                  background: '#fff',
                  border: '1px solid var(--border-color)',
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                  maxHeight: '220px',
                  overflowY: 'auto',
                  zIndex: 100
                }}
              >
                {INDIAN_STATES.filter(s =>
                  s.toLowerCase().includes((formData.state || '').toLowerCase())
                ).slice(0, 15).map(state => (
                  <li
                    key={state}
                    onClick={() => {
                      handleChange('state', state);
                      setStateDropdownOpen(false);
                      if (errors.state) setErrors(prev => ({ ...prev, state: null }));
                    }}
                    style={{
                      padding: '10px 12px',
                      cursor: 'pointer',
                      fontSize: '0.9rem',
                      borderBottom: '1px solid #f3f4f6'
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.background = '#f3f4f6'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = '#fff'; }}
                  >
                    {state}
                  </li>
                ))}
                {INDIAN_STATES.filter(s =>
                  s.toLowerCase().includes((formData.state || '').toLowerCase())
                ).length === 0 && (
                    <li style={{ padding: '10px 12px', color: '#6b7280', fontSize: '0.9rem' }}>
                      No matching state
                    </li>
                  )}
              </ul>
            )} */}
          </div>
          {errors.state && <span className="error-text">{errors.state}</span>}
        </div>

        <div className="form-group">
          <label>Additional Address <span className="required">*</span></label>
          <input
            type="text"
            placeholder="Enter additional address details"
            value={formData.fullAddress || ''}
            onChange={(e) => handleChange('fullAddress', e.target.value)}
            className={errors.fullAddress ? 'error' : ''}
          />
          {errors.fullAddress && <span className="error-text">{errors.fullAddress}</span>}
        </div>
      </div>

      <div className="form-group">
        <label>Pincode <span className="required">*</span></label>
        <input
          type="text"
          value={formData.pincode || ''}
          onChange={(e) => handleChange('pincode', e.target.value.replace(/\D/g, ''))}
          placeholder="Enter 6-digit pincode"
          maxLength={6}
          className={errors.pincode ? 'error' : ''}
        />
        {errors.pincode && <span className="error-text">{errors.pincode}</span>}
      </div>
    </div>
  );

  // Step 3: Configuration & Inventory — options and fields depend on project type
  const configurationOptions = formData.projectType
    ? (CONFIGURATION_BY_PROJECT_TYPE[formData.projectType] || [])
    : [];
  const pt = formData.projectType;
  const isPlotOrLand = pt === "Plot / Land / Indusrtial Property";
  const isWarehouse = pt === "Warehouse / Godown";
  const isCommercialOffice = pt === "Commercial Office";
  const isVilla = pt === "Villa / Banglow";
  const isIndependentHouse = pt === "Independent House";
  const isPGHostel = pt === "PG / Hostel";
  const isApartment = pt === "Apartment";
  // Area label by type — always include sq.ft so unit is clear in add/edit
  const areaLabel = isPlotOrLand
    ? "Plot Size Range (sq.ft)"
    : (isCommercialOffice || pt === "Commercial Shop")
      ? "Area Range (sq.ft)"
      : isWarehouse
        ? "Built-up Area Range (sq.ft)"
        : isPGHostel
          ? "Carpet Area Range (sq.ft)"
          : "Carpet Area Range (sq.ft)";
  const areaSuffix = "sq.ft";

  const renderStep3 = () => (
    <div className="step-content">
      <div style={{ marginBottom: '1.5rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border-color)' }}>
        <span style={{ fontSize: '0.85rem', color: 'var(--text-muted)', fontWeight: '500' }}>
          Step {currentStep} of {STEPS.length} — {STEPS[currentStep - 1].title}
        </span>
      </div>
      <h3 className="step-heading">Configuration</h3>
      <p className="step-subheading">
        {formData.projectType
          ? `Configurations for ${formData.projectType}`
          : "Select project type in Step 1 to see configuration options"}
      </p>

      <div className="form-group">
        <label>Property Configurations <span className="required">*</span></label>
        {configurationOptions.length > 0 ? (
          <>
            <div className={`amenities-grid ${errors.configurations ? 'error' : ''}`}>
              {configurationOptions.map(config => (
                <button
                  key={config}
                  type="button"
                  className={`amenity-btn ${formData.configurations.includes(config) ? 'active' : ''}`}
                  onClick={() => toggleConfiguration(config)}
                >
                  {config}
                </button>
              ))}
            </div>
            {errors.configurations && <span className="error-text">{errors.configurations}</span>}
          </>
        ) : (
          <p className="step-subheading" style={{ marginTop: '0.5rem', color: 'var(--text-muted)' }}>
            Please select a project type in Step 1 (Basic Details) first.
          </p>
        )}
      </div>

      <div className="form-group">
        <label>{areaLabel} <span className="required">*</span></label>
        <div className="input-with-suffix">
          <input
            type="text"
            value={formData.carpetAreaRange}
            onChange={(e) => handleCarpetAreaChange(e.target.value)}
            placeholder={isPlotOrLand ? "e.g., 500 - 2000" : "e.g., 650 - 1200"}
            className={errors.carpetAreaRange ? 'error' : ''}
          />
          <span className="suffix">{areaSuffix}</span>
        </div>
        {errors.carpetAreaRange && <span className="error-text">{errors.carpetAreaRange}</span>}
      </div>

      {/* Apartment: Number of Towers, Floors per tower, Units per floor (optional) */}
      {isApartment && (
        <>
          <div className="form-row">
            <div className="form-group">
              <label>Number of Towers</label>
              <input
                type="number"
                value={formData.numberOfTowers}
                onChange={(e) => handleChange('numberOfTowers', e.target.value)}
                placeholder="e.g., 3"
                min="1"
              />
            </div>
            <div className="form-group">
              <label>Number of Floors per Tower</label>
              <input
                type="number"
                value={formData.floorsCount}
                onChange={(e) => handleChange('floorsCount', e.target.value)}
                placeholder="e.g., 12"
                min="1"
              />
            </div>
          </div>
          <div className="form-group">
            <label>Units per floor</label>
            <input
              type="number"
              value={formData.unitsPerFloor}
              onChange={(e) => handleChange('unitsPerFloor', e.target.value)}
              placeholder="e.g., 4"
              min="1"
            />
          </div>
        </>
      )}

      {/* Villa: Number of Villas */}
      {isVilla && (
        <div className="form-group">
          <label>Number of Villas</label>
          <input
            type="number"
            value={formData.numberOfVillas}
            onChange={(e) => handleChange('numberOfVillas', e.target.value)}
            placeholder="e.g., 24"
            min="1"
          />
        </div>
      )}

      {/* Independent House: Total Units */}
      {isIndependentHouse && (
        <div className="form-group">
          <label>Total Units</label>
          <input
            type="number"
            value={formData.totalUnits}
            onChange={(e) => handleChange('totalUnits', e.target.value)}
            placeholder="e.g., 50"
            min="1"
          />
        </div>
      )}

      {/* Row House / Farm House: Total Units */}
      {pt === "Row House/ Farm House" && (
        <div className="form-group">
          <label>Total Units</label>
          <input
            type="number"
            value={formData.totalUnits}
            onChange={(e) => handleChange('totalUnits', e.target.value)}
            placeholder="e.g., 30"
            min="1"
          />
        </div>
      )}

      {/* Penthouse: Number of Towers + Floors per tower (optional for standalone) */}
      {pt === "Penthouse" && (
        <>
          <div className="form-group">
            <label>Number of Towers</label>
            <input
              type="number"
              value={formData.numberOfTowers}
              onChange={(e) => handleChange('numberOfTowers', e.target.value)}
              placeholder="e.g., 2"
              min="1"
            />
          </div>
          <div className="form-group">
            <label>Number of Floors per Tower</label>
            <input
              type="number"
              value={formData.floorsCount}
              onChange={(e) => handleChange('floorsCount', e.target.value)}
              placeholder="e.g., 20"
              min="1"
            />
          </div>
        </>
      )}

      {/* Studio Apartment: Number of Towers, Floors per tower, Units per floor (optional) */}
      {pt === "Studio Apartment" && (
        <>
          <div className="form-row">
            <div className="form-group">
              <label>Number of Towers</label>
              <input
                type="number"
                value={formData.numberOfTowers}
                onChange={(e) => handleChange('numberOfTowers', e.target.value)}
                placeholder="e.g., 1"
                min="1"
              />
            </div>
            <div className="form-group">
              <label>Number of Floors per Tower</label>
              <input
                type="number"
                value={formData.floorsCount}
                onChange={(e) => handleChange('floorsCount', e.target.value)}
                placeholder="e.g., 10"
                min="1"
              />
            </div>
          </div>
          <div className="form-group">
            <label>Units per floor (optional)</label>
            <input
              type="number"
              value={formData.unitsPerFloor}
              onChange={(e) => handleChange('unitsPerFloor', e.target.value)}
              placeholder="e.g., 8"
              min="1"
            />
          </div>
        </>
      )}

      {/* Plot / Land: Number of Plots — no towers */}
      {isPlotOrLand && (
        <div className="form-group">
          <label>Number of Plots</label>
          <input
            type="number"
            value={formData.numberOfPlots}
            onChange={(e) => handleChange('numberOfPlots', e.target.value)}
            placeholder="e.g., 100"
            min="1"
          />
        </div>
      )}

      {/* Commercial Office: Number of Towers + Floors per tower */}
      {isCommercialOffice && (
        <>
          <div className="form-group">
            <label>Number of Towers</label>
            <input
              type="number"
              value={formData.numberOfTowers}
              onChange={(e) => handleChange('numberOfTowers', e.target.value)}
              placeholder="e.g., 5"
              min="1"
            />
          </div>
          <div className="form-group">
            <label>Number of Floors per Tower</label>
            <input
              type="number"
              value={formData.floorsCount}
              onChange={(e) => handleChange('floorsCount', e.target.value)}
              placeholder="e.g., 12"
              min="1"
            />
          </div>
        </>
      )}

      {/* PG / Hostel: Bed Capacity — no towers */}
      {isPGHostel && (
        <div className="form-group">
          <label>Bed Capacity</label>
          <input
            type="number"
            value={formData.bedCapacity}
            onChange={(e) => handleChange('bedCapacity', e.target.value)}
            placeholder="e.g., 50"
            min="1"
          />
        </div>
      )}

      {/* Warehouse: Loading Docks (optional) */}
      {isWarehouse && (
        <div className="form-group">
          <label>Loading Docks (optional)</label>
          <input
            type="number"
            value={formData.loadingDocks}
            onChange={(e) => handleChange('loadingDocks', e.target.value)}
            placeholder="e.g., 4"
            min="0"
          />
        </div>
      )}
    </div>
  );

  // Step 4: Pricing & Amenities
  const renderStep4 = () => (
    <div className="step-content">
      <div style={{ marginBottom: '1.5rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border-color)' }}>
        <span style={{ fontSize: '0.85rem', color: 'var(--text-muted)', fontWeight: '500' }}>
          Step {currentStep} of {STEPS.length} — {STEPS[currentStep - 1].title}
        </span>
      </div>
      <h3 className="step-heading">Pricing & Amenities</h3>
      <p className="step-subheading">Set pricing details and select amenities for your project</p>

      <div className="form-group">
        <label>Starting Price <span className="required">*</span></label>
        <div className="price-input-wrapper">
          <span className="currency">₹</span>
          <input
            type="text"
            value={formData.startingPrice}
            onChange={(e) => handlePriceChange('startingPrice', e.target.value)}
            placeholder="e.g., 45 Lakh or 4500000 or 1.5 Cr"
            className={errors.startingPrice ? 'error' : ''}
          />
        </div>
        {formData.startingPrice && (
          <span className="price-words">
            Price: {formatPriceInWords(formData.startingPrice)}
          </span>
        )}
        {errors.startingPrice && <span className="error-text">{errors.startingPrice}</span>}
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Price per Sq.ft (Optional)</label>
          <div className="price-input-wrapper">
            <span className="currency">₹</span>
            <input
              type="text"
              value={formData.pricePerSqft}
              onChange={(e) => handlePriceChange('pricePerSqft', e.target.value)}
              placeholder="e.g., 5000 or 5000-6000"
            />
          </div>
          {formData.pricePerSqft && (
            <span className="price-words">
              Price: {formatPriceInWords(formData.pricePerSqft)}/sq.ft
            </span>
          )}
        </div>

        <div className="form-group">
          <label>Booking Amount Price (Optional)</label>
          <div className="price-input-wrapper">
            <span className="currency">₹</span>
            <input
              type="text"
              value={formData.bookingAmount}
              onChange={(e) => handlePriceChange('bookingAmount', e.target.value)}
              placeholder="e.g., 200000 or 1.5-2.5"
            />
          </div>
          {formData.bookingAmount && (
            <span className="price-words">
              Price: {formatPriceInWords(formData.bookingAmount)}
            </span>
          )}
        </div>
      </div>

      <div className={`form-row ${launchDatePickerOpen || possessionDatePickerOpen ? 'state-dropdown-row-active' : ''}`}>
        <div className={`form-group ${launchDatePickerOpen ? 'state-dropdown-open' : ''}`}>
          <label>Launch Date</label>
          <ModernDatePicker
            value={formData.expectedLaunchDate}
            onChange={(val) => handleChange('expectedLaunchDate', val)}
            placeholder="Select launch date"
            onOpenChange={setLaunchDatePickerOpen}
          />
        </div>

        <div className={`form-group ${possessionDatePickerOpen ? 'state-dropdown-open' : ''}`}>
          <label>Expected Possession Date</label>
          <ModernDatePicker
            value={formData.expectedPossessionDate}
            onChange={(val) => handleChange('expectedPossessionDate', val)}
            placeholder="Select possession date"
            onOpenChange={setPossessionDatePickerOpen}
          />
        </div>
      </div>

      <div className="form-group" style={{ marginTop: '2rem' }}>
        <label>Amenities <span className="required">*</span></label>
        <div className={`amenities-grid ${errors.amenities ? 'error' : ''}`}>
          {AMENITIES.map(amenity => (
            <button
              key={amenity.id}
              type="button"
              className={`amenity-btn ${formData.amenities.includes(amenity.id) ? 'active' : ''}`}
              onClick={() => toggleAmenity(amenity.id)}
            >
              <span className="amenity-icon">{amenity.icon}</span>
              <span className="amenity-label">{amenity.label}</span>
              {formData.amenities.includes(amenity.id) && (
                <span className="check-icon">✓</span>
              )}
            </button>
          ))}
        </div>
        {errors.amenities && <span className="error-text">{errors.amenities}</span>}
      </div>

      <div className="form-group" data-field="description">
        <div className="seller-popup-description-header">
          <label>Project Description <span className="required">*</span></label>
          <button
            type="button"
            className="generate-description-btn"
            onClick={handleGenerateDescription}
          >
            Generate description
          </button>
        </div>
        <textarea
          name="description"
          value={formData.description}
          onChange={(e) => handleChange('description', e.target.value)}
          placeholder="Describe your upcoming project in detail (minimum 100 characters). Mention configurations, location advantages, amenities, and possession timeline."
          rows={6}
          maxLength={1000}
          className={errors.description ? 'error' : ''}
        />
        <span className="char-count" style={{
          color: (formData.description || '').length < 100 ? '#dc2626' : 'inherit'
        }}>
          Characters: {(formData.description || '').length}/1000 (min: 100)
        </span>
        {errors.description && <span className="error-text">{errors.description}</span>}
      </div>
    </div>
  );

  // Step 5: Media & Contact
  const renderStep5 = () => (
    <div className="step-content">
      <div style={{ marginBottom: '1.5rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border-color)' }}>
        <span style={{ fontSize: '0.85rem', color: 'var(--text-muted)', fontWeight: '500' }}>
          Step {currentStep} of {STEPS.length} — {STEPS[currentStep - 1].title}
        </span>
      </div>
      <h3 className="step-heading">Media & Contact</h3>
      <p className="step-subheading">Upload project images and provide contact information</p>

      <div className="form-group">
        <label>Project Cover Image <span className="required">*</span></label>
        <input
          type="file"
          accept="image/*"
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) {
              const url = URL.createObjectURL(file);
              handleChange('coverImage', { file, url });
            }
          }}
        />
        {!formData.coverImage?.file && !formData.coverImage?.isExisting && (
          <div style={{
            marginTop: '8px',
            padding: '8px 12px',
            background: '#fef2f2',
            border: '1px solid #fecaca',
            borderRadius: '4px',
            color: '#991b1b',
            fontSize: '0.875rem'
          }}>
            Please add cover image first
          </div>
        )}
        {formData.coverImage && (
          <div style={{ marginTop: '10px' }}>
            <img src={formData.coverImage.url} alt="Cover" style={{ maxWidth: '200px', maxHeight: '200px', borderRadius: '8px' }} />
          </div>
        )}
        {errors.coverImage && <span className="error-text">{errors.coverImage}</span>}
      </div>

      <div className="form-group">
        <label>Project Images <span className="required">*</span> (Concept images / 3D renders allowed)</label>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
          <input
            ref={imagesRef}
            type="file"
            accept="image/*"
            multiple
            onChange={handleImageUpload}
            style={{ display: 'none' }}
            disabled={formData.projectImages?.length >= 20}
          />
          <button
            type="button"
            className="cancel-btn"
            onClick={() => imagesRef.current?.click()}
            disabled={formData.projectImages?.length >= 20}
            style={{
              background: formData.projectImages?.length >= 20 ? '#f3f4f6' : 'white',
              border: '2px solid var(--border-color)',
              cursor: formData.projectImages?.length >= 20 ? 'not-allowed' : 'pointer',
              opacity: formData.projectImages?.length >= 20 ? 0.6 : 1
            }}
          >
            📷 Upload Images (Max 20)
          </button>
          <span style={{
            fontSize: '0.875rem',
            color: formData.projectImages?.length < 3 ? '#dc2626' : '#059669',
            fontWeight: '500'
          }}>
            Images uploaded: {formData.projectImages?.length || 0} / 20
          </span>
        </div>
        {formData.projectImages?.length < 3 && (
          <div style={{
            marginBottom: '8px',
            padding: '8px 12px',
            // background: '#fef2f2',
            border: '1px solid #fecaca',
            borderRadius: '4px',
            color: '#991b1b',
            fontSize: '0.875rem'
          }}>
            ⚠️ Please upload at least 3 images to continue.
          </div>
        )}
        {errors.projectImages && <span className="error-text">{errors.projectImages}</span>}

        <div className="image-preview-grid" style={{ marginTop: '15px' }}>
          {formData.projectImages.map((img, idx) => {
            const validationStatus = imageValidationStatus[idx] || { status: 'pending', errorMessage: '' };

            return (
              <div key={idx} className={`preview-item image-validation-item ${validationStatus.status}`}>
                <img src={img} alt={`Project ${idx + 1}`} />

                {/* Validation Overlays */}
                {validationStatus.status === 'checking' && (
                  <div className="validation-overlay checking-overlay">
                    <div className="overlay-content">
                      <div className="spinner"></div>
                      <p className="status-message-text">Checking...</p>
                    </div>
                  </div>
                )}


{validationStatus.status === 'approved' && (
  <div className="validation-overlay approved-overlay" style={{ 
    background: 'transparent',
    pointerEvents: 'none'
  }}>
    <div className="overlay-content" style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center',
      background: 'rgba(0,0,0,0.6)',
      padding: '8px 12px',
      borderRadius: '8px',
      gap: '4px'
    }}>
      {/* <svg className="checkmark" width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ stroke: '#4CAF50' }}>
        <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg> */}
      <p className="approved-text" style={{ color: '#4CAF50', fontSize: '11px', fontWeight: '600', margin: 0 }}>Approved</p>
    </div>
  </div>
)}



                {/* {validationStatus.status === 'approved' && (
                  <div className="validation-overlay approved-overlay" style={{ 
                    background: 'transparent',
                    pointerEvents: 'none'
                  }}>
                    <div className="overlay-content">
                      <svg className="checkmark" width="32" height="32" viewBox="0 0 24 24" fill="none">
                        <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <p className="approved-text">Approved</p>
                    </div>
                  </div>
                )} */}

                {validationStatus.status === 'rejected' && (
                  <div className="validation-overlay rejected-overlay">
                    <div className="overlay-content">
                      <svg className="x-icon" width="32" height="32" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
                      </svg>
                      <p className="rejected-title">REJECTED</p>
                      <p className="rejected-message">{validationStatus.errorMessage || 'Image rejected'}</p>
                      <button
                        type="button"
                        className="remove-rejected-btn"
                        onClick={() => removeImage(idx)}
                      >
                        Remove & Try Again
                      </button>
                    </div>
                  </div>
                )}

                {validationStatus.status === 'approved' && (
                  <div className="status-badge approved-badge">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                )}

                {validationStatus.status === 'rejected' && (
                  <div className="status-badge rejected-badge">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                  </div>
                )}

            
                {validationStatus.status !== 'checking' && (
                  <button
                    type="button"
                    className="remove-image-btn"
                    onClick={() => removeImage(idx)}
                    title="Remove image"
                  >
                    ✕
                  </button>
                )}
              </div>
            );
          })}
        </div>

        {/* Warning if rejected images exist */}
        {imageValidationStatus.some(img => img.status === 'rejected') && (
          <div className="image-validation-warning">
            <strong>⚠️ Remove rejected images to continue</strong>
            <p style={{ margin: '4px 0 0 0', fontSize: '13px' }}>
              {imageValidationStatus.filter(img => img.status === 'rejected').length} image(s) were rejected.
              Please remove them and upload valid property images only.
            </p>
          </div>
        )}

        {/* Success message if all approved */}
        {imageValidationStatus.length > 0 &&
          imageValidationStatus.every(img => img.status === 'approved') &&
          !isCheckingImages && (
            <div className="image-validation-success" style={{
              background: '#e8f5e9',
              color: '#2e7d32',
              padding: '12px',
              borderRadius: '4px',
              marginTop: '16px',
              fontSize: '14px',
              border: '1px solid #4CAF50',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              <span>✅</span>
              <span>All images approved!</span>
            </div>
          )}
      </div>

      {/* <div className="form-group">
        <label>Brochure (PDF)</label>
        <input
          ref={brochureRef}
          type="file"
          accept=".pdf"
            onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) {
              const url = URL.createObjectURL(file);
              handleChange('brochure', { file, name: file.name, url, isExisting: false });
            }
          }}
          style={{ display: 'none' }}
        />
        <button
          type="button"
          className="cancel-btn"
          onClick={() => brochureRef.current?.click()}
          style={{ background: 'white', border: '2px solid var(--border-color)' }}
        >
          📑 Upload Brochure
        </button>
        {formData.brochure && (

          <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <span>📄 {formData.brochure.name}</span>
            <div style={{flexDirection:'row'}}>
            {formData.brochure.url && (
              <a
                href={formData.brochure.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontSize: '0.875rem', color: '#2563eb' }}
              >
                View PDF
              </a>
            )}
             <button
      type="button"
      onClick={() => {
        // Revoke blob URL to free memory
        if (formData.brochure.url && formData.brochure.url.startsWith('blob:')) {
          URL.revokeObjectURL(formData.brochure.url);
        }
        // Clear brochure data
        handleChange('brochure', null);
        // Reset file input
        if (brochureRef.current) {
          brochureRef.current.value = '';
        }
      }}
      style={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#dc2626',
        fontSize: '1.2rem',
        padding: '0 4px',
        marginLeft: '10px'
      }}
      title="Remove brochure"
    >
      ✕
    </button>

    </div>
            <button
              type="button"
              className="cancel-btn"
              onClick={() => brochureRef.current?.click()}
              style={{ background: 'white', border: '2px solid var(--border-color)', maxWidth: '200px' }}
            >
              Replace brochure
            </button>
          </div>
        )}
      </div> */}


<div className="form-group">
  <label>Brochure (PDF) - Multiple files allowed</label>
  <input
    ref={brochureRef}
    type="file"
    accept=".pdf,application/pdf"
    multiple
    onChange={(e) => {
      const files = Array.from(e.target.files || []);
      if (files.length > 0) {
        const oversized = files.filter((file) => file.size > MAX_BROCHURE_SIZE_BYTES);
        const validFiles = files.filter((file) => file.size <= MAX_BROCHURE_SIZE_BYTES);

        // Any file over 10 MB blocks project publish until a valid ≤10 MB upload replaces it
        if (oversized.length > 0) {
          setBrochureSizeExceeded(true);
          setErrors((prev) => ({
            ...prev,
            brochures: BROCHURE_SIZE_EXCEEDED_MSG,
          }));
          // Do not add any files from this selection (including valid ones mixed in)
        } else {
          setBrochureSizeExceeded(false);
          setErrors((prev) => {
            if (!prev.brochures && !prev.submit) return prev;
            const next = { ...prev };
            delete next.brochures;
            if (next.submit === BROCHURE_SIZE_EXCEEDED_MSG) {
              delete next.submit;
            }
            return next;
          });

          if (validFiles.length > 0) {
            const newBrochures = validFiles.map((file) => ({
              file,
              name: file.name,
              url: URL.createObjectURL(file),
              isExisting: false,
              id: Date.now() + Math.random().toString(36).substr(2, 9),
            }));
            const existingBrochures = formData.brochures || [];
            handleChange('brochures', [...existingBrochures, ...newBrochures]);
          }
        }
      }
      if (brochureRef.current) {
        brochureRef.current.value = '';
      }
    }}
    style={{ display: 'none' }}
  />
  <button
    type="button"
    className="cancel-btn"
    onClick={() => brochureRef.current?.click()}
    style={{ background: 'white', border: '2px solid var(--border-color)' }}
  >
    📑 Upload Brochures (Multiple)
  </button>
  <p
    style={{
      margin: '8px 0 0',
      fontSize: '0.85rem',
      color: (brochureSizeExceeded || errors.brochures) ? '#dc2626' : '#64748b',
    }}
  >
    {(brochureSizeExceeded || errors.brochures)
      ? BROCHURE_SIZE_EXCEEDED_MSG
      : BROCHURE_SIZE_HINT}
  </p>

  {/* Display multiple brochures */}
  {(formData.brochures && formData.brochures.length > 0) && (
    <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
      {formData.brochures.map((brochure, index) => (
        <div 
          key={brochure.id || index}
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between',
            padding: '8px 12px',
            border: '1px solid var(--border-color)',
            borderRadius: '6px',
            background: '#f9fafb'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
            <span style={{ fontSize: '0.9rem' }}>📄</span>
            <span style={{ fontSize: '0.9rem', fontWeight: '500' }}>{brochure.name}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {brochure.url && (
              <a
                href={resolvePropertyMediaUrl(brochure.url) || brochure.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontSize: '0.875rem', color: '#2563eb', textDecoration: 'none' }}
              >
                View PDF
              </a>
            )}
            <button
              type="button"
              onClick={() => {
                if (brochure.url && brochure.url.startsWith('blob:')) {
                  URL.revokeObjectURL(brochure.url);
                }
                const updatedBrochures = formData.brochures.filter((_, i) => i !== index);
                handleChange('brochures', updatedBrochures);
              }}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: '#dc2626',
                fontSize: '1.2rem',
                padding: '0 4px'
              }}
              title="Remove brochure"
            >
              ✕
            </button>
          </div>
        </div>
      ))}
    </div>
  )}
</div>




      {/* Contact Information Section */}
      <div className="form-group" style={{ marginTop: '2rem', paddingTop: '2rem', borderTop: '1px solid var(--border-color)' }}>
        <h3 className="step-heading" style={{ fontSize: '1.1rem', marginBottom: '1rem' }}>Contact Information</h3>
        <p className="step-subheading" style={{ fontSize: '0.9rem', marginBottom: '1.25rem' }}>How can buyers reach you? Add one or more sales person details.</p>

        {(formData.salesPersons || [{ name: '', number: '', email: '', landlineNumber: '', whatsappNumber: '', alternativeNumber: '' }]).map((sp, idx) => (
          <div key={idx} style={{ marginBottom: '1.5rem', padding: '1rem', border: '1px solid var(--border-color)', borderRadius: '8px', background: '#fafafa' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
              <span style={{ fontWeight: '600', fontSize: '0.9rem' }}>Sales Person {idx + 1}</span>
              {(formData.salesPersons || []).length > 1 && (
                <button
                  type="button"
                  onClick={() => removeSalesPerson(idx)}
                  style={{ padding: '4px 10px', fontSize: '0.8rem', background: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: '6px', cursor: 'pointer' }}
                >
                  Remove
                </button>
              )}
            </div>
            <div className="form-row two-cols">
              {/* <div className="form-group">
                <label>Name <span className="required">*</span></label>
                <input
                  type="text"
                  value={sp.name}
                  onChange={(e) => updateSalesPerson(idx, 'name', e.target.value.replace(/[^a-zA-Z\s]/g, ''))}
                  placeholder="Sales person name (letters only)"
                  className={errors[`salesPerson_name_${idx}`] ? 'error' : ''}
                />
                {errors[`salesPerson_name_${idx}`] && <span className="error-text">{errors[`salesPerson_name_${idx}`]}</span>}
              </div> */}

<div className="form-group">
  <label>Name <span className="required">*</span></label>
  <input
    type="text"
    value={sp.name.toUpperCase()}
    onChange={(e) => updateSalesPerson(idx, 'name', e.target.value.replace(/[^a-zA-Z\s]/g, '').toUpperCase())}
    placeholder="Sales person name"
    className={errors[`salesPerson_name_${idx}`] ? 'error' : ''}
    style={{ textTransform: 'uppercase' }}
  />
  {errors[`salesPerson_name_${idx}`] && <span className="error-text">{errors[`salesPerson_name_${idx}`]}</span>}
</div>


{/* 
              <div className="form-group">
                <label>Contact Number <span className="required">*</span></label>
                <input
                  type="tel"
                  value={sp.number}
                  onChange={(e) => updateSalesPerson(idx, 'number', e.target.value.replace(/\D/g, '').slice(0, 10))}
                  placeholder="10-digit mobile number"
                  maxLength={10}
                  className={errors[`salesPerson_number_${idx}`] ? 'error' : ''}
                />
                {errors[`salesPerson_number_${idx}`] && <span className="error-text">{errors[`salesPerson_number_${idx}`]}</span>}
              </div> */}

{/* <div className="form-group">
  <label>Contact Number <span className="required">*</span></label>
  <input
    type="tel"
    value={sp.number}
    onChange={(e) => {
      const rawValue = e.target.value.replace(/\D/g, '');
      if (rawValue.length <= 10) {
        updateSalesPerson(idx, 'number', rawValue);
      }
    }}
    onBlur={() => {
      const num = sp.number || '';
      const cleanNum = num.replace(/\D/g, '');
      
      // Check if empty
      if (cleanNum.length === 0) {
        setErrors(prev => ({ 
          ...prev, 
          [`salesPerson_number_${idx}`]: "Contact number is required (exactly 10 digits)" 
        }));
        return;
      }
      
      // Check if less than 10 digits
      if (cleanNum.length > 0 && cleanNum.length < 10) {
        setErrors(prev => ({ 
          ...prev, 
          [`salesPerson_number_${idx}`]: `Please add correct number - exactly 10 digits required (currently ${cleanNum.length})` 
        }));
        return;
      }
      
      // Check if more than 10 digits
      if (cleanNum.length > 10) {
        setErrors(prev => ({ 
          ...prev, 
          [`salesPerson_number_${idx}`]: "Contact number cannot exceed 10 digits" 
        }));
        return;
      }
      
      // Check if exactly 10 digits but invalid format
      if (cleanNum.length === 10 && !/^[6-9]\d{9}$/.test(cleanNum)) {
        setErrors(prev => ({ 
          ...prev, 
          [`salesPerson_number_${idx}`]: "Contact number must start with 6, 7, 8, or 9" 
        }));
        return;
      }
      
      // Valid - clear error
      if (cleanNum.length === 10 && /^[6-9]\d{9}$/.test(cleanNum)) {
        setErrors(prev => {
          const next = { ...prev };
          delete next[`salesPerson_number_${idx}`];
          return next;
        });
      }
    }}
    placeholder="10-digit mobile number"
    maxLength={10}
    className={errors[`salesPerson_number_${idx}`] ? 'error' : ''}
    style={{
      borderColor: errors[`salesPerson_number_${idx}`] ? '#dc2626' : 
                   (sp.number && sp.number.length === 10 && /^[6-9]\d{9}$/.test(sp.number) ? '#22c55e' : ''),
    }}
  />
  {errors[`salesPerson_number_${idx}`] && (
    <span className="error-text" style={{ color: '#dc2626', fontSize: '0.875rem', marginTop: '4px', display: 'block' }}>
      {errors[`salesPerson_number_${idx}`]}
    </span>
  )}
  {sp.number && sp.number.length > 0 && sp.number.length < 10 && !errors[`salesPerson_number_${idx}`] && (
    <span style={{ color: '#f59e0b', fontSize: '0.75rem', marginTop: '2px', display: 'block' }}>
      ⚠️ {sp.number.length}/10 digits
    </span>
  )}
  {sp.number && sp.number.length === 10 && /^[6-9]\d{9}$/.test(sp.number) && !errors[`salesPerson_number_${idx}`] && (
    <span style={{ color: '#22c55e', fontSize: '0.75rem', marginTop: '2px', display: 'block' }}>
      ✅ Valid number
    </span>
  )}
</div> */}


<div className="form-group">
  <label>Contact Number <span className="required">*</span></label>
  <input
    type="tel"
    value={sp.number}
    onChange={(e) => {
      const rawValue = e.target.value.replace(/\D/g, '');
      if (rawValue.length <= 10) {
        updateSalesPerson(idx, 'number', rawValue);
      }
    }}
    onBlur={() => {
      const num = sp.number || '';
      const cleanNum = num.replace(/\D/g, '');
      
      // Check if empty
      if (cleanNum.length === 0) {
        setErrors(prev => ({ 
          ...prev, 
          [`salesPerson_number_${idx}`]: "Contact number is required (exactly 10 digits)" 
        }));
        return;
      }
      
      // Check if less than 10 digits
      if (cleanNum.length > 0 && cleanNum.length < 10) {
        setErrors(prev => ({ 
          ...prev, 
          [`salesPerson_number_${idx}`]: `Please add correct number - exactly 10 digits required (currently ${cleanNum.length})` 
        }));
        return;
      }
      
      // Check if more than 10 digits
      if (cleanNum.length > 10) {
        setErrors(prev => ({ 
          ...prev, 
          [`salesPerson_number_${idx}`]: "Contact number cannot exceed 10 digits" 
        }));
        return;
      }
      
      // Check if exactly 10 digits but invalid format
      if (cleanNum.length === 10 && !/^[6-9]\d{9}$/.test(cleanNum)) {
        setErrors(prev => ({ 
          ...prev, 
          [`salesPerson_number_${idx}`]: "Contact number must start with 6, 7, 8, or 9" 
        }));
        return;
      }
      
      // Valid - clear error
      if (cleanNum.length === 10 && /^[6-9]\d{9}$/.test(cleanNum)) {
        setErrors(prev => {
          const next = { ...prev };
          delete next[`salesPerson_number_${idx}`];
          return next;
        });
      }
    }}
    placeholder="10-digit mobile number"
    maxLength={10}
    className={errors[`salesPerson_number_${idx}`] ? 'error' : ''}
    style={{
      borderColor: errors[`salesPerson_number_${idx}`] ? '#dc2626' : 
                   (sp.number && sp.number.length === 10 && /^[6-9]\d{9}$/.test(sp.number) ? '#22c55e' : ''),
    }}
  />
  {errors[`salesPerson_number_${idx}`] && (
    <span className="error-text" style={{ color: '#dc2626', fontSize: '0.875rem', marginTop: '4px', display: 'block' }}>
      {errors[`salesPerson_number_${idx}`]}
    </span>
  )}
  {sp.number && sp.number.length > 0 && sp.number.length < 10 && !errors[`salesPerson_number_${idx}`] && (
    <span style={{ color: '#f59e0b', fontSize: '0.75rem', marginTop: '2px', display: 'block' }}>
      ⚠️ {sp.number.length}/10 digits
    </span>
  )}
  {sp.number && sp.number.length === 10 && /^[6-9]\d{9}$/.test(sp.number) && !errors[`salesPerson_number_${idx}`] && (
    <span style={{ color: '#22c55e', fontSize: '0.75rem', marginTop: '2px', display: 'block' }}>
      ✅ Valid number
    </span>
  )}
</div>


            </div>
            {/* <div className="form-group">
              <label>Email ID <span className="required">*</span></label>
              <input
                type="email"
                value={sp.email}
                onChange={(e) => updateSalesPerson(idx, 'email', e.target.value)}
                placeholder="Email address"
                className={errors[`salesPerson_email_${idx}`] ? 'error' : ''}
              />
              {errors[`salesPerson_email_${idx}`] && <span className="error-text">{errors[`salesPerson_email_${idx}`]}</span>}
            </div> */}


{/* <div className="form-group">
  <label>Email ID <span className="required">*</span></label>
  <input
    type="email"
    value={sp.email}
    onChange={(e) => {
      const value = e.target.value;
      updateSalesPerson(idx, 'email', value);
    }}
    onBlur={() => {
      const email = sp.email || '';
      const trimmedEmail = email.trim();
      
      // Check if empty
      if (trimmedEmail.length === 0) {
        setErrors(prev => ({ 
          ...prev, 
          [`salesPerson_email_${idx}`]: "Email ID is required" 
        }));
        return;
      }
      
      // Validate email format
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(trimmedEmail)) {
        setErrors(prev => ({ 
          ...prev, 
          [`salesPerson_email_${idx}`]: "Please enter a valid email address (e.g., name@domain.com)" 
        }));
        return;
      }
      
      // Valid - clear error
      setErrors(prev => {
        const next = { ...prev };
        delete next[`salesPerson_email_${idx}`];
        return next;
      });
    }}
    placeholder="Email address"
    className={errors[`salesPerson_email_${idx}`] ? 'error' : ''}
    style={{
      borderColor: errors[`salesPerson_email_${idx}`] ? '#dc2626' : 
                   (sp.email && /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(sp.email.trim()) ? '#22c55e' : ''),
    }}
  />
  {errors[`salesPerson_email_${idx}`] && (
    <span className="error-text" style={{ color: '#dc2626', fontSize: '0.875rem', marginTop: '4px', display: 'block' }}>
      {errors[`salesPerson_email_${idx}`]}
    </span>
  )}
  {sp.email && sp.email.trim().length > 0 && !errors[`salesPerson_email_${idx}`] && /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(sp.email.trim()) && (
    <span style={{ color: '#22c55e', fontSize: '0.75rem', marginTop: '2px', display: 'block' }}>
      ✅ Valid email address
    </span>
  )}
</div> */}

<div className="form-group">
  <label>Email ID <span className="required">*</span></label>
  <input
    type="email"
    value={sp.email}
    onChange={(e) => {
      const value = e.target.value;
      updateSalesPerson(idx, 'email', value);
    }}
    onBlur={(e) => {
      const emailError = getSalesPersonEmailError(e.target.value);
      if (emailError) {
        setErrors(prev => ({ 
          ...prev, 
          [`salesPerson_email_${idx}`]: emailError 
        }));
        return;
      }
      
      // Valid - clear error
      setErrors(prev => {
        const next = { ...prev };
        delete next[`salesPerson_email_${idx}`];
        return next;
      });
    }}
    placeholder="Email address"
    className={errors[`salesPerson_email_${idx}`] ? 'error' : ''}
    style={{
      borderColor: errors[`salesPerson_email_${idx}`] ? '#dc2626' : 
                   (sp.email && isValidSalesPersonEmail(sp.email) ? '#22c55e' : ''),
    }}
  />
  {errors[`salesPerson_email_${idx}`] && (
    <span className="error-text" style={{ color: '#dc2626', fontSize: '0.875rem', marginTop: '4px', display: 'block' }}>
      {errors[`salesPerson_email_${idx}`]}
    </span>
  )}
  {sp.email && sp.email.trim().length > 0 && !errors[`salesPerson_email_${idx}`] && isValidSalesPersonEmail(sp.email) && (
    <span style={{ color: '#22c55e', fontSize: '0.75rem', marginTop: '2px', display: 'block' }}>
      ✅ Valid email address
    </span>
  )}
</div>

{/* 
            <div className="form-group">
              <label>Landline Number (Optional)</label>
              <input
                type="tel"
                value={sp.landlineNumber ?? ''}
                onChange={(e) => updateSalesPerson(idx, 'landlineNumber', e.target.value.replace(/[^\d\s\-]/g, ''))}
                placeholder="e.g. 020-12345678 or 0123-1234567"
                maxLength={15}
              />
            </div> */}

<div className="form-group">
  <label>Landline Number (Optional)</label>
  <input
    type="tel"
    value={sp.landlineNumber ?? ''}
    onChange={(e) => {
      const rawValue = e.target.value.replace(/[^\d\s\-]/g, '');
      if (rawValue.length <= 15) {
        updateSalesPerson(idx, 'landlineNumber', rawValue);
      }
    }}
    onBlur={() => {
      const landline = sp.landlineNumber || '';
      const cleanLandline = landline.replace(/\D/g, '');
      
      // Only validate if user entered something
      if (cleanLandline.length > 0) {
        if (cleanLandline.length < 10) {
          setErrors(prev => ({ 
            ...prev, 
            [`salesPerson_landlineNumber_${idx}`]: "Landline number must have at least 10 digits" 
          }));
        } else if (cleanLandline.length > 15) {
          setErrors(prev => ({ 
            ...prev, 
            [`salesPerson_landlineNumber_${idx}`]: "Landline number cannot exceed 15 digits" 
          }));
        } else {
          // Valid - clear error
          setErrors(prev => {
            const next = { ...prev };
            delete next[`salesPerson_landlineNumber_${idx}`];
            return next;
          });
        }
      } else {
        // Clear error if empty (optional field)
        setErrors(prev => {
          const next = { ...prev };
          delete next[`salesPerson_landlineNumber_${idx}`];
          return next;
        });
      }
    }}
    placeholder="e.g. 020-12345678 or 0123-1234567"
    maxLength={15}
    className={errors[`salesPerson_landlineNumber_${idx}`] ? 'error' : ''}
    style={{
      borderColor: errors[`salesPerson_landlineNumber_${idx}`] ? '#dc2626' : 
                   (sp.landlineNumber && sp.landlineNumber.replace(/\D/g, '').length >= 10 && 
                    sp.landlineNumber.replace(/\D/g, '').length <= 15 ? '#22c55e' : ''),
    }}
  />
  {errors[`salesPerson_landlineNumber_${idx}`] && (
    <span className="error-text" style={{ color: '#dc2626', fontSize: '0.875rem', marginTop: '4px', display: 'block' }}>
      {errors[`salesPerson_landlineNumber_${idx}`]}
    </span>
  )}
  {sp.landlineNumber && sp.landlineNumber.replace(/\D/g, '').length >= 10 && 
   sp.landlineNumber.replace(/\D/g, '').length <= 15 && 
   !errors[`salesPerson_landlineNumber_${idx}`] && (
    <span style={{ color: '#22c55e', fontSize: '0.75rem', marginTop: '2px', display: 'block' }}>
      ✅ Valid landline number
    </span>
  )}
</div>


            <div className="form-row two-cols">
              {/* <div className="form-group">
                <label>WhatsApp Number (Optional)</label>
                <input
                  type="tel"
                  value={sp.whatsappNumber ?? ''}
                  onChange={(e) => updateSalesPerson(idx, 'whatsappNumber', e.target.value.replace(/\D/g, '').slice(0, 10))}
                  placeholder="10-digit Mobile number"
                  maxLength={10}
                />
              </div> */}

<div className="form-group">
  <label>WhatsApp Number (Optional)</label>
  <input
    type="tel"
    value={sp.whatsappNumber ?? ''}
    onChange={(e) => {
      const rawValue = e.target.value.replace(/\D/g, '');
      if (rawValue.length <= 10) {
        updateSalesPerson(idx, 'whatsappNumber', rawValue);
      }
    }}
    onBlur={() => {
      const whatsapp = sp.whatsappNumber || '';
      const cleanWhatsapp = whatsapp.replace(/\D/g, '');
      
      // Only validate if user entered something
      if (cleanWhatsapp.length > 0) {
        if (cleanWhatsapp.length < 10) {
          setErrors(prev => ({ 
            ...prev, 
            [`salesPerson_whatsappNumber_${idx}`]: "WhatsApp number must be exactly 10 digits" 
          }));
        } else if (cleanWhatsapp.length > 10) {
          setErrors(prev => ({ 
            ...prev, 
            [`salesPerson_whatsappNumber_${idx}`]: "WhatsApp number cannot exceed 10 digits" 
          }));
        } else if (cleanWhatsapp.length === 10 && !/^[6-9]\d{9}$/.test(cleanWhatsapp)) {
          setErrors(prev => ({ 
            ...prev, 
            [`salesPerson_whatsappNumber_${idx}`]: "WhatsApp number must start with 6, 7, 8, or 9" 
          }));
        } else {
          // Valid - clear error
          setErrors(prev => {
            const next = { ...prev };
            delete next[`salesPerson_whatsappNumber_${idx}`];
            return next;
          });
        }
      } else {
        // Clear error if empty (optional field)
        setErrors(prev => {
          const next = { ...prev };
          delete next[`salesPerson_whatsappNumber_${idx}`];
          return next;
        });
      }
    }}
    placeholder="10-digit Mobile number"
    maxLength={10}
    className={errors[`salesPerson_whatsappNumber_${idx}`] ? 'error' : ''}
    style={{
      borderColor: errors[`salesPerson_whatsappNumber_${idx}`] ? '#dc2626' : 
                   (sp.whatsappNumber && sp.whatsappNumber.length === 10 && /^[6-9]\d{9}$/.test(sp.whatsappNumber) ? '#22c55e' : ''),
    }}
  />
  {errors[`salesPerson_whatsappNumber_${idx}`] && (
    <span className="error-text" style={{ color: '#dc2626', fontSize: '0.875rem', marginTop: '4px', display: 'block' }}>
      {errors[`salesPerson_whatsappNumber_${idx}`]}
    </span>
  )}
  {sp.whatsappNumber && sp.whatsappNumber.length > 0 && sp.whatsappNumber.length < 10 && !errors[`salesPerson_whatsappNumber_${idx}`] && (
    <span style={{ color: '#f59e0b', fontSize: '0.75rem', marginTop: '2px', display: 'block' }}>
      ⚠️ {sp.whatsappNumber.length}/10 digits
    </span>
  )}
  {sp.whatsappNumber && sp.whatsappNumber.length === 10 && /^[6-9]\d{9}$/.test(sp.whatsappNumber) && !errors[`salesPerson_whatsappNumber_${idx}`] && (
    <span style={{ color: '#22c55e', fontSize: '0.75rem', marginTop: '2px', display: 'block' }}>
      ✅ Valid WhatsApp number
    </span>
  )}
</div>


              {/* <div className="form-group">
                <label>Alternative Number (Optional)</label>
                <input
                  type="tel"
                  value={sp.alternativeNumber ?? ''}
                  onChange={(e) => updateSalesPerson(idx, 'alternativeNumber', e.target.value.replace(/\D/g, '').slice(0, 10))}
                  placeholder="10-digit mobile number"
                  maxLength={10}
                />
              </div> */}

<div className="form-group">
  <label>Alternative Number (Optional)</label>
  <input
    type="tel"
    value={sp.alternativeNumber ?? ''}
    onChange={(e) => {
      const rawValue = e.target.value.replace(/\D/g, '');
      if (rawValue.length <= 10) {
        updateSalesPerson(idx, 'alternativeNumber', rawValue);
      }
    }}
    onBlur={() => {
      const alternative = sp.alternativeNumber || '';
      const cleanAlternative = alternative.replace(/\D/g, '');
      
      // Only validate if user entered something
      if (cleanAlternative.length > 0) {
        if (cleanAlternative.length < 10) {
          setErrors(prev => ({ 
            ...prev, 
            [`salesPerson_alternativeNumber_${idx}`]: "Alternative number must be exactly 10 digits" 
          }));
        } else if (cleanAlternative.length > 10) {
          setErrors(prev => ({ 
            ...prev, 
            [`salesPerson_alternativeNumber_${idx}`]: "Alternative number cannot exceed 10 digits" 
          }));
        } else if (cleanAlternative.length === 10 && !/^[6-9]\d{9}$/.test(cleanAlternative)) {
          setErrors(prev => ({ 
            ...prev, 
            [`salesPerson_alternativeNumber_${idx}`]: "Alternative number must start with 6, 7, 8, or 9" 
          }));
        } else {
          // Valid - clear error
          setErrors(prev => {
            const next = { ...prev };
            delete next[`salesPerson_alternativeNumber_${idx}`];
            return next;
          });
        }
      } else {
        // Clear error if empty (optional field)
        setErrors(prev => {
          const next = { ...prev };
          delete next[`salesPerson_alternativeNumber_${idx}`];
          return next;
        });
      }
    }}
    placeholder="10-digit mobile number"
    maxLength={10}
    className={errors[`salesPerson_alternativeNumber_${idx}`] ? 'error' : ''}
    style={{
      borderColor: errors[`salesPerson_alternativeNumber_${idx}`] ? '#dc2626' : 
                   (sp.alternativeNumber && sp.alternativeNumber.length === 10 && /^[6-9]\d{9}$/.test(sp.alternativeNumber) ? '#22c55e' : ''),
    }}
  />
  {errors[`salesPerson_alternativeNumber_${idx}`] && (
    <span className="error-text" style={{ color: '#dc2626', fontSize: '0.875rem', marginTop: '4px', display: 'block' }}>
      {errors[`salesPerson_alternativeNumber_${idx}`]}
    </span>
  )}
  {sp.alternativeNumber && sp.alternativeNumber.length > 0 && sp.alternativeNumber.length < 10 && !errors[`salesPerson_alternativeNumber_${idx}`] && (
    <span style={{ color: '#f59e0b', fontSize: '0.75rem', marginTop: '2px', display: 'block' }}>
      ⚠️ {sp.alternativeNumber.length}/10 digits
    </span>
  )}
  {sp.alternativeNumber && sp.alternativeNumber.length === 10 && /^[6-9]\d{9}$/.test(sp.alternativeNumber) && !errors[`salesPerson_alternativeNumber_${idx}`] && (
    <span style={{ color: '#22c55e', fontSize: '0.75rem', marginTop: '2px', display: 'block' }}>
      ✅ Valid alternative number
    </span>
  )}
</div>



            </div>
          </div>
        ))}

        {(formData.salesPersons || []).length < 5 && (
          <button
            type="button"
            onClick={addSalesPerson}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '10px 16px',
              marginBottom: '1.25rem',
              background: 'white',
              border: '2px dashed var(--border-color)',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '0.9rem',
              fontWeight: '600',
              color: 'var(--accent-color, #7c3aed)'
            }}
          >
            <span>+ Add another sales person</span>
          </button>
        )}
      </div>
    </div>
  );

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1: return renderStep1();
      case 2: return renderStep2();
      case 3: return renderStep3();
      case 4: return renderStep4();
      case 5: return renderStep5();
      default: return renderStep1();
    }
  };

  return (
    <>
      {/* Close Warning Modal - Show when trying to close on final step without publishing */}
      {showCloseWarning && (
        <div className="popup-overlay" style={{ zIndex: 10000 }}>
          <div className="popup-container" style={{ maxWidth: '500px' }}>
            <div className="popup-header">
              <h2>Publishing Not Completed</h2>
              <button
                className="close-btn"
                onClick={() => setShowCloseWarning(false)}
                aria-label="Close"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </button>
            </div>
            <div className="popup-body" style={{ padding: '2rem' }}>
              <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" style={{ margin: '0 auto 1rem', color: 'var(--warning-color, #f59e0b)' }}>
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                  <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
                <p style={{ fontSize: '1rem', lineHeight: '1.6', color: 'var(--text-color, #333)' }}>
                  You haven't published this project yet.
                  <br />
                  Please publish before closing, or your data will be lost.
                </p>
              </div>
            </div>
            <div className="popup-footer" style={{ justifyContent: 'center', gap: '1rem' }}>
              <button
                type="button"
                className="cancel-btn"
                onClick={() => setShowCloseWarning(false)}
              >
                Continue Editing
              </button>

            </div>
          </div>
        </div>
      )}

      {/* Main Popup Overlay - Only show if close warning not shown */}
      {!showCloseWarning && (
        <div className="popup-overlay">
          <div className="popup-container" onClick={(e) => e.stopPropagation()}>
            {/* Header */}
            <div className="popup-header">
              <h2>{isEditMode ? 'Edit Upcoming Project' : 'Add Upcoming Project'}</h2>
              <button className="close-btn" onClick={handleCloseAttempt}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </button>
            </div>

            {/* Step Indicator */}
            {renderStepIndicator()}

            {/* Body */}
            <div className="popup-body" ref={popupBodyRef}>
              {renderCurrentStep()}
            </div>

            {/* Footer */}
            <div className="popup-footer">
              {currentStep > 1 && (
                <button type="button" className="back-btn" onClick={handleBack}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M19 12H5M12 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                  Back
                </button>
              )}

              <div className="footer-right">
                <button type="button" className="cancel-btn" onClick={handleCloseAttempt}>
                  Cancel
                </button>

                {currentStep < 5 ? (
                  <button type="button" className="next-btn" onClick={handleNext}>
                    Next
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                  </button>
                ) : (
                  <button
                    type="button"
                    className="submit-btn"
                    onClick={handleSubmit}
                    disabled={
                      isSubmitting
                      || isDiscarded
                      || (!formData.coverImage?.file && !formData.coverImage?.isExisting)
                      || (formData.projectImages?.length || 0) < 3
                      || (formData.projectImages?.length || 0) > 20
                    }
                    style={{
                      opacity: (
                        isSubmitting
                        || isDiscarded
                        || (!formData.coverImage?.file && !formData.coverImage?.isExisting)
                        || (formData.projectImages?.length || 0) < 3
                        || (formData.projectImages?.length || 0) > 20
                      ) ? 0.6 : 1,
                      cursor: (
                        isSubmitting
                        || isDiscarded
                        || (!formData.coverImage?.file && !formData.coverImage?.isExisting)
                        || (formData.projectImages?.length || 0) < 3
                        || (formData.projectImages?.length || 0) > 20
                      ) ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="spinner"></span>
                        Submitting...
                      </>
                    ) : (
                      <>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                          <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                        Publish Project
                      </>
                    )}
                  </button>

//                   <button
//   type="button"
//   className="submit-btn"
//   onClick={handleSubmit}
//   disabled={
//     isSubmitting
//     || isDiscarded
//     || (!formData.coverImage?.file && !formData.coverImage?.isExisting)
//     || (formData.projectImages?.length || 0) < 3
//     || (formData.projectImages?.length || 0) > 20
//     || Object.keys(errors).some(key => key.startsWith('salesPerson_number_'))
//     || (formData.salesPersons || []).some(sp => {
//       const num = (sp.number || '').replace(/\D/g, '');
//       return num.length > 0 && num.length !== 10;
//     })
//   }
//   style={{
//     opacity: (
//       isSubmitting
//       || isDiscarded
//       || (!formData.coverImage?.file && !formData.coverImage?.isExisting)
//       || (formData.projectImages?.length || 0) < 3
//       || (formData.projectImages?.length || 0) > 20
//       || Object.keys(errors).some(key => key.startsWith('salesPerson_number_'))
//       || (formData.salesPersons || []).some(sp => {
//         const num = (sp.number || '').replace(/\D/g, '');
//         return num.length > 0 && num.length !== 10;
//       })
//     ) ? 0.6 : 1,
//     cursor: (
//       isSubmitting
//       || isDiscarded
//       || (!formData.coverImage?.file && !formData.coverImage?.isExisting)
//       || (formData.projectImages?.length || 0) < 3
//       || (formData.projectImages?.length || 0) > 20
//       || Object.keys(errors).some(key => key.startsWith('salesPerson_number_'))
//       || (formData.salesPersons || []).some(sp => {
//         const num = (sp.number || '').replace(/\D/g, '');
//         return num.length > 0 && num.length !== 10;
//       })
//     ) ? 'not-allowed' : 'pointer'
//   }}
// ></button>

                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Location Picker Modal */}
      {/* {showLocationPicker && (
        <div className="location-picker-modal-overlay" onClick={(e) => {
          if (e.target.classList.contains('location-picker-modal-overlay')) {
            setShowLocationPicker(false);
          }
        }}>
          <LocationPicker
            initialLocation={
              formData.latitude && formData.longitude
                ? {
                    latitude: parseFloat(formData.latitude),
                    longitude: parseFloat(formData.longitude),
                    fullAddress: formData.location || formData.fullAddress
                  }
                : mapCenterFromAddress
                  ? {
                      latitude: mapCenterFromAddress.lat,
                      longitude: mapCenterFromAddress.lng,
                      fullAddress: formData.location || formData.area || ''
                    }
                  : null
            }
            defaultCenter={formData.latitude && formData.longitude ? undefined : (mapCenterFromAddress ? [mapCenterFromAddress.lng, mapCenterFromAddress.lat] : undefined)}
            defaultZoom={formData.latitude && formData.longitude ? undefined : (mapCenterFromAddress ? 14 : undefined)}
            onLocationChange={handleLocationSelect}
            onClose={() => setShowLocationPicker(false)}
          />
        </div>
      )} */}

{/* Location Picker Modal */}
{showLocationPicker && (
  <div 
    className="location-picker-modal-overlay" 
    onClick={(e) => {
      if (e.target === e.currentTarget) {
        setShowLocationPicker(false);
      }
    }}
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 99999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}
  >
    <div style={{
      background: 'white',
      borderRadius: '12px',
      maxWidth: '90vw',
      maxHeight: '90vh',
      overflow: 'auto',
      position: 'relative',
      zIndex: 100000
    }}>
      <LocationPicker
        initialLocation={
          formData.latitude && formData.longitude
            ? {
                latitude: parseFloat(formData.latitude),
                longitude: parseFloat(formData.longitude),
                fullAddress: formData.location || formData.fullAddress
              }
            : mapCenterFromAddress
              ? {
                  latitude: mapCenterFromAddress.lat,
                  longitude: mapCenterFromAddress.lng,
                  fullAddress: formData.location || formData.area || ''
                }
              : null
        }
        defaultCenter={formData.latitude && formData.longitude ? undefined : (mapCenterFromAddress ? [mapCenterFromAddress.lng, mapCenterFromAddress.lat] : undefined)}
        defaultZoom={formData.latitude && formData.longitude ? undefined : (mapCenterFromAddress ? 14 : undefined)}
        onLocationChange={handleLocationSelect}
        onClose={() => setShowLocationPicker(false)}
      />
    </div>
  </div>
)}

    </>
  );
}
